import * as Card from "../public/icons/card.svg";
import * as Label from "../public/icons/label.svg";
import * as Photo from "../public/icons/photo.svg";
import * as FullScreen from "../public/icons/organigram-fullscreen.svg";
import * as Download from "../public/icons/organigram-download.svg";
import * as Comment from "../public/icons/organigram-comment.svg";
import { socket } from "./feathers-socketio.js";
import Utils from "./utility.js";

const AIGenerateIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiIGZpbGw9IiM2YjcyODciPjxwYXRoIGQ9Ik00MDAtMTIwdi04MGgtODB2LTgwaDgwdi04MGg4MHY4MGg4MHY4MGgtODB2ODBoLTgwWm0xMjAtMjQwLTgwLTE2MC0xNjAtODAgMTYwLTgwIDgwLTE2MCA4MCAxNjAgMTYwIDgwLTE2MCA4MC04MCAxNjBaTTEyMC02ODBsLTQwLTgwLTgwLTQwIDgwLTQwIDQwLTgwIDQwIDgwIDgwIDQwLTgwIDQwLTQwIDgwWiIvPjwvc3ZnPg==";

const OrangeSpinnerIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmZjk4MDAiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj48cGF0aCBkPSJNMjEgMTJhOSA5IDAgMSAxLTYuMjE5LTguNTYiLz48L3N2Zz4=";

const API_BASE_URL = process.env.VUE_APP_API_URL || "http://127.0.0.1:8000";
const _totalEvaluation = {
    _total : 0,
    get total(){
        return this._total;
    },
    set total(val){
        this._total = val;
    }
}
const _calculateEvaluation = {
    _total : 0,
    get total(){
        return this._total;
    },
    set total(val){
        this._total = val;
    }
}
const isViewportActive = {
    isActive : true,
    get status(){
        return this.isActive;
    },
    set status(value){
        this.isActive = value;
    }
}

// Helper function to safely get graphData as array
const safeGraphData = (config) => {
    const graphData = config?.data?.graphData;
    return Array.isArray(graphData) ? graphData : [];
};

export class OrganiGram {
    constructor(e, t, vueInstance = null) { // <<< ADD 'vueInstance = null' HERE
        this.vueInstance = vueInstance;      // <<< ADD THIS LINE
        this.counter = 0;
        this.activeAiTasks = new Map();
        this.translate = (key, defaultText = "") => {
            // Check if Vue instance and $t exist
            if (this.vueInstance && typeof this.vueInstance.$t === 'function') {
                const translated = this.vueInstance.$t(key);
                // If it successfully translated (not undefined, and not just the key)
                if (translated && translated !== key) {
                    return translated;
                }
            }
            // If it fails, ALWAYS return the default text so we never see 'undefined'
            return defaultText; 
        };

        // --- 1. DEFINE THE FUNCTION FIRST ---
        const injectStyles = (styleId, css) => {
            if (document.getElementById(styleId)) {
                return; 
            }
            const styleSheet = document.createElement("style");
            styleSheet.id = styleId; 
            styleSheet.innerText = css;
            document.head.appendChild(styleSheet);
        };

        // --- 2. DEFINE THE CSS STRINGS ---
        const aiLoaderCSS = `
            @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
            .ai-icon-loading {
                animation: spin 1s linear infinite;
            }
        `;

        const hoverStyles = `
            .node-action-icon {
                opacity: 0;
                visibility: hidden; 
                transition: all 0.2s ease-in-out;
            }
            .node-hover-target:hover .node-action-icon {
                opacity: 1;
                visibility: visible;
            }
            /* Make the role cards behave like buttons */
            .node-hover-target, 
            .node-hover-target *, 
            .userCard, 
            .userCard label, 
            .userCard span, 
            .userCard i {
                cursor: pointer !important;
            }
            .node-hover-target {
                transition: transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.2s ease !important;
            }
            .node-hover-target:hover {
                transform: scale(1.03);
                box-shadow: 0 8px 25px rgba(0,0,0,0.15) !important;
                z-index: 10;
            }
            .node-hover-target:active {
                transform: scale(0.98);
            }
        `;
        
        const dndStyles = `
            .is-dragging {
                opacity: 0.4;
                border: 2px dashed #999 !important;
            }
            .drag-over-active {
                background-color: #e6fffa !important;
                box-shadow: 0 0 15px rgba(0, 200, 0, 0.5) !important;
                transform: scale(1.05);
                border: 2px solid #00b894 !important;
                z-index: 100;
                transition: all 0.2s ease;
            }
        `;

        const fullscreenFixStyles = `
            *:fullscreen > .chartCanvasContainer {
                height: 100% !important;
                min-height: 100% !important;
            }
            /* Aggressively force the fullscreen button size, overriding Vue inline styles */
            #toggle-full-screen {
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                width: 32px !important;
                height: 32px !important;
                padding: 0 !important;
                margin: 0 !important;
                background: transparent !important;
                border: none !important;
                border-radius: 50% !important;
                cursor: pointer !important;
                transition: background 0.2s ease !important;
            }
            #toggle-full-screen:hover {
                background-color: #F9FAFB !important;
            }
            /* Force the inner image/SVG to be 16px (smaller) */
            #toggle-full-screen img, 
            #toggle-full-screen svg, 
            #toggle-full-screen i {
                width: 16px !important;
                height: 16px !important;
                max-width: 16px !important;
                max-height: 16px !important;
                object-fit: contain !important;
                pointer-events: none !important;
            }
        `;

        const ribbonCSS = `
    @keyframes ribbon-spin { to { transform: rotate(360deg); } }
    .ribbon-spinner { width: 18px; height: 18px; border: 2px solid rgba(0, 0, 0, 0.1); border-radius: 50%; border-top-color: #FFC107; animation: ribbon-spin 1s linear infinite; }
    .resume-external-ribbon { 
        background: #fff; 
        border: 1px solid #E5E7EB; 
        border-radius: 12px; 
        padding: 12px 16px; 
        margin: 15px 20px; 
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
        position: relative; 
        z-index: 9999;
        display: none;
    }
        .resume-external-ribbon { 
        background: #fff; 
        border: 1px solid #E5E7EB; 
        border-radius: 12px; 
        padding: 12px 16px; 
        margin: 15px 20px; 
        box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
        position: relative; 
        z-index: 1000;
        display: none;
        transition: opacity 0.3s ease; /* Add this */
    }
    .ribbon-progress-track { width: 100%; height: 6px; background: #F3F4F6; border-radius: 3px; margin-top: 10px; overflow: hidden; }
    .ribbon-progress-fill { height: 100%; transition: width 0.4s ease; }
`;
        const kvdrBtnStyles = `
        .kvdrNodeBtnBox {
            transition: transform 0.2s ease, opacity 0.2s ease;
        }
        .kvdrNodeBtnBox i {
            /* Prevents the tooltip from flickering */
            display: block; 
            padding: 2px;
        }
        .kvdrNodeBtnBox:hover {
            transform: scale(1.15); /* Slight pop effect when hovering the icon */
        }
    `;
    const textareaFixCSS = `
            .invisible-scroll-y::-webkit-scrollbar {
                display: none;
            }
        `;
        injectStyles('organigram-textarea-fix', textareaFixCSS);
        injectStyles('organigram-ai-styles', aiLoaderCSS);
        injectStyles('organigram-kvdr-styles', kvdrBtnStyles); // <--- Add this line
        injectStyles('organigram-dnd-styles', dndStyles);
        injectStyles('organigram-hover-styles', hoverStyles);
        injectStyles('organigram-fullscreen-fix', fullscreenFixStyles);
        injectStyles('organigram-ribbon-styles', ribbonCSS); 

        const FEATHERS_BASE_URL = 'https://api.getboarded.tech';
        const getAuthHeader = () => {
            const token = localStorage.getItem('feathers-jwt') || localStorage.getItem('accessToken');
            return token ? { 'Authorization': `Bearer ${token}` } : {};
        };
        const handleFeathersRes = async (res) => {
            if (!res.ok) throw new Error(`API Error: ${res.status}`);
            return await res.json(); 
        };

        const a = {
            id: "",
            data: { id: "", name: "", positionName: "", imageUrl: "", parentId: "" },
            candidateList: { id: "", name: "", positionName: "", imageUrl: "", parent: "" },
            root: { id: "", name: "ROOT", image: "" },
            container: "body",
            type: "lable",
            user: {},
            skills: [],
            softSkills: [],
            role: 2,
            collapsed: !0,
            displaySettings: { cardColor: "#F2C244", textColor: "#666" },
            searchContainer: "",
            displayType: ["card", "image", "label"],
            
            onNodeClick: async (data) => { 
                const res = await fetch(`${FEATHERS_BASE_URL}/kvdr-role`, { method: 'POST', headers: { ...getAuthHeader(), 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
                return handleFeathersRes(res); 
            },
            onNodeDelClick: async (empIds) => { 
                for (let id of empIds) { 
                    // FIX: Delete by query parameter instead of path
                    await fetch(`${FEATHERS_BASE_URL}/kvdr-role?selfId=${id}`, { method: 'DELETE', headers: getAuthHeader() }); 
                }
                return empIds; 
            },
            onNodeAddProfileClick: async (payload) => { 
                const data = { kvdrRoleId: payload.roleId || payload.kvdrRoleId, userId: payload.userId };
                const res = await fetch(`${FEATHERS_BASE_URL}/kvdr-role-profile`, { method: 'POST', headers: { ...getAuthHeader(), 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
                return handleFeathersRes(res); 
            },
            onNodeRemoveProfileClick: async (payload) => { 
                const roleId = payload.roleId || payload.kvdrRoleId;
                const res = await fetch(`${FEATHERS_BASE_URL}/kvdr-role-profile?kvdrRoleId=${roleId}&userId=${payload.userId}`, { method: 'DELETE', headers: getAuthHeader() });
                return handleFeathersRes(res); 
            },
            onNodeFetch: async (query) => { 
                const res = await fetch(`${FEATHERS_BASE_URL}/kvdr-role?${query}`, { method: 'GET', headers: getAuthHeader() });
                const json = await handleFeathersRes(res); 
                return json.data || json; 
            },
            onNodeUpdate: async (payload) => { 
                // FIX: Patch by query parameter instead of path
                const res = await fetch(`${FEATHERS_BASE_URL}/kvdr-role?selfId=${payload.query}`, { method: 'PATCH', headers: { ...getAuthHeader(), 'Content-Type': 'application/json' }, body: JSON.stringify(payload.data) });
                return handleFeathersRes(res); 
            },
            onNodeProfileUpdate: async (payload) => { 
                const res = await fetch(`${FEATHERS_BASE_URL}/kvdr-role-profile?${payload.query}`, { method: 'PATCH', headers: { ...getAuthHeader(), 'Content-Type': 'application/json' }, body: JSON.stringify(payload.data) });
                return handleFeathersRes(res); 
            },
            onNodeProfileFetch: async (query) => { 
                const res = await fetch(`${FEATHERS_BASE_URL}/kvdr-role-profile?${query}`, { method: 'GET', headers: getAuthHeader() });
                const json = await handleFeathersRes(res); 
                return json.data || json; 
            }
        };
        this.config = () => a;
        this.key = e;
        this.chart = t;
        this.role = () => a.role;
        this.skills = a.skills;
        this.softSkills = a.softSkills;
        this.user = a.user;
        let permissions = {};
        const setPermissions = () => {
            const map = {
                0: { addRole: false, delRole: false, editTitle: false, addProfile: false, delProfile: false, expandRole: false, addRoleRequest: true },
                1: { addRole: false, delRole: false, editTitle: false, addProfile: true, delProfile: true, expandRole: true, addRoleRequest: true },
                2: { addRole: true, delRole: true, editTitle: true, addProfile: true, delProfile: true, expandRole: true, addRoleRequest: false },
            };
            permissions = map[this.role()] || {};
        };
        Object.keys(a).forEach((e) => {
            this[e] = function (t) {
                if (e === "role" && arguments.length) {
                    a[e] = t;
                    setPermissions(); // auto-update
                    return this;
                }

                // --- FIX: BLOCK VUE COMPONENT FROM OVERRIDING WITH LOCALHOST ---
                const lockedApiMethods = [
                    'onNodeClick', 'onNodeDelClick', 'onNodeAddProfileClick', 'onNodeRemoveProfileClick', 
                    'onNodeFetch', 'onNodeUpdate', 'onNodeProfileUpdate', 'onNodeProfileFetch'
                ];
                if (lockedApiMethods.includes(e) && arguments.length) {
                    return this; // Ignore the misconfigured Vue setter
                }

                return arguments.length ? ((a[e] = t), this) : a[e];
            };
        });

        setPermissions();
        this.can = (perm) => !!permissions[perm];
        this.listenersAdded = false;
        if (!this.listenersAdded) {
            // 1. Add Error Handling
            socket.on('connect_error', (err) => {
                console.warn("Socket connection failed, falling back to manual polling...");
                // If socket fails, trigger a one-time fetch to ensure data is current
                this.startAutoNotificationRefresh();
            });

            const events = [
                'kvdr-role-created',
                'kvdr-role-patched',
                'kvdr-role-removed',
                'kvdr-role-profile-created',
                'kvdr-role-profile-patched',
                'kvdr-role-profile-removed'
            ];

            events.forEach(eventName => {
                // Listen for ANY change event to keep chart in sync
                socket.on(eventName, data => {
                    console.log(`Real-time update received: ${eventName}`);
                    this.startAutoNotificationRefresh();
                });
            });

            this.listenersAdded = true;
        }
        this.activePollers = new Map(); 
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.startSmartPolling(entry.target);
                } else {
                    this.stopSmartPolling(entry.target);
                }
            });
        }, { threshold: 0.1 }); 
        this.setupRealtimeFallback();

        // --- NEW: Initialize Remote Config Caching ---
        this.cachedOrgConfig = null;
        this.isFetchingConfig = false;
        this.fetchOrgConfig(); 

        // --- NEW: Listener for seamless popup refreshes ---
        if (window._boundOrganigramRefresh) {
            document.removeEventListener('organigram-force-popup-refresh', window._boundOrganigramRefresh);
        }
        window._boundOrganigramRefresh = () => {
            if (this._activePopupArgs && document.getElementById("back-drop-overlay")?.style.display === "flex") {
                // Silently rebuilds the popup in place with the fresh data
                this.expandRole(this._activePopupArgs.data, this._activePopupArgs.type, this._activePopupArgs.id);
            }
        };
        document.addEventListener('organigram-force-popup-refresh', window._boundOrganigramRefresh);
    }

    // --- NEW METHOD: Fetch live settings from the API ---
    async fetchOrgConfig() {
        try {
            const token = localStorage.getItem('feathers-jwt') || localStorage.getItem('accessToken');
            const orgId = this.getActualOrgId();
            if (!token || !orgId || orgId === 'undefined') return;

            // CRITICAL FIX: Clear previous cache so we don't bleed GB Demo into an org with no config!
            this.cachedOrgConfig = null;

            const baseUrl = 'https://api.getboarded.tech';
            
            // Strictly fetch from the exact API you provided using the dynamically resolved Org ID
            const url = `${baseUrl}/kvdr-org-config?orgId=${orgId}&$sort[createdAt]=-1&$limit=1`;

            const response = await fetch(url, {
                headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
            });

            if (response.ok) {
                const json = await response.json();
                let fetchedConfig = null;
                
                if (json.data && json.data.length > 0) {
                    fetchedConfig = json.data[0];
                } else if (Array.isArray(json) && json.length > 0) {
                    fetchedConfig = json[0];
                }

                // Save it globally for the chart to use
                if (fetchedConfig && fetchedConfig.appraisalData) {
                    this.cachedOrgConfig = fetchedConfig;
                }
            }
        } catch (err) {
            console.error("Error fetching remote KVDR config:", err.message);
        }
    }
        setupRealtimeFallback() {
        setInterval(() => {
            if (!socket.connected) {
                console.log("WebSocket inactive: Performing manual background refresh...");
                this.startAutoNotificationRefresh();
                
                this.activePollers.forEach((timer, element) => {
                    this.startSmartPolling(element);
                });
            }
        }, 20000);
    }
    triggerAiEvaluation = async (orgId, roleId, emails, userList, btn) => {
        try {
            const token = localStorage.getItem('feathers-jwt') || localStorage.getItem('accessToken');
            const response = await fetch(`${API_BASE_URL}/api/talent-pool/re-evaluate-candidates`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({ role_id: roleId, user_emails: emails, organization_id: orgId })
            });

            const result = await response.json();
            
            if (result.task_id) {
                this.activeAiTasks.set(roleId, { taskId: result.task_id, emails: emails });
                if (btn) {
                    btn.disabled = true;
                    btn.style.opacity = '0.7';
                    btn.innerHTML = `<img src="${OrangeSpinnerIcon}" style="width:16px; height:16px; filter:brightness(0) invert(1);" class="ai-icon-loading" />`;
                }

                if (userList) {
                    emails.forEach(email => {
                        const row = userList.querySelector(`li[data-email-key="${email.toLowerCase().trim()}"]`);
                        if (row) {
                            row.dataset.evalStatus = 'processing';
                            row.dataset.processing = "true";
                            const cb = row.querySelector('input[type="checkbox"]');
                            if (cb) cb.disabled = true;
                            const rowDiv = row.querySelector('.multi-select-box');
                            if (rowDiv) { rowDiv.style.opacity = "0.6"; rowDiv.style.pointerEvents = "none"; }
                            
                            const statusBox = row.querySelector('.ai-status-box');
                            if (statusBox) {
                                statusBox.innerHTML = `<img src="${OrangeSpinnerIcon}" style="width:20px; height:20px; animation:spin 1s linear infinite;" class="ai-icon-loading" />`;
                            }
                        }
                    });
                }
    
                this._startAiEvaluationPolling(orgId, result.task_id, userList, btn, roleId);
            }
        } catch (err) {
            console.error("AI Evaluation Trigger Error:", err);
            this.activeAiTasks.delete(roleId);
            this.refreshNotifications(); // Trigger UI cleanup
        }
    }

    _startAiEvaluationPolling = (orgId, taskId, userListContainer, aiEvalButton, roleId) => {
        const pollInterval = 3000;
        
        const poller = setInterval(async () => {
            try {
                const token = localStorage.getItem('feathers-jwt') || localStorage.getItem('accessToken');
                const response = await fetch(`${API_BASE_URL}/api/talent-pool/re-evaluate-status/${orgId}/${taskId}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });

                if (!response.ok) throw new Error("Poll failed");

                const statusData = await response.json();
                
                if (userListContainer && userListContainer.isConnected && statusData.users) {
                    Object.entries(statusData.users).forEach(([email, userData]) => {
                        const safeEmail = email.toLowerCase().trim();
                        const userRow = userListContainer.querySelector(`li[data-email-key="${safeEmail}"]`);
                        if (!userRow || userRow.dataset.evalStatus === userData.status) return;

                        if (userData.status === 'completed') {
                            userRow.dataset.evalStatus = 'completed'; 
                            if (typeof userRow.rebuildRow === 'function') {
                                userRow.rebuildRow({ ...userRow.candidateData, ...userData });
                            }
                        } else if (userData.status === 'failed') {
                            userRow.dataset.evalStatus = 'failed';
                            const sb = userRow.querySelector('.ai-status-box');
                            if (sb) sb.innerHTML = '<span title="Analysis Failed">⚠️</span>';
                        }
                    });
                }

                if (statusData.status === 'completed' || statusData.status === 'failed') {
                    clearInterval(poller);
                    this.activeAiTasks.delete(roleId);
                    
                    if (userListContainer && userListContainer.isConnected) {
                        if (aiEvalButton) {
                            aiEvalButton.disabled = false;
                            aiEvalButton.style.opacity = '1';
                            aiEvalButton.innerHTML = `<img src="${AIGenerateIcon}" style="width:16px; height:16px; filter:brightness(0) invert(1);" />`;
                        }
                        userListContainer.querySelectorAll('li[data-processing="true"]').forEach(li => {
                            delete li.dataset.processing;
                            delete li.dataset.evalStatus;
                            const cb = li.querySelector('input[type="checkbox"]');
                            if (cb) cb.disabled = false;
                            const rb = li.querySelector('.multi-select-box');
                            if (rb) { rb.style.opacity = '1'; rb.style.pointerEvents = 'auto'; }
                        });
                    }
                }
            } catch (error) {
                console.error("Polling Error:", error);
                clearInterval(poller);
                this.activeAiTasks.delete(roleId);
            }
        }, pollInterval);
    }

    startSmartPolling(element) {
        if (this.activePollers.has(element)) return;

        const { roleId } = element.dataset;
        const orgId = this.getActualOrgId(); 
        const dot = element.querySelector('.suggestionDot'); 
        
        const poll = () => {
            if (!document.body.contains(element)) {
                this.stopSmartPolling(element);
                return;
            }

            fetch(`${API_BASE_URL}/api/talent-pool/suggestions/${orgId}/${roleId}?t=${Date.now()}`)
                .then(res => res.json())
                .then(response => {
                    const suggestions = response.data || response || [];
                    const validMatches = Array.isArray(suggestions) ? suggestions.filter(c => c.status !== 'rejected') : [];
                    
                    if (validMatches.length > 0) {
                        if(dot) {
                            dot.style.display = "block";
                            dot.title = `${validMatches.length} new match(es)`;
                        }
                    } else {
                        if(dot) dot.style.display = "none";
                    }
                })
                .catch(() => {}) 
                .finally(() => {
                    if (this.activePollers.has(element)) {
                        const timerId = setTimeout(poll, 15000);
                        this.activePollers.set(element, timerId); 
                    }
                });
        };

        poll();
        this.activePollers.set(element, true);
    }
    stopSmartPolling(element) {
        const timerId = this.activePollers.get(element);
        if (timerId && typeof timerId !== 'boolean') {
            clearTimeout(timerId); 
        }
        this.activePollers.delete(element); 
    }
    createChartGroupBy(e) {
        document.querySelector("#" + e.container).innerHTML = "";
        var t = e.data.length;
        let a,
            r = e.data;
        const s = Utils.createElem("div", ["chartCanvasControlls"], "chart-canvas-controlls");
        s.style.cssText = "display:flex;align-items:center;flex-wrap: wrap;border: 1px solid #e5e5e7;border-left:none;border-right:none;background:#FFF;";
        const o = Utils.createElem("div", ["chartCanvasContainer"], "chart-canvas-container"),
            n = Utils.createElem("div", ["chart-canvas"], "chart-canvas");
        o.append(n), document.querySelector("#" + e.container).appendChild(s), document.querySelector("#" + e.container).appendChild(o);
        const i = Utils.createElem("datalist", "", "allUserList");
        n.append(i);
        for (let s = 0; s < t; s++) {
            const t = Utils.createElem("option", "", "opt_" + r[s].id, r[s].name);
            i.append(t);
            const o = Utils.createElem("div", ["member"], r[s].id, "");
            if (
                (Object.keys(r[s]).forEach((t) => {
                    "parentId" == t ? o.setAttribute("data-parentid", (r[s][t] && null != r[s][t] && "" != r[s][t]) || e.root.id === r[s].id ? r[s][t] : e.root.id) : o.setAttribute("data-" + t, r[s][t]),
                        (o.style.color = e.displaySettings.cardColor);
                }),
                o.setAttribute("data-empid", r[s].id),
                "card" === e.type)
            )
                a =
                    '<label class="emptitle" draggable=true><fieldset style="background-color:' +
                    e.displaySettings.cardColor +
                    ";color:" +
                    e.displaySettings.textColor +
                    ";border-color:" +
                    e.displaySettings.borderColor +
                    '" class="userCard onlyCardType"><div class="userImg onlyImgType"><img src="' +
                    r[s].imageUrl +
                    '"  draggable=false/></div><label class="onlyLblType">' +
                    r[s].name +
                    '<br><span class="text-sm">' +
                    r[s].positionName +
                    "</span></label></fieldset></label>";
            else if ("image" === e.type)
                a =
                    '<label class="emptitle" draggable=true><fieldset style="background-color:' +
                    e.displaySettings.cardColor +
                    ";color:" +
                    e.displaySettings.textColor +
                    ";border-color:" +
                    e.displaySettings.borderColor +
                    '" class="userCard onlyCardType"><div class="userImg onlyImgType"><img src="' +
                    r[s].imageUrl +
                    '" name="' +
                    r[s].name +
                    '" alt="' +
                    r[s].name +
                    '" title="' +
                    r[s].name +
                    r[s].positionName +
                    '"  draggable=false/></div></fieldset></label>';
            else {
                let t = "";
                Object.keys(r[s]).forEach((e) => {
                    t += '<div class="flex flex-row padd-1 space-between border-bottom"><span class="d-block text-left mr-10">' + e + '</span><span class="d-block text-right ml-10">' + r[s][e] + "</span></div>";
                }),
                    (a =
                        '<label class="emptitle" draggable=true><fieldset style="background-color:' +
                        e.displaySettings.cardColor +
                        ";color:" +
                        e.displaySettings.textColor +
                        ";border-color:" +
                        e.displaySettings.borderColor +
                        '" class="userCard onlyCardType"><label class="onlyLblType">' +
                        r[s].name +
                        '<br><span class="text-sm">' +
                        r[s].positionName +
                        '</span></label><div class="member_detail_panel">' +
                        t +
                        "</div></fieldset></label>");
            }
            (o.innerHTML = a), n.appendChild(o);
        }
        const l = Utils.createElem("div", ["member","unorganized"], "", "");
        l.dataset.name = "unorganized";
        const d =
            '<label class="emptitle"><fieldset style="background-color:' +
            e.displaySettings.cardColor +
            ";color:" +
            e.displaySettings.textColor +
            ";border-color:" +
            e.displaySettings.borderColor +
            '" class="userCard onlyCardType"><label class="onlyLblType">Unorganized</label></fieldset></label>';
        (l.innerHTML = d), n.appendChild(l);
        let c = 0;
        document.querySelectorAll("div.member").forEach(function (t, a, r) {
            let s = t.dataset.empid,
                o = document.querySelectorAll("[data-parentid='" + s + "']");
            (t.dataset.relationcount = o.length), 0 !== o.length && null !== o.length && "" !== o.length && o.length > 0 ? (t.dataset.relation = t.dataset.relation) : (t.dataset.relation = "");
            const i = Utils.createElem("a", ["toggleBtn"], "", o.length);
            t.childNodes[0].append(i),
                0 !== o.length ? (t.childNodes[0].lastChild.style.display = "inline-block") : (t.childNodes[0].lastChild.style.display = "none"),
                o.forEach(function (e) {
                    try {
                        t.parentNode !== e
                            ? document.querySelector("[data-empid='" + s + "']").append(e)
                            : (n.innerHTML = "<p>This filter have some bidirectional relation. To create hierarchy view remove those relations or try another filter.</p>");
                    } catch (e) {
                        console.log(`${e}`);
                    }
                });
            let l = document.querySelector("div#chart-canvas > div.unorganized");
            if (((null != t.dataset.parentid && "" != t.dataset.parentid) || 0 != t.querySelectorAll("div.member").length || ((t.style.display = "none"), l.append(t), c++), c > 0 && a == r.length - 1)) {
                const e = Utils.createElem("a", ["toggleBtn"], "", c);
                l.childNodes[0].append(e);
            }
            if (e.collapsed) {
                (t.style.display = "none"), (document.querySelector("div#" + e.container + "> div#chart-canvas > div.member").style.display = "inline-block");
                const a = document.querySelector("div#chart-canvas > div.member").childNodes;
                Array.from(a).forEach((e) => {
                    e.style.display = "inline-block";
                });
            }
        }),
            document.querySelectorAll(".toggleBtn").forEach(function (e) {
                (e.style.marginLeft = -e.offsetWidth / 2 + "px"),
                    e.addEventListener("click", function (e) {
                        e.preventDefault(), e.stopPropagation();
                        let t = e.target.parentElement.parentElement.childNodes;
                        Array.from(t).forEach(function (e) {
                            "inline-block" == e.style.display || "" == e.style.display ? (e.style.display = "none") : (e.style.display = "inline-block");
                        });
                    });
            }),
            Utils.toggleFullScreen(s.id, e.container),
            Utils.toggleZoomScreen(o,n,s),
            Utils.moveViewport(o,n,{isActive:true});
            this.createSwitchDisplayButtons(s.id, e.displayType, e),
            this.downloadOrganiGram(s.id),
            this.createSearchMemberBox(null !== e.searchContainer ? e.searchContainer : s.id, i.id);
    }
    createSwitchDisplayButtons(e, t, a) {
        let r = a.type;
        const s = Utils.createElem("div", ["switchBtnBox"], "", "");
        Array.from(t).forEach((e, t) => {
            const o = Utils.createElem("img", ["switchBtnLblIcon"], "", "");
            o.setAttribute("src", "image" == e ? Photo : "card" == e ? Card : Label),
                o.setAttribute("title", e),
                o.setAttribute("alt", e),
                (o.style.width = "25px"),
                (r === e || ("photo" == r && "image" == e)) && (o.style.background = a.displaySettings.cardColor),
                (o.htmlFor = t + "_" + e);
            const n = Utils.createElem("label", ["switchBtnLbl"], "", "");
            n.htmlFor = t + "_" + e;
            const i = Utils.createElem("input", ["switchBtn"], t + "_" + e, e);
            (i.type = "radio"), i.setAttribute("name", "switchBtnGrp"), i.setAttribute("value", e), (i.style.display = "none"), a.type == e && i.setAttribute("checked", !0), n.append(o, i), s.append(n);
        });
        let o = document.querySelector("#" + e);
        o.append(s);
        let n = o.querySelectorAll(".switchBtn");
        Array.from(n).forEach((e) => {
            e.addEventListener("click", function () {
                (a.type = this.value), r !== a.type && OrganiGram.prototype.createChartGroupBy(a);
            });
        });
    }
    downloadOrganiGram(e) {
        const t = Utils.createElem("img", ["_downloadOrganigramIcon"], "", "");
        t.setAttribute("src", Download), t.setAttribute("width", "100%"), t.setAttribute("height", "100%");
        const a = Utils.createElem("button", ["downloadOrganiGramBtn"], "", "");
        (a.style.cssText = "background:none;"),
            a.append(t),
            document.querySelector("#" + e).childNodes[0].append(a),
            a.addEventListener("click", function (e) {
                e.preventDefault(), e.stopPropagation();
                let t = document.querySelectorAll("div.member"),
                    a = [];
                t.forEach(function (e) {
                    let t = {},
                        r = e.dataset;
                    for (let e in r) t = { ...t, [e]: r[e] };
                    a.push(t);
                }),
                    Utils.JSONToCSV(a, "OrganiGram", !0);
            });
    }
    createSearchMemberBox(e, t) {
        const a = document.getElementById(e);
        let r;
        "input" == a.tagName.toLowerCase() || "select" == a.tagName.toLowerCase()
            ? (r = document.getElementById(e))
            : ((r = Utils.createElem("input", ["searchMemBox"], "search-mem-box", "")),
              r.setAttribute("Placeholder", "Search Here...."),
              (r.style.cssText = "\n                padding: 5px;\n                border: 1px solid #666;\n                border-radius: 3px;\n                font-family: inherit;\n                margin: 20px;"),
              document.querySelector("#" + e).prepend(r)),
            r.setAttribute("list", t),
            r.addEventListener("keyup", function () {
                let e = this.value;
                (e = e.toLowerCase()),
                    (e = e.replace(/\s+/g, "")),
                    "" !== e && null !== e
                        ? document.querySelectorAll("div.member").forEach(function (t) {
                              (t.style.display = "inline-block"), t.classList.add("fadeAway");
                              let a = t.dataset.name,
                                  r = t.dataset.id;
                              (a = a.toLowerCase()),
                                  (a = a.replace(/\s+/g, "")),
                                  e == a ? (t.classList.remove("fadeAway"), document.getElementById(r).scrollIntoView({ behavior: "smooth", block: "center", inline: "center" }, !0)) : t.classList.add("fadeAway");
                          })
                        : document.querySelectorAll("div.member").forEach(function (e) {
                              e.classList.remove("fadeAway");
                          });
            });
    }
    attachTooltip = (element, text) => {
        if(!element) return;
        if (!text || text.trim() === "") return; 
        
        element.removeAttribute("title");

        if (!document.getElementById('organigram-custom-tooltip-style')) {
            const css = `
                .organigram-custom-tooltip {
                    position: fixed;
                    background: #1f1f1f;
                    color: #fff;
                    padding: 10px 14px;
                    border-radius: 6px;
                    font-size: 12px;
                    font-family: inherit;
                    white-space: pre-wrap; /* FIX: Allows text wrapping! */
                    max-width: 250px;      /* FIX: Prevents goofy wide lines */
                    line-height: 1.4;      /* FIX: Better readability */
                    text-align: left;
                    z-index: 1000000;
                    pointer-events: none;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
                    opacity: 0;
                    animation: tooltipFadeIn 0.2s forwards;
                    transform: translateX(-50%);
                    margin-top: -8px; 
                }
                .organigram-custom-tooltip::after {
                    content: '';
                    position: absolute;
                    top: 100%;
                    left: 50%;
                    margin-left: -5px;
                    border-width: 5px;
                    border-style: solid;
                    border-color: #1f1f1f transparent transparent transparent;
                }
                @keyframes tooltipFadeIn { 
                    from { opacity: 0; transform: translateX(-50%) translateY(5px); } 
                    to { opacity: 1; transform: translateX(-50%) translateY(0); } 
                }
            `;
            const style = document.createElement('style');
            style.id = 'organigram-custom-tooltip-style';
            style.innerHTML = css;
            document.head.appendChild(style);
        }

        element.addEventListener('mouseenter', (e) => {
            document.querySelectorAll('.organigram-custom-tooltip').forEach(el => el.remove());
            
            const tip = document.createElement('div');
            tip.className = 'organigram-custom-tooltip';
            tip.innerText = text; // pre-wrap CSS will handle line breaks naturally
            document.body.appendChild(tip);
            
            const rect = element.getBoundingClientRect();
            const top = rect.top - tip.offsetHeight; 
            const left = rect.left + (rect.width / 2);
            
            tip.style.top = top + 'px';
            tip.style.left = left + 'px';
        });

        element.addEventListener('mouseleave', () => {
            document.querySelectorAll('.organigram-custom-tooltip').forEach(el => el.remove());
        });
        
        element.addEventListener('click', () => {
            document.querySelectorAll('.organigram-custom-tooltip').forEach(el => el.remove());
        });
    }

    // --- NEW HELPER METHOD FOR DYNAMIC NOTES ---
    getRoleTooltipText(nodeData) {
        const isUserSide = window.location.pathname.includes('/user/');
        
        // 1. If on Org Dashboard, use the default simple text
        if (!isUserSide) {
            return this.translate('orgDashboard.userDashboard.evaluation.clicktoviewevaluation', 'Click to view evaluation');
        }

        // 2. If on User Side, figure out if this is the logged-in user's role
        const currentUserId = (typeof this.user === 'function' && this.user()) ? this.user()._id : null;
        let isCurrentUser = false;
        
        if (nodeData.profiles && nodeData.profiles.some(p => String(p.userId) === String(currentUserId))) {
            isCurrentUser = true;
        } else if (nodeData.isCurrentUserNode) {
            isCurrentUser = true;
        }

        const otherUserNote = "Click on the User photo thumbnail to view details. Based on your ROLE in the organisation, you have access to information on other users in your direct network.";
        const currentUserNote = "You can make a Self-Assessment on the criteria described in the appraisal indicators. Click to change colour, and add subjective remarks as needed.";
        
        return isCurrentUser ? currentUserNote : otherUserNote;
    }

createKVDR = (config) => {
    if (!config.data || typeof config.data !== 'object') {
        console.warn("Invalid config.data, resetting to empty state");
        config.data = { graphData: [] };
    }
    if (!Array.isArray(config.data.graphData)) {
        console.warn("graphData not an array, initializing to empty array");
        config.data.graphData = [];
    }

    // --- AGGRESSIVE COLOR ENFORCER (Fixes Race Conditions & Deep Nesting) ---
    const enforceColors = async () => {
        const actualOrgId = this.getActualOrgId();
        let primaryCol = null;
        let secondaryCol = null;

        const fixHex = (c) => (c && !c.startsWith('#') && /^[0-9A-Fa-f]{3,6}$/.test(c)) ? '#' + c : c;

        // 1. Recursive Deep Search in Vuex (Immune to structure changes)
        try {
            const vuexStr = localStorage.getItem('vuex');
            if (vuexStr) {
                const vuexData = JSON.parse(vuexStr);
                const findOrg = (obj, targetId) => {
                    if (!obj || typeof obj !== 'object') return null;
                    if (obj._id === targetId && obj.primaryThemeColor) return obj;
                    for (let key in obj) {
                        const res = findOrg(obj[key], targetId);
                        if (res) return res;
                    }
                    return null;
                };
                const foundOrg = findOrg(vuexData, actualOrgId);
                if (foundOrg) {
                    primaryCol = foundOrg.primaryThemeColor;
                    secondaryCol = foundOrg.secondaryThemeColor;
                }
            }
        } catch(e) {}

        // 2. Fallback: Check standard Config payload
        if (!primaryCol) {
            let orgConfigInfo = this.cachedOrgConfig || config.data.kvdrOrgConfigData;
            if (!orgConfigInfo && config.data.graphData && config.data.graphData.length > 0) {
                orgConfigInfo = config.data.graphData[0].kvdrOrgConfigData;
            }
            if (orgConfigInfo) {
                primaryCol = orgConfigInfo.primaryThemeColor || orgConfigInfo.primaryColor;
                secondaryCol = orgConfigInfo.secondaryThemeColor || orgConfigInfo.secondaryColor;
            }
        }

        // 3. Ultimate Fallback: Direct API Fetch (If Vuex hasn't saved it yet)
        if (!primaryCol) {
            try {
                const token = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt');
                const res = await fetch(`https://api.getboarded.tech/organization/${actualOrgId}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (res.ok) {
                    const data = await res.json();
                    if (data && data.primaryThemeColor) {
                        primaryCol = data.primaryThemeColor;
                        secondaryCol = data.secondaryThemeColor;
                    }
                }
            } catch(e) {}
        }

        // APPLY COLORS NATIVELY & DOM REPAINT
        if (primaryCol) {
            const hexPrimary = fixHex(primaryCol);
            const hexSecondary = fixHex(secondaryCol || 'FFFFFF');

            // Set global config so new nodes use it
            config.displaySettings.cardColor = hexPrimary;
            config.displaySettings.borderColor = hexPrimary;
            if (secondaryCol) config.displaySettings.textColor = hexSecondary;

            // Force repaint instantly on already rendered DOM elements
            setTimeout(() => {
                document.querySelectorAll('.userCard.onlyCardType').forEach(card => {
                    card.style.backgroundColor = hexPrimary;
                    card.style.borderColor = hexPrimary;
                    if (secondaryCol) card.style.color = hexSecondary;
                    
                    const title = card.querySelector('.role-card-title, .onlyLblType span');
                    if (title && secondaryCol) title.style.color = hexSecondary;
                });
            }, 100); 
        }
    };

    // Fire the async enforcer without blocking the main thread
    enforceColors();
    // --------------------------------------------------------------------
    
    const container = document.querySelector(`#${config.container}`);
    container.innerHTML = ""; 
    this.initResumeProgressRibbon(container);

    if (new URLSearchParams(window.location.search).get('onboarding_active') === 'true') {
        const ribbon = Utils.createElem("div", ["onboarding-ribbon"]);
        Utils.applyStyles(ribbon, {
            width: "100%", backgroundColor: "#e3f2fd", color: "#0277bd", padding: "12px 24px",
            display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: "14px",
            borderBottom: "1px solid #b3e5fc", fontFamily: "inherit", boxSizing: "border-box"
        });
        const leftContent = Utils.createElem("div");
        Utils.applyStyles(leftContent, { display: "flex", alignItems: "center", gap: "8px" });
        leftContent.innerHTML = `<span style="font-size:18px">ℹ️</span> <span><strong>Setup In Progress:</strong> You are on Step 1 of 4. Structure your organization below.</span>`;
        const rightAction = Utils.createElem("div");
        const continueLink = Utils.createElem("a", [], "", "Continue Setup →");
        Utils.applyStyles(continueLink, {
            fontWeight: "700", cursor: "pointer", textDecoration: "none", color: "#01579b",
            background: "rgba(255,255,255,0.4)", padding: "6px 16px", borderRadius: "6px",
            transition: "all 0.2s"
        });
        continueLink.addEventListener("mouseenter", () => continueLink.style.background = "rgba(255,255,255,0.8)");
        continueLink.addEventListener("mouseleave", () => continueLink.style.background = "rgba(255,255,255,0.4)");
        continueLink.addEventListener("click", () => {
            const pathParts = window.location.pathname.split('/');
            const slugIndex = pathParts.indexOf('organization') + 1;
            const slug = pathParts[slugIndex];
            if (slug) { localStorage.setItem(`onboardingStep_${slug}`, '2'); }
            const currentPath = window.location.pathname;
            const onboardingPath = currentPath.replace('/value', '/onboarding');
            window.location.href = onboardingPath;
        });
        rightAction.append(continueLink);
        ribbon.append(leftContent, rightAction);
        container.append(ribbon);
    }
    
    const controls = Utils.createElem("div", ["chartCanvasControlls"], "chart-canvas-controlls");
    Utils.applyStyles(controls, {
        display: "flex", alignItems: "center", justifyContent: "space-between",
        padding: "10px 20px", border: "1px solid #e5e5e7", borderLeft: "none", borderRight: "none",
        background: "#FFF", width: "100%", boxSizing: "border-box", flexWrap: "nowrap"
    });

    const leftGroup = Utils.createElem("div");
    Utils.applyStyles(leftGroup, { display: "flex", alignItems: "center", flex: "1" });

    const rightGroup = Utils.createElem("div");
    Utils.applyStyles(rightGroup, { display: "flex", alignItems: "center", gap: "16px", justifyContent: "flex-end" });

    // 1. SEARCH BAR (LEFT)
    if (this.role() !== 0) {
        const searchWrapper = Utils.createElem('div', ['organigram-search-wrapper']);
        Utils.applyStyles(searchWrapper, { position: 'relative', display: 'flex', alignItems: 'center', width: '300px', zIndex: '1000' });
        const searchIcon = Utils.createElem('i', ["vs-icon", "notranslate", "icon-scale", "feather", "icon-search"]);
        Utils.applyStyles(searchIcon, { position: 'absolute', left: '12px', color: '#9CA3AF', fontSize: '15px' });
        const searchInput = Utils.createElem('input', ['organigram-search-input']);
        searchInput.placeholder = this.translate('orgDashboard.userDashboard.evaluation.searchPlaceholder');
        Utils.applyStyles(searchInput, { width: '100%', padding: '8px 12px 8px 34px', border: '1px solid #E5E7EB', borderRadius: '20px', outline: 'none', fontSize: '13px', background: '#F9FAFB', transition: 'all 0.2s ease', fontFamily: 'inherit', color: '#111827', cursor: 'text' });
        
        const suggestionsBox = Utils.createElem('div', ['organigram-search-suggestions']);
        Utils.applyStyles(suggestionsBox, { position: 'absolute', top: '100%', left: '0', right: '0', marginTop: '6px', background: '#fff', border: '1px solid #E5E7EB', borderRadius: '8px', boxShadow: '0 10px 25px rgba(0,0,0,0.1)', display: 'none', maxHeight: '280px', overflowY: 'auto', padding: '6px 0', zIndex: '9999' });

        if (!document.getElementById('organigram-search-styles')) {
            const style = document.createElement('style');
            style.id = 'organigram-search-styles';
            style.innerHTML = `
                .organigram-search-suggestions::-webkit-scrollbar { width: 6px; }
                .organigram-search-suggestions::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
                @keyframes search-pulse-anim { 0% { box-shadow: 0 0 0 0 rgba(242, 194, 68, 0.7); border-color: #F2C244 !important; } 70% { box-shadow: 0 0 0 15px rgba(242, 194, 68, 0); border-color: #F2C244 !important; } 100% { box-shadow: 0 0 0 0 rgba(242, 194, 68, 0); border-color: transparent; } }
                .search-highlight-node { animation: search-pulse-anim 1.5s ease-out 2; border: 2px solid #F2C244 !important; z-index: 100 !important; }
                .search-highlight-avatar { animation: search-pulse-anim 1.5s ease-out 2; border-color: #F2C244 !important; transform: scale(1.15); z-index: 100 !important; transition: transform 0.2s; }
            `;
            document.head.appendChild(style);
        }

        searchInput.onfocus = () => { searchInput.style.borderColor = '#F2C244'; searchInput.style.background = '#fff'; searchInput.style.boxShadow = '0 0 0 3px rgba(242,194,68,0.1)'; if(searchInput.value.trim().length > 0) suggestionsBox.style.display = 'block'; };
        searchInput.onblur = () => { searchInput.style.borderColor = '#E5E7EB'; searchInput.style.background = '#F9FAFB'; searchInput.style.boxShadow = 'none'; setTimeout(() => { suggestionsBox.style.display = 'none'; }, 200); };
        
        searchInput.addEventListener('input', (e) => {
            const val = e.target.value.toLowerCase().trim();
            suggestionsBox.innerHTML = '';
            if (!val) { suggestionsBox.style.display = 'none'; return; }

            let matches = [];
            const graphData = config.data.graphData || [];
            const candidateList = config.candidateList || [];

            if (config.root && config.root.name && config.root.name.toLowerCase().includes(val)) {
                matches.push({ type: 'role', id: config.root.id, label: config.root.name, subLabel: 'Head of Organization' });
            }

            graphData.forEach(role => {
                // Combine Title and Level for search display
                const displayTitle = role.level ? `${role.title} ${role.level}` : role.title;
                
                if (displayTitle && displayTitle.toLowerCase().includes(val)) {
                    matches.push({ type: 'role', id: role.selfId, label: displayTitle, subLabel: 'Role' });
                }
                const profiles = role.profiles || role.kvdrRoleProfiles || [];
                profiles.forEach(p => {
                    const user = candidateList.find(c => String(c.id) === String(p.userId));
                    if (user) {
                        // --- FIX: Prevent ghost users from appearing in search (ADDED 'deactivated') ---
                        const isInactive = p.isActive === false || p.isDeleted === true ||
                                           (p.status && ['inactive', 'deleted', 'removed', 'deactivated'].includes(String(p.status).toLowerCase())) ||
                                           user.isActive === false || user.isDeleted === true ||
                                           (user.status && ['inactive', 'deleted', 'removed', 'deactivated'].includes(String(user.status).toLowerCase())) ||
                                           (user.userData && (user.userData.isActive === false || user.userData.isDeleted === true || 
                                           (user.userData.status && ['inactive', 'deleted', 'removed', 'deactivated'].includes(String(user.userData.status).toLowerCase()))));
                        if (isInactive) return;

                        const uName = (user.name || user.firstName || user.email || "").toLowerCase();
                        if (uName.includes(val)) {
                            matches.push({ type: 'person', roleId: role.selfId, userId: p.userId, label: user.name || user.firstName || user.email, subLabel: `in ${role.title}`, avatar: user.imageUrl || user.image_url });
                        }
                    }
                });
            });

            matches = matches.filter((v, i, a) => a.findIndex(t => (t.id === v.id && t.userId === v.userId)) === i);

            if (matches.length > 0) {
                matches.forEach(match => {
                    const item = Utils.createElem('div');
                    Utils.applyStyles(item, { padding: '8px 16px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: '12px', borderBottom: '1px solid #f9f9f9', transition: 'background 0.2s', width: '100%', boxSizing: 'border-box' });
                    item.onmouseenter = () => item.style.background = '#F3F4F6';
                    item.onmouseleave = () => item.style.background = '#fff';
                    let iconHtml = match.type === 'person' && match.avatar ? `<img src="${match.avatar}" style="width:28px;height:28px;border-radius:50%;object-fit:cover;border:1px solid #E5E7EB;flex-shrink:0;">` : `<div style="width:28px;height:28px;border-radius:6px;background:#F3F4F6;display:flex;align-items:center;justify-content:center;flex-shrink:0;"><i class="vs-icon notranslate feather icon-${match.type==='role'?'briefcase':'user'}" style="font-size:14px;color:#6B7280;"></i></div>`;
                    item.innerHTML = `${iconHtml} <div style="display:flex;flex-direction:column;align-items:flex-start;text-align:left;overflow:hidden;width:100%;"><span style="font-size:13px;font-weight:600;color:#1F2937;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:left;width:100%;">${match.label}</span><span style="font-size:11px;color:#6B7280;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:left;width:100%;">${match.subLabel}</span></div>`;
                    item.onmousedown = (evt) => {
                        evt.preventDefault(); 
                        const targetId = match.type === 'role' ? match.id : match.roleId;
                        const roleNode = document.querySelector(`[data-empid='${targetId}'], #${targetId}`);
                        if (roleNode) {
                            roleNode.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
                            document.querySelectorAll('.search-highlight-node').forEach(el => el.classList.remove('search-highlight-node'));
                            document.querySelectorAll('.search-highlight-avatar').forEach(el => { el.classList.remove('search-highlight-avatar'); el.style.transform = ''; });
                            if (match.type === 'role') {
                                const card = roleNode.querySelector('.userCard');
                                if (card) { card.classList.add('search-highlight-node'); setTimeout(() => card.classList.remove('search-highlight-node'), 3000); }
                            } else {
                                const avatar = roleNode.querySelector(`#img-${match.userId}`);
                                if (avatar) { avatar.classList.add('search-highlight-avatar'); setTimeout(() => { avatar.classList.remove('search-highlight-avatar'); avatar.style.transform = ''; }, 3000); } 
                                else { const card = roleNode.querySelector('.userCard'); if (card) { card.classList.add('search-highlight-node'); setTimeout(() => card.classList.remove('search-highlight-node'), 3000); } }
                            }
                        }
                        suggestionsBox.style.display = 'none'; searchInput.value = ''; searchInput.blur();
                    };
                    suggestionsBox.append(item);
                });
                suggestionsBox.style.display = 'block';
            } else {
                suggestionsBox.innerHTML = '<div style="padding: 16px; text-align: center; font-size: 13px; color: #9CA3AF;">No roles or assigned candidates found.</div>';
                suggestionsBox.style.display = 'block';
            }
        });

        searchWrapper.append(searchIcon, searchInput, suggestionsBox);
        leftGroup.append(searchWrapper);
    }

    // 2. RIGHT SIDE ICONS
    const path = window.location.pathname || "";
    const isOrgPlanView = path.includes('/organization/') && path.includes('/value');
    
    // 2A. Import Resumes (Icon Only)
    if (this.role() !== 0 && isOrgPlanView) {
        this.createImportResumesBtn(rightGroup); 
    }

    // 2B. Refresh
    const refreshBtn = Utils.createElem("button", ["refreshBtn"], "", "");
    Utils.applyStyles(refreshBtn, {
        width: "32px", height: "32px", padding: "0", background: "transparent",
        border: "none", borderRadius: "50%", cursor: "pointer", color: "#FFC107", display: "flex",
        alignItems: "center", justifyContent: "center", position: "relative",
        transition: "background 0.2s ease, color 0.2s ease"
    });
    refreshBtn.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"></polyline><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path></svg>`;
    this.attachTooltip(refreshBtn, this.translate('orgDashboard.userDashboard.evaluation.refreshchart'));
    refreshBtn.addEventListener("mouseenter", () => { refreshBtn.style.background = "#FFC107"; refreshBtn.style.color = "#fff"; });
    refreshBtn.addEventListener("mouseleave", () => { refreshBtn.style.background = "transparent"; refreshBtn.style.color = "#FFC107"; });
    refreshBtn.addEventListener("click", async (e) => {
        e.preventDefault();
        this.toggleLoadingScreen(true, "Refreshing Chart Data...");
        try {
            await this.fetchOrgConfig();
            const query = `kvdrId=${config.id}`;
            let response = await config.onNodeFetch(query);
            let freshData = (response && response.data) ? response.data : response;
            if (Array.isArray(freshData)) {
                config.data.graphData = freshData.map(node => {
                    if (node.kvdrRoleProfiles && (!node.profiles || node.profiles.length === 0)) node.profiles = node.kvdrRoleProfiles;
                    return node;
                });
                this.createKVDR(config);
            }
        } catch (err) { console.error("Refresh Error:", err); } finally { this.toggleLoadingScreen(false); }
    });
    if (this.role() !== 0) {
        rightGroup.append(refreshBtn);
    }

    // 2C. Fullscreen Expand
    const fsBtn = document.getElementById('toggle-full-screen');
    if (fsBtn) {
        this.attachTooltip(fsBtn, "Toggle Fullscreen");
        rightGroup.append(fsBtn);
    }

    // 2D. Notifications (Bell)
    this.notificationsPanel(rightGroup);
    if (this.role() === 0 && this.notifyBtn && this.notifyBtn.parentElement) {
        this.notifyBtn.parentElement.style.display = "none";
    }

    // --- BULLETPROOF ICON ORDERING ---
    // Forces the visual order regardless of what Vue tries to do in the background
    Array.from(rightGroup.children).forEach(child => {
        if (child.querySelector('.icon-file-text')) {
            child.style.order = "1"; // Import (Far Left)
        } 
        else if (child.classList.contains('refreshBtn')) {
            child.style.order = "2"; // Refresh 
        } 
        else if (child.id === 'toggle-full-screen') {
            child.style.order = "3"; // Fullscreen
        } 
        else {
            child.style.order = "4"; // Bell (Far Right)
        }
    });

    // Append both groups to the main top bar
    controls.append(leftGroup, rightGroup);
    // --- CANVAS CONTAINER SETUP ---
    const canvasContainer = Utils.createElem("div", ["chartCanvasContainer"], "chart-canvas-container");
    Utils.applyStyles(canvasContainer, {
        display: "block", overflow: "hidden", width: "100%", height: "calc(100vh - 160px)",
        minHeight: "500px", background: "#FAFAFA", position: "relative"
    });

    if (!this.fullscreenListenerAdded) {
        const handleFullscreenChange = () => {
            const chartContainerNode = document.querySelector(`#${config.container} .chartCanvasContainer`);
            if (!chartContainerNode) return;
            const isFullscreen = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
            if (isFullscreen) { chartContainerNode.style.height = '100%'; chartContainerNode.style.minHeight = '100%'; } 
            else { chartContainerNode.style.height = 'calc(100vh - 160px)'; chartContainerNode.style.minHeight = '500px'; }
        };
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        document.addEventListener('mozfullscreenchange', handleFullscreenChange);
        document.addEventListener('MSFullscreenChange', handleFullscreenChange);
        this.fullscreenListenerAdded = true; 
    }

    const canvas = Utils.createElem("div", ["chart-canvas"], "chart-canvas");
    Utils.applyStyles(canvas, {
        display: "inline-block", textAlign: "center", minWidth: "100%", width: "max-content",
        padding: "50px", boxSizing: "border-box", whiteSpace: "nowrap", transformOrigin: "center top"
    });

    const overlay = Utils.createElem("div", ["backDropOverlay"], "back-drop-overlay");
    overlay.addEventListener("click", () => { overlay.innerHTML = ""; overlay.style.display = "none", isViewportActive.status = true })
    Utils.applyStyles(overlay, { background: "rgba(0,0,0,0.4)", position: "fixed", top: 0, left: 0, padding: "10px", overflow: "auto", right: 0, width: "100%", height: "100%", zIndex: 9999, display: "none" })
    
    canvasContainer.append(canvas, overlay);
    container.append(controls, canvasContainer);
    
    const rootNodeHtml = `
        <label class="emptitle" style="position:relative; overflow: visible !important; cursor: pointer;">
            <fieldset class="userCard onlyCardType root-card-drop-target node-hover-target" style="background-color: ${config.displaySettings.cardColor}; color: ${config.displaySettings.textColor}; border-color: ${config.displaySettings.borderColor}; position:relative; overflow: visible !important; cursor: pointer;">
                <label class="onlyLblType" style="cursor: pointer;">
                    <div style="display: flex; align-items: center; cursor: pointer;">
                        <span style="cursor: pointer;">${config.root.name}</span>
                        <span class="selectedUsrBox" style="display: flex; margin: 10px 5px; align-items: center;">
                            <img class="selectedUsrImg" src="${config.root.image}" style="width: 32px; height: 32px; object-fit: cover; object-position: center; border: 2px solid; border-radius: 50%; cursor: pointer;">
                        </span>
                    </div>
                </label>
            </fieldset>
        </label>
    `;
    const rootNode = Utils.createElem("div", ["member", "root"], config.root.id, rootNodeHtml);
    const rootCard = rootNode.querySelector('.root-card-drop-target');
    
    if (this.can("editTitle")) {
        rootCard.addEventListener("dragover", (e) => { e.preventDefault(); const draggedId = window.draggedNodeId; if (draggedId) rootCard.classList.add('drag-over-active'); });
        rootCard.addEventListener("dragleave", () => rootCard.classList.remove('drag-over-active'));
        rootCard.addEventListener("drop", (e) => {
            e.preventDefault(); rootCard.classList.remove('drag-over-active');
            const draggedId = e.dataTransfer.getData("text/plain"); const targetId = config.root.id;
            if (draggedId && draggedId !== targetId) {
                const draggedNode = config.data.graphData.find(n => n.selfId === draggedId);
                const draggedName = draggedNode ? draggedNode.title : "this role";
                this.confirmMovePopup(draggedName, config.root.name, async () => { await this.handleNodeMove(draggedId, targetId); });
            }
        });
    }
    
    const nodeConfig = {
        body: config.container, candidateList: config.candidateList, data: { kvdrOrgConfigData: config.data.kvdrOrgConfigData },
        displaySettings: { cc: config.displaySettings.cardColor, tc: config.displaySettings.textColor, bc: config.displaySettings.borderColor },
        addUsersToDesig: (popupData) => { event.stopPropagation(); overlay.append(popupData); overlay.style.display = "flex"; popupData.dataset.selectedNode = event.target.closest("div.member").dataset.empid; },
        onNodeClick: config.onNodeClick, onNodeDelClick: config.onNodeDelClick, onNodeFetch: config.onNodeFetch,
        onNodeUpdate: config.onNodeUpdate, onNodeAddProfileClick: config.onNodeAddProfileClick,
        onNodeProfileFetch: config.onNodeProfileFetch, onNodeProfileUpdate: config.onNodeProfileUpdate,
        onNodeRemoveProfileClick: config.onNodeRemoveProfileClick,
    };

    if (this.can("addRole")) {
        const addNodeBtn = Utils.createElem("div", ["toggleBtn", "addNodeBtn", "node-action-icon"], "", "");
        this.attachTooltip(addNodeBtn, this.translate('orgDashboard.userDashboard.evaluation.addroles'));
        const plusIconImg = Utils.createElem("i", ["vs-icon", "notranslate", "icon-scale", "feather", "icon-plus"]);
        Utils.applyStyles(plusIconImg, { fontSize: "10px", fontWeight: "900", display: "block", color: "#000" });
        addNodeBtn.append(plusIconImg);
        addNodeBtn.addEventListener('click', (a) => this.createNode(nodeConfig, overlay));
        Utils.applyStyles(addNodeBtn, { position: "absolute", bottom: "-32px", left: "50%", transform: "translateX(-50%)", background: "#FFFFFF", border: "1px solid #000", borderRadius: "3px", width: "14px", height: "14px", display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", zIndex: "999", filter: "drop-shadow(0px 1px 2px rgba(0,0,0,0.1))" });
        addNodeBtn.dataset.addnode = "true";
        rootNode.querySelector(".userCard").append(addNodeBtn);
    }
    canvas.append(rootNode);

    Utils.toggleFullScreen(controls.id, config.container);
    
    if (this.role() !== 0) {
        this.enableGlobalDragDrop(document.body);
    }
    
    Utils.moveViewport(canvasContainer, canvas, isViewportActive);

    if (config.data.graphData.length) {
        // OPTIMIZATION: Build a dictionary of nodes in memory FIRST
        const nodeElementsMap = new Map();
        
        // 1. Create all nodes but DO NOT append them to the DOM yet
        config.data.graphData.forEach((node) => {
            if (node.status === 'rejected') return;
            const nodeData = { ...node, ...nodeConfig };
            const importedNode = this.importNodeKVDR(nodeData, overlay);
            nodeElementsMap.set(node.selfId, importedNode);
        });

        // 2. Attach children to parents strictly in memory
        config.data.graphData.forEach((node) => {
            if (node.status === 'rejected') return;
            
            const currentElement = nodeElementsMap.get(node.selfId);
            const parentElement = nodeElementsMap.get(node.parentId);

            // If it has a parent in the map, attach it there. Otherwise, attach to Root.
            if (parentElement && node.parentId !== config.root.id) {
                parentElement.append(currentElement);
            } else {
                rootNode.append(currentElement);
            }
        });
    }

    setTimeout(() => {
        if (rootNode && canvasContainer) {
            const rootRect = rootNode.getBoundingClientRect();
            const containerRect = canvasContainer.getBoundingClientRect();
            const currentScrollLeft = canvasContainer.scrollLeft;
            const rootAbsoluteLeft = currentScrollLeft + (rootRect.left - containerRect.left);
            const halfContainer = containerRect.width / 2;
            const halfRoot = rootRect.width / 2;
            const targetScroll = rootAbsoluteLeft - halfContainer + halfRoot;
            canvasContainer.scrollTo({ left: targetScroll, behavior: 'auto' });
        }
    }, 100);
}
getActualOrgId() {
        const config = this.config();
        const cData = config.data || {};
        const orgConfig = cData.kvdrOrgConfigData || {};

        // 1. THE ABSOLUTE TRUTH: Vue explicitly injects the selected Org ID into the root node.
        // This guarantees the User Side dropdown perfectly syncs with the chart API calls.
        if (config.root && config.root.id && /^[a-fA-F0-9]{24}$/.test(config.root.id)) {
            return config.root.id;
        }

        // 2. PRIORITY: Passed explicitly in the config data payload
        let passedOrgId = orgConfig.organizationId || orgConfig.orgId || orgConfig._id || cData.organizationId || cData.orgId;
        if (passedOrgId && /^[a-fA-F0-9]{24}$/.test(passedOrgId)) {
            return passedOrgId;
        }

        // 3. PRIORITY: Resolved True Org ID from URL (Only reliable on Org Dashboard)
        if (this.trueOrgId && window.location.pathname.includes('/organization/')) {
            return this.trueOrgId;
        }

        // 4. PRIORITY: Vuex Active Session Organization (Fallback for edge cases)
        try {
            const vuexStr = localStorage.getItem('vuex');
            if (vuexStr) {
                const vuex = JSON.parse(vuexStr);
                if (vuex.organization && vuex.organization.orgData && vuex.organization.orgData._id) {
                    return vuex.organization.orgData._id;
                }
            }
        } catch(e) {}

        // 5. Ultimate Fallback
        return config.id;
    }

enableGlobalDragDrop(targetElement) {
        if (targetElement.dataset.dndInitialized === 'true') {
            return;
        }
        targetElement.dataset.dndInitialized = 'true';

        if (!document.getElementById('organigram-drop-overlay')) {
            const overlay = Utils.createElem("div", [], "organigram-drop-overlay");
            const content = Utils.createElem("div");
            
            // Icon
            const icon = Utils.createElem("i", ["vs-icon", "notranslate", "icon-scale", "feather", "icon-upload-cloud"]);
            Utils.applyStyles(icon, { fontSize: "60px", marginBottom: "20px", color: "#fff" });
            
            // Text
            const text = Utils.createElem("h2", [], "", "Drop Resumes to Import");
            Utils.applyStyles(text, { color: "#fff", fontFamily: "inherit", margin: "0" });

            content.append(icon, text);
            Utils.applyStyles(content, { textAlign: "center", pointerEvents: "none" });

            Utils.applyStyles(overlay, {
                position: "fixed", top: "0", left: "0", width: "100%", height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.65)", zIndex: "999999",
                display: "none", alignItems: "center", justifyContent: "center",
                backdropFilter: "blur(4px)", transition: "opacity 0.2s"
            });

            overlay.append(content);
            document.body.append(overlay);
        }

        const overlay = document.getElementById('organigram-drop-overlay');
        let dragCounter = 0;

        const isOrgPlanView = () => {
            const path = window.location.pathname || "";
            return path.includes('/organization/') && path.includes('/value');
        };

        // --- ADDED CHECK: ONLY TRIGGER FOR FILES ---
        const hasFiles = (e) => {
            return e.dataTransfer && e.dataTransfer.types && (
                e.dataTransfer.types.includes ? e.dataTransfer.types.includes('Files') : e.dataTransfer.types.indexOf('Files') !== -1
            );
        };

        // 2. Event Listeners
        const preventDefaults = (e) => {
            if (!isOrgPlanView()) return; 
            if (!hasFiles(e)) return; // Abort if dragging an internal node
            e.preventDefault();
            e.stopPropagation();
        };

        ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
            targetElement.addEventListener(eventName, preventDefaults, false);
        });

        targetElement.addEventListener('dragenter', (e) => {
            if (!isOrgPlanView()) return;
            if (!hasFiles(e)) return; 
            dragCounter++;
            overlay.style.display = "flex";
        });

        targetElement.addEventListener('dragleave', (e) => {
            if (!isOrgPlanView()) return;
            if (!hasFiles(e)) return; 
            dragCounter--;
            if (dragCounter <= 0) {
                dragCounter = 0;
                overlay.style.display = "none";
            }
        });

        targetElement.addEventListener('drop', (e) => {
            if (!isOrgPlanView()) return;
            if (!hasFiles(e)) return; 
            dragCounter = 0;
            overlay.style.display = "none";
            
            const dt = e.dataTransfer;
            const files = dt.files;

            if(files && files.length > 0) {
                this.handleResumeDropBatch(files);
            }
        });
    }

    async handleResumeDropBatch(files) {
        const validExts = ['.pdf', '.doc', '.docx', '.txt'];
        const validFiles = Array.from(files).filter(f => 
            validExts.some(ext => f.name.toLowerCase().endsWith(ext))
        );

        if (validFiles.length === 0) {
            this.showToast("Invalid file type. Please drop PDF, DOC, or TXT files.", "error");
            return;
        }

        if (validFiles.length > 20) {
            this.showToast("Limit exceeded. Please drop max 20 files at a time.", "error");
            return;
        }

        this.toggleLoadingScreen(true, `Importing ${validFiles.length} Resumes...`);

        // --- BULLETPROOF ID RESOLUTION ---
        const actualOrgId = this.getActualOrgId();
        let kvdrId = "";
        
        // 1. Best Source: Extract directly from active roles on the chart
        const gData = this.config().data?.graphData;
        if (Array.isArray(gData) && gData.length > 0) {
            const firstValid = gData.find(n => n.kvdrId);
            if (firstValid) kvdrId = firstValid.kvdrId;
        }
        
        // 2. Second Source: Try base config ID
        if (!kvdrId || kvdrId === 'undefined') {
            kvdrId = this.config().id;
        }

        // 3. Ultimate Fallback: Ensure it's a valid 24-character Mongo ID, otherwise use Organization ID
        if (!kvdrId || kvdrId === 'undefined' || !/^[a-fA-F0-9]{24}$/.test(kvdrId)) {
            kvdrId = actualOrgId;
        }

        const token = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt') || "";

        const formData = new FormData();
        formData.append('api_token', token);
        formData.append('organization_id', actualOrgId);
        formData.append('kvdr_id', kvdrId); // Now strictly a valid 24-char ID
        formData.append('upload_type', 'applicant'); 

        let isSilent = false;
        try {
            const saved = localStorage.getItem(`resume_upload_state_${actualOrgId}`);
            if (saved) isSilent = JSON.parse(saved).isSilentMode || false;
        } catch(e) {}
        formData.append('silent_mode', isSilent);
        
        validFiles.forEach(f => formData.append('files', f));

        try {
            const res = await fetch(`${API_BASE_URL}/upload-resumes-batch/`, { 
                method: 'POST', 
                body: formData 
            });
            
            const data = await res.json();
            if (!res.ok) throw new Error(data.detail || "Upload failed");

            const newBatchId = data.batch_id;
            const stateKey = `resume_upload_state_${actualOrgId}`;
            let savedState = { localBatchIds: [], batchesData: {}, uploadQueue: [] };

            try {
                const existing = localStorage.getItem(stateKey);
                if (existing) savedState = JSON.parse(existing);
            } catch(e) {}

            const fileObj = {};
            validFiles.forEach(f => {
                fileObj[f.name] = { status: 'processing', progress: 5 };
            });

            if (!savedState.localBatchIds.includes(newBatchId)) {
                savedState.localBatchIds.push(newBatchId);
            }

            savedState.batchesData[newBatchId] = {
                status: 'processing',
                total_files: validFiles.length,
                processed_count: 0,
                files: fileObj
            };
            
            savedState.timestamp = Date.now();
            savedState.lastActivity = Date.now(); // Timer for the 30-second kill switch
            localStorage.setItem(stateKey, JSON.stringify(savedState));

            const orgSlug = this.config().slug;
            if(orgSlug) {
                localStorage.setItem(`onboardingStep_${orgSlug}`, '2');
            }
            
            this.refreshRibbonUI(); 
            this.showResumeSuccessToast(validFiles.length);

        } catch (e) {
            console.error("Upload Error:", e);
            this.showToast(`Upload Error: ${e.message}`, "error");
        } finally {
            this.toggleLoadingScreen(false);
        }
    }

    initResumeProgressRibbon(container) {
        if (window.__resumeRibbonInterval) clearInterval(window.__resumeRibbonInterval);

        let ribbon = document.getElementById("resume-progress-ribbon-inline");
        if (!ribbon) {
            ribbon = document.createElement("div");
            ribbon.id = "resume-progress-ribbon-inline";
            
            ribbon.style.cssText = `
                background: #fff; border: 1px solid #E5E7EB; border-radius: 8px;
                padding: 16px 20px; margin-bottom: 20px; box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.03);
                display: none; font-family: inherit; width: 100%; box-sizing: border-box;
            `;
            
            // UI setup with Manual Cross Button
            ribbon.innerHTML = `
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                    <div style="display: flex; align-items: center; gap: 10px;">
                        <div id="ribbon-icon-zone"></div>
                        <div style="display: flex; flex-direction: column; text-align: left;">
                            <span id="ribbon-title" style="font-size: 14px; font-weight: 600; color: #111827;"></span>
                            <span id="ribbon-sub-title" style="font-size: 12px; color: #6B7280;"></span>
                        </div>
                    </div>
                    <div style="display: flex; align-items: center; gap: 15px;">
                        <span id="ribbon-perc-text" style="font-weight: 700; font-size: 16px; color: #FFC107;"></span>
                        <div id="ribbon-action-zone"></div>
                        <button id="ribbon-force-close-btn" style="background:transparent;border:none;cursor:pointer;font-size:24px;line-height:1;color:#9ca3af;padding:0 5px;" title="Dismiss">&times;</button>
                    </div>
                </div>
                <div style="width: 100%; height: 6px; background: #F3F4F6; border-radius: 3px; overflow: hidden;">
                    <div id="ribbon-bar-fill" style="height: 100%; transition: width 0.3s ease; width: 0%;"></div>
                </div>
            `;
            
            container.parentNode.insertBefore(ribbon, container);

            // Bind the manual cross (X) force close logic
            document.getElementById('ribbon-force-close-btn').addEventListener('click', (e) => {
                e.stopPropagation();
                if (this.ribbonStateKey) localStorage.removeItem(this.ribbonStateKey);
                ribbon.style.display = "none";
            });

        } else if (ribbon.parentNode !== container.parentNode) {
            container.parentNode.insertBefore(ribbon, container);
        }

        const findActiveKey = () => {
            return Object.keys(localStorage).find(key => {
                if (!key.startsWith('resume_upload_state_')) return false;
                try {
                    const data = JSON.parse(localStorage.getItem(key));
                    return data && data.localBatchIds && data.localBatchIds.length > 0;
                } catch(e) { return false; }
            });
        };

        this.ribbonStateKey = findActiveKey();
        this.refreshRibbonUI();

        // Start Polling (with 30-sec Auto-Kill feature)
        window.__resumeRibbonInterval = setInterval(async () => {
            if (!this.ribbonStateKey) this.ribbonStateKey = findActiveKey();
            
            if (this.ribbonStateKey) {
                try {
                    const saved = localStorage.getItem(this.ribbonStateKey);
                    if (saved) {
                        const state = JSON.parse(saved);
                        if (state.localBatchIds && state.localBatchIds.length > 0) {
                            
                            // --> 30 SECOND KILL SWITCH <--
                            const lastActivity = state.lastActivity || state.timestamp || Date.now();
                            if (Date.now() - lastActivity > 30000) {
                                console.warn("Ribbon stuck for >30 seconds. Triggering Auto-Kill.");
                                localStorage.removeItem(this.ribbonStateKey);
                                ribbon.style.display = "none";
                                return; 
                            }

                            const ids = state.localBatchIds.join(',');
                            const actualOrgId = this.getActualOrgId();
                            const token = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt') || "";
                            
                            const res = await fetch(`${API_BASE_URL}/status/multi-batch?batch_ids=${ids}&organization_id=${actualOrgId}`, {
                                headers: { 'Authorization': `Bearer ${token}` }
                            });
                            
                            if (res.ok) {
                                const data = await res.json();
                                if (data.batches) {
                                    let isUpdated = false;
                                    Object.keys(data.batches).forEach(bid => {
                                        state.batchesData[bid] = data.batches[bid];
                                        isUpdated = true;
                                    });
                                    if (isUpdated) {
                                        state.lastActivity = Date.now(); // Refresh the kill switch timer
                                        localStorage.setItem(this.ribbonStateKey, JSON.stringify(state));
                                    }
                                }
                            }
                        }
                    }
                } catch(err) {
                    console.error("Ribbon Polling Error", err);
                }
            }

            this.refreshRibbonUI();
        }, 2000);
    }

refreshRibbonUI() {
        const ribbon = document.getElementById("resume-progress-ribbon-inline");
        if (!ribbon) return;

        if (!window.location.pathname.includes('/value')) {
            ribbon.style.display = "none";
            if (window.__resumeRibbonInterval) clearInterval(window.__resumeRibbonInterval);
            return;
        }

        const saved = this.ribbonStateKey ? localStorage.getItem(this.ribbonStateKey) : null;
        
        const hideRibbon = () => {
            if (ribbon.style.display !== "none") ribbon.style.display = "none";
            this.ribbonStateKey = null;
        };

        if (!saved) return hideRibbon();

        let state;
        try { state = JSON.parse(saved); } catch(e) { return; } 

        if (!state.localBatchIds || state.localBatchIds.length === 0) return hideRibbon();

        let totalFiles = 0, processedCount = 0, totalProgress = 0, activeFileName = "", statuses = [];
        Object.values(state.batchesData || {}).forEach(batch => {
            totalFiles += (batch.total_files || 0);
            processedCount += (batch.processed_count || 0);
            statuses.push(batch.status);
            
            if (batch.files) {
                Object.entries(batch.files).forEach(([name, f]) => {
                    const s = f.status;
                    if (!activeFileName && s !== 'completed' && s !== 'failed' && s !== 'processed_and_emailed') {
                        activeFileName = name;
                    }
                    if (s === 'completed' || s === 'processed_and_emailed' || s === 'failed') {
                        totalProgress += 100;
                    } else {
                        totalProgress += (f.progress || 0);
                    }
                });
            }
        });

        const isComplete = (statuses.length > 0 && statuses.every(s => ['completed', 'failed', 'completed_with_errors'].includes(s))) || 
                           (totalFiles > 0 && processedCount >= totalFiles);
                           
        const percentage = isComplete ? 100 : (totalFiles > 0 ? Math.floor(totalProgress / totalFiles) : 0);

        if (ribbon.style.display !== "block") ribbon.style.display = "block";

        const titleEl = document.getElementById("ribbon-title");
        const subEl = document.getElementById("ribbon-sub-title");
        const percEl = document.getElementById("ribbon-perc-text");
        const barEl = document.getElementById("ribbon-bar-fill");
        const iconZone = document.getElementById("ribbon-icon-zone");
        const actionZone = document.getElementById("ribbon-action-zone");

        if (titleEl) titleEl.textContent = isComplete ? 'Processing Complete' : `Parsing ${activeFileName || 'resumes'}...`;
        if (subEl) subEl.textContent = `${processedCount} / ${totalFiles} files processed`;
        
        if (percEl) {
            percEl.textContent = `${percentage}%`;
            percEl.style.color = isComplete ? '#28C76F' : '#FFC107';
        }
        
        if (barEl) {
            barEl.style.width = `${percentage}%`;
            barEl.style.backgroundColor = isComplete ? '#28C76F' : '#FFC107';
        }

        if (iconZone) {
            const iconHtml = isComplete ? '<span style="font-size:16px">✅</span>' : '<div class="ribbon-spinner"></div>';
            if (iconZone.innerHTML !== iconHtml) iconZone.innerHTML = iconHtml;
        }

        if (actionZone) {
            if (isComplete) {
                if (!document.getElementById("ribbon-finish-btn-inline")) {
                    
                    // Disarm the 30-second kill switch so the user has unlimited time to click "Finish"
                    try {
                        let s = JSON.parse(localStorage.getItem(this.ribbonStateKey));
                        s.lastActivity = Date.now() + 86400000; // Push kill threshold 24 hours into future
                        localStorage.setItem(this.ribbonStateKey, JSON.stringify(s));
                    } catch(e){}

                    actionZone.innerHTML = `<button id="ribbon-finish-btn-inline" style="background: #28C76F; color: #fff; border: none; padding: 6px 14px; border-radius: 6px; cursor: pointer; font-weight: 600; font-size: 13px;">Finish</button>`;
                    document.getElementById("ribbon-finish-btn-inline").onclick = async (e) => {
                        e.stopPropagation();
                        localStorage.removeItem(this.ribbonStateKey);
                        hideRibbon();
                        
                        this.toggleLoadingScreen(true, "Synchronizing Candidates...");
                        try {
                            const config = this.config();
                            // FORCE: Get the Org ID directly from the active graph data to prevent ID mismatch
                            const orgId = config.data.graphData[0]?.kvdrOrgConfigData?.organizationId || config.id;
                            const token = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt');

                            // 1. Fetch the master list
                            const res = await fetch(`https://api-core-gateway.getboarded.com/organization/employees/${orgId}`, {
                                headers: { 'Authorization': `Bearer ${token}` }
                            });
                            
                            if (res.ok) {
                                const json = await res.json();
                                if (json.data) {
                                    // FIX: Map 'profilePictureUrl' to 'imageUrl' so images don't break
                                    config.candidateList = json.data.map(emp => ({
                                        id: emp.userId,
                                        name: `${emp.userData.firstName} ${emp.userData.lastName}`,
                                        email: emp.userData.email,
                                        // PREPEND THE S3 BUCKET URL HERE
                                        imageUrl: emp.userData.profilePictureUrl 
                                            ? `https://getboarded-files.s3.ap-south-1.amazonaws.com/editor/profile-pictures/${emp.userData.profilePictureUrl}`
                                            : `https://hostedboringavatars.vercel.app/api/beam?name=${emp.userData.firstName}`
                                    }));
                                }
                            }

                            // 2. Re-fetch chart structure
                            const query = `kvdrId=${config.id}`;
                            let chartRes = await config.onNodeFetch(query);
                            config.data.graphData = chartRes.data || chartRes;

                            // 3. RE-RENDER COMPLETELY
                            this.createKVDR(config);

                            // 4. Update the Talent Pool Page (Vuex)
                            document.dispatchEvent(new CustomEvent('request-talentpool-refresh'));

                        } catch (err) {
                            console.error("Sync Failed:", err);
                        } finally {
                            this.toggleLoadingScreen(false);
                        }
                    };
                }
            } else {
                if (actionZone.innerHTML !== "") actionZone.innerHTML = "";
            }
        }
    }

    openResumeUploadModal() {
        // --- BULLETPROOF ID RESOLUTION FOR MODAL ---
        const actualOrgId = this.getActualOrgId(); 
        let kvdrId = "";
        
        const gData = this.config().data?.graphData;
        if (Array.isArray(gData) && gData.length > 0) {
            const firstValid = gData.find(n => n.kvdrId);
            if (firstValid) kvdrId = firstValid.kvdrId;
        }
        
        if (!kvdrId || kvdrId === 'undefined') {
            kvdrId = this.config().id;
        }

        if (!kvdrId || kvdrId === 'undefined' || !/^[a-fA-F0-9]{24}$/.test(kvdrId)) {
            kvdrId = actualOrgId;
        }

        const stateKey = `resume_upload_state_${actualOrgId}`;
        const API_TOKEN = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt') || "";
        
        const state = { localBatchIds: [], batchesData: {}, uploadQueue: [], isUploading: false, pollingInterval: null, isSilentMode: false }; 
        if (!document.getElementById('resume-modal-styles')) {
            const css = `
                .resume-drop-zone { border: 2px dashed #e2e8f0; border-radius: 12px; background: #f8fafc; display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 250px; cursor: pointer; transition: all 0.3s; }
                .resume-drop-zone:hover, .resume-drop-zone.dragover { background: #f1f5f9; border-color: #94a3b8; }
                .resume-file-list { max-height: 300px; overflow-y: auto; padding-right: 5px; margin-top: 15px; }
                .resume-file-item { padding: 10px 0; border-bottom: 1px solid #f1f1f1; }
                .resume-progress-track { width: 100%; height: 6px; background: #f0f2f5; border-radius: 3px; margin-top: 6px; overflow: hidden; }
                .resume-progress-fill { height: 100%; transition: width 0.3s ease; }
                .bg-success { background-color: #28c76f !important; } .bg-danger { background-color: #ea5455 !important; } .bg-warning { background-color: #ff9f43 !important; }
                .text-success { color: #28c76f; } .text-danger { color: #ea5455; }
            `;
            const style = document.createElement('style');
            style.id = 'resume-modal-styles';
            style.innerHTML = css;
            document.head.appendChild(style);
        }

        const contentWrapper = Utils.createElem('div');
        Utils.applyStyles(contentWrapper, { width: '100%', height: '100%', display: 'flex', flexDirection: 'column' });
        
        const fileInput = Utils.createElem('input');
        fileInput.type = 'file'; fileInput.multiple = true; fileInput.accept = '.pdf,.doc,.docx,.txt'; fileInput.style.display = 'none';

        const persistState = () => {
            // Save state even if queues are empty so silent mode preference is remembered
            localStorage.setItem(stateKey, JSON.stringify({ localBatchIds: state.localBatchIds, batchesData: state.batchesData, uploadQueue: state.uploadQueue, isSilentMode: state.isSilentMode, timestamp: Date.now() }));
        };

        const loadState = () => {
            try {
                const saved = localStorage.getItem(stateKey);
                if (!saved) return;
                const parsed = JSON.parse(saved);
                if (Date.now() - (parsed.timestamp || 0) > 3600000) { localStorage.removeItem(stateKey); return; }
                
                // Load silent mode preference FIRST
                state.isSilentMode = parsed.isSilentMode || false;
                
                const statuses = Object.values(parsed.batchesData || {}).map(b => b.status);
                const allDone = statuses.length > 0 && statuses.every(s => ['completed', 'failed', 'completed_with_errors'].includes(s));
                if (allDone) { 
                    // Keep the silent mode preference even if we clear the rest of the queue
                    localStorage.setItem(stateKey, JSON.stringify({ isSilentMode: state.isSilentMode, timestamp: Date.now() }));
                    return; 
                }
                
                state.localBatchIds = parsed.localBatchIds || [];
                state.batchesData = parsed.batchesData || {};
                state.uploadQueue = parsed.uploadQueue || [];
            } catch (e) { console.error("State Load Error", e); }
        };

        const getAggregatedStatus = () => {
            let totalFiles = 0, processed = 0, files = {}, batchStatuses = [];
            state.localBatchIds.forEach(bid => {
                const data = state.batchesData[bid];
                if (data) {
                    totalFiles += (data.total_files || 0); processed += (data.processed_count || 0);
                    if (data.files) Object.assign(files, data.files);
                    batchStatuses.push(data.status);
                }
            });
            state.uploadQueue.forEach(q => {
                q.files.forEach(f => { files[`(Queue) ${f.name}`] = { status: 'queued', progress: 0 }; totalFiles++; });
                batchStatuses.push('pending');
            });
            const isComplete = state.localBatchIds.length > 0 && state.uploadQueue.length === 0 && batchStatuses.every(s => ['completed', 'failed', 'completed_with_errors'].includes(s));
            return { totalFiles, processed, files, isComplete };
        };

        const handleFiles = (fileList) => {
            const valid = Array.from(fileList).filter(f => ['.pdf', '.doc', '.docx', '.txt'].some(ext => f.name.toLowerCase().endsWith(ext)));
            if (valid.length === 0 || valid.length > 10) { this.showToast("Invalid files. Check formats and limit (max 10).", "error"); return; }
            state.uploadQueue.push({ files: valid, tempId: Date.now() });
            renderUI(); processQueue();
        };

        const processQueue = async () => {
            if (state.uploadQueue.length === 0 || state.isUploading) return;
            state.isUploading = true;
            const currentBatch = state.uploadQueue[0];
            
            const formData = new FormData();
            formData.append('api_token', API_TOKEN);
            formData.append('organization_id', actualOrgId); 
            formData.append('kvdr_id', kvdrId); // Strictly passed to API
            formData.append('upload_type', 'applicant'); 

            formData.append('silent_mode', state.isSilentMode);
            
            currentBatch.files.forEach(f => formData.append('files', f));

            try {
                renderUI(); 
                const res = await fetch(`${API_BASE_URL}/upload-resumes-batch/`, { method: 'POST', body: formData });
                const data = await res.json();
                if (!res.ok) throw new Error(data.detail);

                const newId = data.batch_id;
                const fileObj = {};
                currentBatch.files.forEach(f => fileObj[f.name] = { status: 'processing', progress: 5 });

                state.batchesData[newId] = { status: 'processing', total_files: currentBatch.files.length, processed_count: 0, files: fileObj };
                if (!state.localBatchIds.includes(newId)) state.localBatchIds.push(newId);
                
                state.uploadQueue.shift();
                persistState();
                startPolling();
            } catch (e) {
                console.error(e);
                this.showToast(`Upload failed: ${e.message || "Unknown error"}`, "error");
                state.uploadQueue.shift(); 
            } finally {
                state.isUploading = false; processQueue(); renderUI();
            }
        };

        const startPolling = () => {
            if (state.pollingInterval) return;
            state.pollingInterval = setInterval(async () => {
                if (state.localBatchIds.length === 0) return;
                try {
                    const ids = state.localBatchIds.join(',');
                    const res = await fetch(`${API_BASE_URL}/status/multi-batch?batch_ids=${ids}&organization_id=${actualOrgId}`);
                    if (res.ok) {
                        const data = await res.json();
                        if (data.batches) {
                            Object.keys(data.batches).forEach(bid => { state.batchesData[bid] = data.batches[bid]; });
                            persistState(); renderUI();
                            const agg = getAggregatedStatus();
                            if (agg.isComplete) stopPolling();
                        }
                    }
                } catch (e) { console.error("Poll Error", e); }
            }, 2000);
        };

        const stopPolling = () => {
            if (state.pollingInterval) { clearInterval(state.pollingInterval); state.pollingInterval = null; }
        };

        const renderUI = () => {
            contentWrapper.innerHTML = "";
            const agg = getAggregatedStatus();
            const hasActiveUploads = state.localBatchIds.length > 0 || state.uploadQueue.length > 0;

            if (!hasActiveUploads) {
                const dropZone = Utils.createElem('div', ['resume-drop-zone']);
                // 1. Get the translated texts (with fallbacks just in case)
                const textDragDrop = this.translate('orgDashboard.userDashboard.evaluation.draganddrop', 'Drag & Drop Resumes Here');
                const textClickSelect = this.translate('orgDashboard.userDashboard.evaluation.clicktoselect', 'or click to select files');

                // 2. Inject them into your HTML
                dropZone.innerHTML = `<div style="pointer-events:none; text-align:center;"><p style="font-weight:600; font-size:18px; color:#333;">${textDragDrop}</p><p style="font-size:14px; color:#888; margin-top:5px;">${textClickSelect}</p></div>`;
                // 1. Get the translations
                const textSupported = this.translate('orgDashboard.userDashboard.evaluation.supportedfiles', 'Supported: PDF, DOC, DOCX, TXT');
                const textMaxFile = this.translate('orgDashboard.userDashboard.evaluation.maxfile', 'Max 10 files per upload.');

                // 2. Pass the combined HTML to Utils.createElem
                const meta = Utils.createElem('div', [], '', `<p>${textSupported}</p><p>${textMaxFile}</p>`);                Utils.applyStyles(meta, { textAlign: 'center', marginTop: '15px', fontSize: '12px', color: '#999' });

                dropZone.addEventListener('click', () => fileInput.click());
                dropZone.addEventListener('dragover', (e) => { e.preventDefault(); dropZone.classList.add('dragover'); });
                dropZone.addEventListener('dragleave', (e) => { e.preventDefault(); dropZone.classList.remove('dragover'); });
                dropZone.addEventListener('drop', (e) => { e.preventDefault(); dropZone.classList.remove('dragover'); if (e.dataTransfer.files) handleFiles(e.dataTransfer.files); });
                contentWrapper.append(dropZone, meta);
            } else {
                const header = Utils.createElem('div');
                Utils.applyStyles(header, { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', borderBottom: '1px solid #eee', paddingBottom: '10px' });
                
                let totalProgressSum = 0;
                Object.values(agg.files).forEach(f => {
                    if (f.status === 'completed' || f.status === 'processed_and_emailed' || f.status === 'failed') totalProgressSum += 100;
                    else totalProgressSum += (f.progress || 0);
                });
                const percent = agg.totalFiles > 0 ? Math.floor(totalProgressSum / agg.totalFiles) : 0;
                
                // 1. Fetch all needed translations
                const tComplete = this.translate('orgDashboard.userDashboard.evaluation.processingComplete', 'Processing Complete');
                const tProcessing = this.translate('orgDashboard.userDashboard.evaluation.processing', 'Processing...');
                const tProcessed = this.translate('orgDashboard.userDashboard.evaluation.processed', 'processed');
                const tQueued = this.translate('orgDashboard.userDashboard.evaluation.batchedqueued', 'batch(es) queued...');
                const tTotalProg = this.translate('orgDashboard.userDashboard.evaluation.totalprogress', 'TOTAL PROGRESS');

                // 2. Build the HTML using the variables
                header.innerHTML = `
                    <div>
                        <h4 style="font-weight:bold; margin:0; color:#333;">
                            ${agg.isComplete ? tComplete : tProcessing}
                        </h4>
                        <p style="font-size:13px; color:#666; margin:5px 0 0;">
                            ${agg.processed} / ${agg.totalFiles} ${tProcessed}
                        </p>
                        ${state.uploadQueue.length > 0 ? 
                            `<p style="font-size:11px; color:#ff9f43; margin-top:4px;">
                                <b>${state.uploadQueue.length}</b> ${tQueued}
                            </p>` : ''
                        }
                    </div>
                    <div style="text-align:right;">
                        <span style="font-size:11px; color:#888; display:block;">${tTotalProg}</span>
                        <span style="font-size:32px; font-weight:bold; color:#28c76f;">
                            ${agg.isComplete ? 100 : percent}%
                        </span>
                    </div>`;
                const fileListContainer = Utils.createElem('div', ['resume-file-list']);
                Object.entries(agg.files).forEach(([filename, fileData]) => {
                    const item = Utils.createElem('div', ['resume-file-item']);
                    let statusColor = 'bg-warning', statusText = `${Math.floor(fileData.progress || 0)}%`, barWidth = fileData.progress || 0;
                    if (fileData.status === 'completed' || fileData.status === 'processed_and_emailed') { statusColor = 'bg-success'; statusText = 'DONE'; barWidth = 100; } 
                    else if (fileData.status === 'failed') { statusColor = 'bg-danger'; statusText = 'FAILED'; barWidth = 100; } 
                    else if (fileData.status === 'queued') { statusColor = 'bg-gray-300'; statusText = 'WAITING'; barWidth = 0; }

                    item.innerHTML = `<div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:5px;"><div style="display:flex; align-items:center; overflow:hidden;"><span style="font-size:13px; font-weight:500; color:#444; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:280px;" title="${filename}">${filename}</span></div><span class="${statusColor === 'bg-success' ? 'text-success' : statusColor === 'bg-danger' ? 'text-danger' : 'text-warning'}" style="font-size:11px; font-weight:bold;">${statusText}</span></div><div class="resume-progress-track"><div class="resume-progress-fill ${statusColor}" style="width: ${barWidth}%;"></div></div>`;
                    fileListContainer.append(item);
                });

                const footer = Utils.createElem('div');
                Utils.applyStyles(footer, { marginTop: '20px', display: 'flex', flexDirection: 'column', gap: '10px' });

                if (!agg.isComplete) {
                    // 1. Upload more button
                    const uploadMoreBtn = Utils.createElem('button', [], '', state.isUploading ? 'Uploading Batch...' : 'Upload More Resumes');
                    Utils.applyStyles(uploadMoreBtn, { width: '100%', padding: '10px', borderRadius: '20px', border: '2px solid #FFC107', background: 'transparent', color: '#FFC107', fontWeight: 'bold', cursor: state.isUploading ? 'not-allowed' : 'pointer', opacity: state.isUploading ? '0.6' : '1' });
                    if (!state.isUploading) uploadMoreBtn.onclick = () => fileInput.click();

                    // 2. Hide button (This is what the user should use while processing)
                    const hideBtn = Utils.createElem('div', [], '', 'Hide & Process in Background');
                    Utils.applyStyles(hideBtn, { textAlign: 'center', fontSize: '12px', color: '#999', cursor: 'pointer', textDecoration: 'underline' });
                    hideBtn.onclick = () => { 
                        document.querySelector(".organiGramPopup.resume-upload-view")?.remove(); 
                        document.getElementById("back-drop-overlay").style.display = "none"; 
                        if (typeof isViewportActive !== 'undefined') isViewportActive.status = true; 
                    };
                    
                    footer.append(uploadMoreBtn, hideBtn);
                    // ORANGE FINISH BUTTON REMOVED FROM HERE
                } else {
                    // This is the SUCCESS finish button (appears only at 100%)
                    const finishBtn = Utils.createElem('button', [], '', 'Finish');
                    Utils.applyStyles(finishBtn, { width: '100%', padding: '12px', borderRadius: '6px', background: '#FF9F43', color: '#fff', fontWeight: 'bold', border: 'none', cursor: 'pointer' });
                    
                    finishBtn.onclick = async () => { 
                        stopPolling(); 
                        localStorage.removeItem(stateKey); 
                        document.querySelector(".organiGramPopup.resume-upload-view")?.remove(); 
                        document.getElementById("back-drop-overlay").style.display = "none"; 
                        if (typeof isViewportActive !== 'undefined') isViewportActive.status = true; 
                        
                        this.showToast("Import Complete", "success"); 

                        // Trigger the Talent Pool Auto-Refresh
                        this.toggleLoadingScreen(true, "Synchronizing Talent Pool...");
                        try {
                            await this.fetchOrgConfig();
                            const config = this.config();
                            const query = `kvdrId=${config.id}`; 
                            let response = await config.onNodeFetch(query);
                            let freshData = (response && response.data) ? response.data : response;

                            if (Array.isArray(freshData)) {
                                config.data.graphData = freshData.map(node => {
                                    if (node.kvdrRoleProfiles && (!node.profiles || node.profiles.length === 0)) {
                                        node.profiles = node.kvdrRoleProfiles;
                                    }
                                    return node;
                                });
                                this.createKVDR(config);
                            }
                            // Notify other tabs (Talent Pool Page)
                            document.dispatchEvent(new CustomEvent('request-talentpool-refresh'));
                        } catch (err) {
                            console.error("Refresh Error:", err);
                        } finally {
                            this.toggleLoadingScreen(false);
                        }
                    };
                    footer.append(finishBtn);
                }
                contentWrapper.append(header, fileListContainer, footer);
            }
        };

        loadState();
        if (state.localBatchIds.length > 0) startPolling();
        renderUI();

        fileInput.onchange = (e) => { if(e.target.files) handleFiles(e.target.files); fileInput.value = ''; };

        const silentModeToggle = Utils.createElem("div");
        Utils.applyStyles(silentModeToggle, { cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.2s ease", marginRight: "10px" });
        
        const renderBell = () => {
            silentModeToggle.style.color = state.isSilentMode ? '#ff9f43' : '#a0a0a0';
            silentModeToggle.title = state.isSilentMode ? 'Silent Mode On (No Emails)' : 'Silent Mode Off (Emails Active)';
            if (state.isSilentMode) {
                silentModeToggle.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M13.73 21a2 2 0 0 1-3.46 0"></path><path d="M18.63 13A17.89 17.89 0 0 1 18 8"></path><path d="M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14"></path><path d="M18 8a6 6 0 0 0-9.33-5"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>`;
            } else {
                silentModeToggle.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>`;
            }
        };
        renderBell(); // Init icon
        
        silentModeToggle.addEventListener('click', (e) => {
            e.stopPropagation();
            state.isSilentMode = !state.isSilentMode;
            persistState();
            renderBell();
        });

        // --- INJECT INTO POPUP CONFIG ---
        const popupConfig = {
            headerText: this.translate('orgDashboard.userDashboard.evaluation.importResumes'),
            headerRightControlls: silentModeToggle, // <--- MAGIC HAPPENS HERE
            onCloseClick: () => { document.querySelector(".organiGramPopup.resume-upload-view")?.remove(); document.getElementById("back-drop-overlay").style.display = "none"; if (typeof isViewportActive !== 'undefined') isViewportActive.status = true; },
            data: contentWrapper, displaySettings: { width: "500px", height: "auto" }, footer: ""
        };

        const popup = this.createPopup(popupConfig);
        popup.classList.add("resume-upload-view");
        const bodyPart = popup.querySelector('.OrganiGramPopupBody');
        if(bodyPart) { bodyPart.style.padding = "20px"; }

        const backdrop = document.getElementById("back-drop-overlay");
        backdrop.innerHTML = ""; backdrop.style.display = "flex"; backdrop.append(popup);
    }

        
    delNodeKVDR(data) {
    const { target, deleteNode, deleteProfile, popupBody, displaySettings } = data;

    const childNodes = target.childNodes;
    const subRoles = Array.from(childNodes).filter((node) => node.matches("div.member"));
    const assignedCount = target.dataset.selectedUsr ? target.dataset.selectedUsr.split(',').filter(Boolean).length : 0;

    const clearPopup = () => {
        popupBody.style.display = "none";
        popupBody.innerHTML = "";
        if (typeof isViewportActive !== 'undefined') isViewportActive.status = true;
    };

    const handleDeletion = () => {
        target.remove();
        const nodes = [...subRoles, target];
        const empIds = nodes.map((e) => e.dataset.empid);
        deleteNode(empIds); 
        clearPopup();
    };

    Utils.playBellSound(1000, 990, 'sine');

    const confirmBtn = Utils.createElem("button", ["popup-confirm-btn"], "", "Confirm Delete");
    Utils.applyStyles(confirmBtn, {
        border: "none",
        background: "#dc3545",
        color: "#fff",
        padding: "10px 18px",            
        fontSize: "14px",
        fontWeight: "600",
        cursor: "pointer",
        borderRadius: "8px",             
        boxShadow: "0 4px 12px rgba(220,53,69,0.12)", 
        outline: "none"
    });
    confirmBtn.addEventListener("click", handleDeletion);

    const footerWrapper = Utils.createElem("div");
    Utils.applyStyles(footerWrapper, {
        display: "flex",
        justifyContent: "flex-end",
        padding: "14px 18px",
        borderTop: "1px solid rgba(0,0,0,0.06)",
        boxSizing: "border-box",
        width: "100%",
        background: "transparent"
    });
    footerWrapper.appendChild(confirmBtn);

    const messageContainer = Utils.createElem("div");
    Utils.applyStyles(messageContainer, { 
        padding: "18px 20px", 
        textAlign: "left",         
        alignItems: "flex-start",
        color: "#444", 
        fontSize: "14px", 
        lineHeight: "1.6",
        fontFamily: "inherit",
        display: "block",
        width: "100%",
        boxSizing: "border-box"
    });

    let contentHTML = "";

    // 1. Fetch Common Translations
const tActionWarning = this.translate('orgDashboard.userDashboard.evaluation.thisactioncannotbeundone', 'This action cannot be undone.');

if (subRoles.length > 0) {
    // Sub-role Scenario
    const tSubTitle = this.translate('orgDashboard.userDashboard.evaluation.subroles', 'Sub-roles detected');
    const tRoleHas = this.translate('orgDashboard.userDashboard.evaluation.thisrolehassubroles', 'This role has');
    const tConnSub = this.translate('orgDashboard.userDashboard.evaluation.connectedsubrole', 'connected sub-role(s).');
    const tDeleteWarn2 = this.translate('orgDashboard.userDashboard.evaluation.deletewarning2', 'Deleting this role will permanently remove all sub-roles and unassign all candidates.');

    contentHTML = `
        <div style="display:flex; gap:14px; padding:14px; border-radius:10px; background:#fdecea; align-items:flex-start; text-align:left;">
            <span style="font-size:24px; line-height:1; color:#d32f2f; margin-top:2px;">⚠️</span>
            <div style="min-width:0; text-align:left;">
                <h3 style="margin:0 0 6px; font-size:17px; font-weight:600; color:#b71c1c;">${tSubTitle}</h3>
                <p style="margin:0; font-size:14px; color:#c62828; line-height:1.4; overflow-wrap:break-word; text-align:left;">
                    ${tRoleHas} <b>${subRoles.length}</b> ${tConnSub}
                </p>
            </div>
        </div>
        <p style="margin:14px 0 0; font-size:14px; color:#555; line-height:1.6; text-align:left;">${tDeleteWarn2}</p>
        <p style="margin-top:10px; font-size:14px; font-weight:600; color:#333;">${tActionWarning}</p>
    `;
} else if (assignedCount > 0) {
    // Active Assignments Scenario
    const tActiveTitle = this.translate('orgDashboard.userDashboard.evaluation.activeassignments', 'Active assignments');
    const tAssignedCand = this.translate('orgDashboard.userDashboard.evaluation.assignedcandidates', 'candidate(s) are currently assigned.');
    const tDeleteWarn1 = this.translate('orgDashboard.userDashboard.evaluation.deletewarning1', 'Deleting this role will remove all assignments from the organization chart.');

    contentHTML = `
        <div style="display:flex; gap:14px; padding:14px; border-radius:10px; background:#fff4e5; align-items:flex-start; text-align:left;">
            <span style="font-size:24px; line-height:1; color:#f57c00; margin-top:2px;">⚠️</span>
            <div style="min-width:0; text-align:left;">
                <h3 style="margin:0 0 6px; font-size:17px; font-weight:600; color:#e65100;">${tActiveTitle}</h3>
                <p style="margin:0; font-size:14px; color:#ef6c00; line-height:1.4; overflow-wrap:break-word; text-align:left;">
                    <b>${assignedCount}</b> ${tAssignedCand}
                </p>
            </div>
        </div>
        <p style="margin:14px 0 0; font-size:14px; color:#555; line-height:1.6;">${tDeleteWarn1}</p>
        <p style="margin-top:10px; font-size:14px; font-weight:600; color:#333;">${tActionWarning}</p>
    `;
} else {
    // Generic Delete Scenario
    const tDeleteTitle = this.translate('orgDashboard.userDashboard.evaluation.deleterole', 'Delete role?');
    const tDeleteMsg = this.translate('orgDashboard.userDashboard.evaluation.deletewarning1', 'This role will be removed from the organization chart.');

    contentHTML = `
        <div style="display:flex; gap:14px; padding:14px; border-radius:10px; background:#f5f5f5; align-items:flex-start; text-align:left;">
            <span style="font-size:24px; line-height:1; color:#616161; margin-top:2px;">⚠️</span>
            <div style="min-width:0; text-align:left;">
                <h3 style="margin:0 0 6px; font-size:17px; font-weight:600; color:#424242;">${tDeleteTitle}</h3>
                <p style="margin:0; font-size:14px; color:#616161; line-height:1.4; overflow-wrap:break-word; text-align:left;">${tDeleteMsg}</p>
            </div>
        </div>
        <p style="margin-top:14px; font-size:14px; font-weight:600; color:#333;">${tActionWarning}</p>
    `;
}

    messageContainer.innerHTML = contentHTML;

    const confirmPromptData = {
        headerText: this.translate('orgDashboard.userDashboard.evaluation.deleteconfirmation'),
        onCloseClick: clearPopup,
        data: messageContainer,
        footer: footerWrapper,
        displaySettings: {
            ...displaySettings,
            width: "520px",    
            height: "auto",
            cc: displaySettings.cc,
            tc: displaySettings.tc
        },
    };

    const popupData = this.createPopup(confirmPromptData);
    popupBody.append(popupData);
    popupBody.style.display = "flex";
    popupBody.dataset.selectedNode = target.dataset.empid;
}

    
    importNodeKVDR(nodeData, popupBody) {
        // --- FIX: Filter out removed/inactive ghost users ---
        const rawProfiles = nodeData.profiles || nodeData.kvdrRoleProfiles || [];
        const profiles = rawProfiles.filter(p => {
            // 1. Check if the role assignment itself is dead (ADDED 'deactivated')
            if (p.isActive === false || p.isDeleted === true || (p.status && ['inactive', 'deleted', 'removed', 'deactivated'].includes(String(p.status).toLowerCase()))) return false;
            
            // 2. Cross-reference with the main org talent pool
            const cand = nodeData.candidateList?.find(c => String(c.id) === String(p.userId));
            if (!cand) return false; // Ghost user, no longer in org
            
            // 3. Is the user marked as inactive in the main talent pool? (ADDED 'deactivated')
            if (cand.isActive === false || cand.isDeleted === true || (cand.status && ['inactive', 'deleted', 'removed', 'deactivated'].includes(String(cand.status).toLowerCase()))) return false;
            if (cand.userData && (cand.userData.isActive === false || cand.userData.isDeleted === true || (cand.userData.status && ['inactive', 'deleted', 'removed', 'deactivated'].includes(String(cand.userData.status).toLowerCase())))) return false;

            return true; // Keep active users
        });

        // 🚀 CRITICAL FIX: Overwrite the nodeData arrays so the deactivated user 
        // does NOT get passed into the Vue "Edit Role" modal!
        nodeData.profiles = profiles;
        nodeData.kvdrRoleProfiles = profiles;

        const container = Utils.createElem("div", ["member"], `${nodeData._id}`, "", { "data-empid": nodeData.selfId, "data-parentid": nodeData.parentId });
        container.dataset.selectedUsr = profiles.map((c) => c.userId).join(",") || "";
        container.addEventListener("click", (event) => event.preventDefault());

        const selectedUserBox = Utils.createElem("span", ["selectedUsrBox"]);
        Utils.applyStyles(selectedUserBox, { display: "flex", margin: "10px 5px", alignItems: "center" });

        // Add User Button Logic
        if (this.can('addProfile') && nodeData.status === 'published') {
            const addUserIcon = Utils.createElem("i", ["vs-icon", "notranslate", "icon-scale", "feather", "icon-plus"]);
            Utils.applyStyles(addUserIcon, { fontSize: "20px", color: "#000" });
            const addUserButton = Utils.createElem("button", ["openUsrListBtn"]);
            Utils.applyStyles(addUserButton, { border: "1px solid #ddd ", background: "#fff", cursor: "pointer", margin: "0 0 0 8px", borderRadius: "50%", width: "32px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center", position: "relative", padding: "0" });
            addUserButton.addEventListener('mouseenter', () => addUserButton.style.borderColor = "#999");
            addUserButton.addEventListener('mouseleave', () => addUserButton.style.borderColor = "#ddd");
            this.attachTooltip(addUserButton, this.translate('orgDashboard.userDashboard.evaluation.addteammember'));
            addUserButton.append(addUserIcon);
            const notifyDot = Utils.createElem("span", ["suggestionDot"], "", "");
            Utils.applyStyles(notifyDot, { position: "absolute", top: "-2px", right: "-2px", width: "8px", height: "8px", backgroundColor: "#ff4444", borderRadius: "50%", border: "1px solid white", display: "none", zIndex: "10" });
            addUserButton.append(notifyDot);
            addUserButton.dataset.orgId = this.getActualOrgId();
            addUserButton.dataset.roleId = nodeData.selfId;
            addUserButton.dataset.dot = notifyDot;
            this.observer.observe(addUserButton);
            addUserButton.addEventListener("click", (event) => {
                event.preventDefault(); 
                event.stopImmediatePropagation();

                // THIS IS THE CORRECT, UNCONDITIONAL LOGIC.
                // It will now ALWAYS open the "Add Team Member" list, as it should.
                const popupConfig = {
                    headerText: this.translate('orgDashboard.userDashboard.evaluation.addteammember'),
                    onCloseClick: () => { document.querySelectorAll('.custom-suggestion-tooltip').forEach(el => el.remove()); event.stopPropagation(); popupBody.style.display = "none"; popupBody.innerHTML = ""; isViewportActive.status = true; },
                    data: this._popupUsrListCollection(event, nodeData, popupBody),
                    displaySettings: nodeData.displaySettings, footer: "",
                };
                const popup = this.createPopup(popupConfig);
                nodeData.addUsersToDesig(popup);
            });

            selectedUserBox.append(addUserButton);
        }

        const exData = {
            _localNodeData: nodeData,
            kvdrRoleId: nodeData.selfId, candidateList: nodeData.candidateList, kvdrOrgConfigData: nodeData.data.kvdrOrgConfigData,
            removeProfile: (payload) => {
                // 1. Trigger API Call
                nodeData.onNodeRemoveProfileClick(payload);

                // 2. DOM Cleanup: Remove avatar from the Role Card (container) directly
                // 'container' is available in this scope from importNodeKVDR
                const userId = payload.userId;
                
                // Update the dataset list of users
                if (container.dataset.selectedUsr) {
                    let sUsers = container.dataset.selectedUsr.split(",");
                    sUsers = sUsers.filter(id => id !== userId); // Remove ID
                    container.dataset.selectedUsr = sUsers.join(",");
                }

                // Find and remove the specific user image
                // We use the ID we assigned during creation: `img-${userId}`
                const userImg = container.querySelector(`#img-${userId}`);
                if (userImg) userImg.remove();
                
                // 3. Close the Popup Cleanly
                popupBody.innerHTML = "";
                popupBody.style.display = "none";
                
                // 4. Re-enable viewport interactions
                if (typeof isViewportActive !== 'undefined') isViewportActive.status = true;

                // 5. Success Sound/Toast (Optional)
                if (typeof Utils.playBellSound === 'function') Utils.playBellSound(1000, 990, 'sine');
            },
            // ------------------------------------

            profileData: async (t) => { return nodeData.onNodeProfileFetch(t) },
            profileUpdate: async (t) => { return nodeData.onNodeProfileUpdate(t) },
            roleData: async (t) => { return nodeData.onNodeFetch(t) },
            roleUpdate: async (t) => { return nodeData.onNodeUpdate(t) },
            displaySettings: nodeData.displaySettings,
        };

        if (profiles.length) {
            profiles.forEach(candidate => {
                const userId = candidate.userId;
                const profile = nodeData.candidateList.find(c => c.id === userId);
                if (profile) {
                    const userImg = Utils.createElem("img", ["selectedUsrImg"], `img-${userId}`, "", { src: profile.imageUrl });
                    Utils.applyStyles(userImg, { position: "relative", marginLeft: "-5px", width: "32px", height: "32px", objectFit: "cover", objectPosition: "center", border: "2px solid", borderRadius: "50%", });
                    const hoverName = profile.name || profile.firstName || profile.fullName || (profile.email ? profile.email.split('@')[0] : "User Profile");
                    this.attachTooltip(userImg, hoverName);
                    userImg.addEventListener("click", (evt) => {
                        evt.preventDefault();
                        evt.stopPropagation();
                        this.expandRole(exData, "Talent", [userId]);
                    });
                    selectedUserBox.prepend(userImg);
                }
            });
        }

        const roleDisplayTitle = nodeData.level ? `${nodeData.title} ${nodeData.level}` : nodeData.title;
        const title = Utils.createElem("i", ["role-card-title"], "", roleDisplayTitle, { contentEditable: "false" });
        Utils.applyStyles(title, { display: "flex", alignItems: "center", marginRight: "0px", color: nodeData.tc, paddingRight: "20px", cursor: "default" });
        
        const titleWrapper = Utils.createElem("div");
        Utils.applyStyles(titleWrapper, { display: "flex", alignItems: "center" });
        titleWrapper.append(title,selectedUserBox);
        this.attachTooltip(titleWrapper, this.getRoleTooltipText(nodeData));

        const deleteBtnWrapper = Utils.createElem("div", ["delNodeBtnBox", "node-action-icon"]);
        if(this.can("delRole") && nodeData.status === 'published'){
            const deleteBtn = Utils.createElem("i", ["delNodeBtn", "vs-icon", "notranslate", "icon-scale", "feather", "icon-x"], "", "");
            Utils.applyStyles(deleteBtn, { cursor: "pointer", fontSize: "14px", color: "#555" }); 
            
            this.attachTooltip(deleteBtn, this.translate('orgDashboard.userDashboard.evaluation.deleterole'));

            deleteBtn.addEventListener("click", () =>
                this.delNodeKVDR({ target: container, deleteNode: (t) => nodeData.onNodeDelClick(t), deleteProfile: (t) => nodeData.onNodeRemoveProfileClick(t), popupBody: popupBody, displaySettings: nodeData.displaySettings, })
            );
            Utils.applyStyles(deleteBtnWrapper, { position: "absolute", top: "5px", right: "5px", zIndex: "5", lineHeight: "0" });
            deleteBtnWrapper.append(deleteBtn);
        }

        const footerLeft = Utils.createElem("div", ["roleFooterLeft"]);
        if (this.can('editTitle') && nodeData.status === 'published') {
            // CHANGE 1: Removed 'node-action-icon' from the initial creation classes here.
            // We will let updateLockVisuals manage this class dynamically.
            const hiringLockBtn = Utils.createElem("i", ["hiringLockBtn", "vs-icon", "notranslate", "icon-scale", "feather"], "", "");
            
            // CONSTANT FOR STORAGE
            const LOCK_FLAG = "[OPEN_HIRING]";

            // 1. DETERMINE STATE FROM softSkills ARRAY
            let currentSoftSkills = Array.isArray(nodeData.softSkills) ? [...nodeData.softSkills] : [];
            let isHiring = currentSoftSkills.includes(LOCK_FLAG);

            const updateLockVisuals = (isOpen) => {
                hiringLockBtn.classList.remove("icon-lock", "icon-unlock");
                hiringLockBtn.classList.add(isOpen ? "icon-unlock" : "icon-lock");
                hiringLockBtn.style.color = isOpen ? "#28c76f" : "#333"; 
                hiringLockBtn.dataset.tooltipText = isOpen ? this.translate('orgDashboard.userDashboard.evaluation.openrole') : this.translate('orgDashboard.userDashboard.evaluation.closedrole');

                // --- FIX START: VISIBILITY LOGIC ---
                if (isOpen) {
                    // If Hiring is Enabled: 
                    // Remove the hover class so it is ALWAYS visible.
                    hiringLockBtn.classList.remove("node-action-icon");
                    hiringLockBtn.style.opacity = "1";
                    hiringLockBtn.style.visibility = "visible";
                } else {
                    // If Hiring is Disabled: 
                    // Add the hover class so it is HIDDEN by default (appears only on hover).
                    hiringLockBtn.classList.add("node-action-icon");
                    // Reset inline styles to let CSS hover effects take over
                    hiringLockBtn.style.opacity = "";
                    hiringLockBtn.style.visibility = "";
                }
                // --- FIX END ---
            };

            // Init Visuals
            updateLockVisuals(isHiring);

            Utils.applyStyles(hiringLockBtn, { 
                fontSize: "13px", 
                position: "absolute", 
                left: "0px", 
                bottom: "0px", 
                cursor: "pointer",
                padding: "2px"
            });

            // Dynamic Tooltip
            hiringLockBtn.addEventListener('mouseenter', () => {
                const text = hiringLockBtn.dataset.tooltipText;
                const tip = document.createElement('div');
                tip.className = 'organigram-custom-tooltip';
                tip.innerText = text;
                document.body.appendChild(tip);
                
                const rect = hiringLockBtn.getBoundingClientRect();
                const top = rect.top - tip.offsetHeight - 5; 
                const left = rect.left + (rect.width / 2);
                tip.style.top = top + 'px';
                tip.style.left = left + 'px';
            });
            hiringLockBtn.addEventListener('mouseleave', () => {
                document.querySelectorAll('.organigram-custom-tooltip').forEach(el => el.remove());
            });

            // Toggle Handler
            hiringLockBtn.addEventListener("click", async (e) => {
                e.preventDefault();
                e.stopPropagation();

                // Toggle logic
                isHiring = !isHiring;
                updateLockVisuals(isHiring);
                
                // Remove tooltip immediately on click to prevent obstruction
                document.querySelectorAll('.organigram-custom-tooltip').forEach(el => el.remove());

                // UPDATE DATA ARRAY
                if (isHiring) {
                    if (!currentSoftSkills.includes(LOCK_FLAG)) currentSoftSkills.push(LOCK_FLAG);
                } else {
                    currentSoftSkills = currentSoftSkills.filter(skill => skill !== LOCK_FLAG);
                }

                // Update Local Node Data reference immediately
                nodeData.softSkills = currentSoftSkills;
                const localNode = safeGraphData(this.config()).find(n => n.selfId === nodeData.selfId);
                if(localNode) localNode.softSkills = currentSoftSkills;

                try {
                    // SAVE TO BACKEND via existing update function
                    await nodeData.onNodeUpdate({ 
                        query: nodeData.selfId, 
                        data: { softSkills: currentSoftSkills } 
                    });
                    
                    if (typeof Utils.playBellSound === 'function') Utils.playBellSound(800, 840, 'sine');
                } catch (err) {
                    console.error("Failed to update hiring status", err);
                    // Revert on failure
                    isHiring = !isHiring;
                    updateLockVisuals(isHiring);
                }
            });

            footerLeft.append(hiringLockBtn);
        }
        const footerRight = Utils.createElem("div", ["roleFooterRight"]);
        if(this.can('expandRole') && nodeData.status === 'published'){
            const expandBtn = Utils.createElem("i", ["roleExpandBtn", "vs-icon", "notranslate", "icon-scale", "feather", "icon-edit-2", "node-action-icon"], "", "");
            Utils.applyStyles(expandBtn, { fontSize: "13px", color: "#000", position: "absolute", right: "0px", bottom: "0px", cursor: "pointer", padding: "2px" });
            
            this.attachTooltip(expandBtn, this.translate('orgDashboard.userDashboard.evaluation.editrole'));

            expandBtn.addEventListener("click", async (evClick) => {
                evClick.preventDefault();
                evClick.stopImmediatePropagation();
                
                document.querySelectorAll('.organigram-custom-tooltip').forEach(el => el.remove());
                
                if (this.vueInstance) {
                    this.vueInstance.openVueRoleModal({
                        detail: {
                            mode: 'EDIT',
                            role: nodeData,
                            onSave: async (updatedData) => {
                                try {
                                    // Save directly to FeathersJS
                                    const response = await nodeData.onNodeUpdate({ 
                                        query: nodeData.selfId, 
                                        data: updatedData 
                                    });
                                    
                                    const cardTitle = document.querySelector(`[data-empid='${nodeData.selfId}'] .role-card-title`);
                                    if (cardTitle) {
                                        const displayLevel = updatedData.level !== undefined ? updatedData.level : nodeData.level;
                                        cardTitle.innerText = displayLevel ? `${updatedData.title} ${displayLevel}` : updatedData.title;
                                    }

                                    const localNode = safeGraphData(this.config()).find(n => n.selfId === nodeData.selfId);
                                    if (localNode) {
                                        Object.assign(localNode, updatedData);
                                        Object.assign(nodeData, updatedData);
                                    }
                                    
                                    return response || updatedData;
                                } catch (error) {
                                    console.error("Feathers API Edit Error:", error);
                                    throw error; // Vue will catch this and show the toast!
                                }
                            }
                        }
                    });
                }
            });
            footerRight.append(expandBtn);
        }
        const footer = Utils.createElem("div", ["roleFooter"]);
        Utils.applyStyles(footer, { border: "none", padding: "5px 0", display: "flex", alignItems: "center", justifyContent: "space-between", flex: "1 1 100%", position: "relative" });
        footer.append(footerLeft, footerRight);

        // --- DRAG AND DROP LOGIC STARTS HERE ---
        // --- UPDATED: ADD 'node-hover-target' to this CARD ---
        const card = Utils.createElem("fieldset", ["userCard", "onlyCardType"]);
        
        // Only apply hover effects if it is published
        if (nodeData.status === 'published') card.classList.add("node-hover-target");

        card.addEventListener('click', (event) => {
            // IMPORTANT: Prevent this from firing if an icon inside was clicked
            if (event.target.closest('.delNodeBtnBox') || 
                event.target.closest('.roleExpandBtn') || 
                event.target.closest('.addNodeBtn') || 
                event.target.closest('.selectedUsrBox') ||
                event.target.closest('.hiringLockBtn')) { // <-- Added hiringLockBtn as a safeguard
                return; 
            }
            
            // If the click was on the card itself, open the evaluation matrix for the whole role
            this.expandRole(exData, "ROLE");
        });
        
        // Only allow Drag & Drop if published
        if(this.can("editTitle") && nodeData.status === 'published') { 
            card.draggable = true;
            card.addEventListener("dragstart", (e) => {
                e.stopPropagation();
                e.dataTransfer.setData("text/plain", nodeData.selfId);
                e.dataTransfer.effectAllowed = "move";
                card.style.opacity = "0.6";
                card.classList.add('is-dragging'); 
                window.draggedNodeId = nodeData.selfId; 
            });
            card.addEventListener("dragend", (e) => {
                e.stopPropagation();
                card.style.opacity = "1";
                card.classList.remove('is-dragging'); 
                delete window.draggedNodeId;
                document.querySelectorAll('.drag-over-active').forEach(el => el.classList.remove('drag-over-active'));
            });
            card.addEventListener("dragover", (e) => {
                e.preventDefault(); e.stopPropagation();
                const draggedId = window.draggedNodeId;
                if(draggedId && draggedId !== nodeData.selfId) { card.classList.add('drag-over-active'); }
            });
            card.addEventListener("dragleave", (e) => {
                e.preventDefault(); e.stopPropagation();
                card.classList.remove('drag-over-active');
            });
            card.addEventListener("drop", (e) => {
                e.preventDefault(); e.stopPropagation();
                card.classList.remove('drag-over-active');
                const draggedId = e.dataTransfer.getData("text/plain");
                const targetId = nodeData.selfId;
                if(draggedId === targetId) return;
                const draggedNode = safeGraphData(this.config()).find(n => n.selfId === draggedId);
                const draggedName = draggedNode ? draggedNode.title : "this role";
                this.confirmMovePopup(draggedName, nodeData.title, async () => { await this.handleNodeMove(draggedId, targetId); });
            });
        }
        // --- DRAG AND DROP LOGIC ENDS HERE ---

       Utils.applyStyles(card, { 
            backgroundColor: nodeData.displaySettings.cc, color: nodeData.displaySettings.tc, 
            borderColor: nodeData.displaySettings.bc, flexWrap: "wrap", 
            position: "relative", overflow: "visible !important", transition: "all 0.2s ease",
            cursor: "pointer" // <-- FORCE INLINE
        });
        
        if(this.can("delRole") && nodeData.status === 'published') { card.append(deleteBtnWrapper); }
        card.append(titleWrapper, footer);
        
        const label = Utils.createElem("label", ["emptitle"]);
        Utils.applyStyles(label,{ opacity:nodeData.status=='pending'?'0.5':nodeData.status=='rejected'?'0.2':'1', position: "relative", overflow: "visible !important" })
        label.append(card);

        // ONLY allow adding roles (+) if the current node is published
        let allowAddBtn = false;
        if (nodeData.status === 'published') {
            if (this.can("addRole")) {
                allowAddBtn = true;
            } else if (this.can("addRoleRequest") && nodeData.isCurrentUserNode === true) {
                allowAddBtn = true; // Restores the rule: Users can only add under themselves
            }
        }

        if(allowAddBtn){
            const addNodeBtn = Utils.createElem("div", ["toggleBtn", "addNodeBtn", "node-action-icon"], "", "", {"data-addnode": "true"});
            this.attachTooltip(addNodeBtn, this.can("addRole") ? this.translate('orgDashboard.userDashboard.evaluation.addroles') : this.translate('orgDashboard.userDashboard.evaluation.requestrole'));
            const plusIconImg = Utils.createElem("i", ["vs-icon", "notranslate", "icon-scale", "feather", "icon-plus"]);
            Utils.applyStyles(plusIconImg, { fontSize: "10px", fontWeight: "900", display: "block", color: "#000" })
            addNodeBtn.append(plusIconImg);
            
            addNodeBtn.addEventListener('click',() => this.createNode(nodeData, popupBody));
            
            Utils.applyStyles(addNodeBtn, {
                position: "absolute", bottom: "-32px", left: "50%", transform: "translateX(-50%)",
                background: "#FFFFFF", border: "1px solid #000", borderRadius: "3px",
                width: "14px", height: "14px", display: "flex", justifyContent: "center", 
                alignItems: "center", cursor: "pointer", zIndex: "999",
                filter: "drop-shadow(0px 1px 2px rgba(0,0,0,0.1))", marginLeft: "0" 
            });
            
            card.append(addNodeBtn);
        }
        container.append(label);
        this.counter++;

        return container;
    }

    toggleLoadingScreen(show, message = "Updating Organization...") {
        let loader = document.getElementById('organigram-global-loader');
        
        // --- FIX 1: FORCE COLOR UPDATE ---
        // If the loader already exists, find the spinner and force it to be Yellow
        if (loader) {
            const existingSpinner = loader.querySelector('div');
            if(existingSpinner) {
                existingSpinner.style.borderTop = "5px solid #F2C244"; // Force Yellow
            }
        }

        // Create loader if it doesn't exist
        if (!loader) {
            loader = document.createElement("div");
            loader.id = 'organigram-global-loader';
            
            // Container Styles
            Object.assign(loader.style, {
                position: "fixed", top: "0", left: "0", width: "100%", height: "100%",
                backgroundColor: "rgba(255, 255, 255, 0.85)", zIndex: "99999",
                display: "none", flexDirection: "column", alignItems: "center", justifyContent: "center",
                backdropFilter: "blur(4px)"
            });

            // CSS Spinner
            const spinner = document.createElement("div");
            Object.assign(spinner.style, {
                width: "50px", 
                height: "50px", 
                border: "5px solid #f3f3f3", 
                borderTop: "5px solid #FFC107", // <--- YELLOW COLOR
                borderRadius: "50%",
                animation: "spin 1s linear infinite", 
                marginBottom: "20px"
            });
            
            // Add Animation Keyframes
            if (!document.getElementById('organigram-spinner-style')) {
                const styleSheet = document.createElement("style");
                styleSheet.id = 'organigram-spinner-style';
                styleSheet.innerText = `@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`;
                document.head.appendChild(styleSheet);
            }

            // Text
            const text = document.createElement("h3");
            text.id = 'organigram-loader-text';
            Object.assign(text.style, { color: "#333", fontFamily: "inherit" });

            loader.append(spinner, text);
            document.body.append(loader);
        }

        // Update Text & Visibility
        if (show) {
            document.getElementById('organigram-loader-text').innerText = message;
            loader.style.display = "flex";
        } else {
            loader.style.display = "none";
        }
    }
    async handleNodeMove(draggedId, newParentId) {
        // 1. Circular Check
        const currentData = this.config().data.graphData;
        if (this.isDescendant(draggedId, newParentId, currentData)) {
            this.showToast("Cannot move a role under its own subordinate!", "error");
            return;
        }

        // 2. SHOW LOADING SCREEN
        this.toggleLoadingScreen(true, "Reorganizing Structure...");

        // Backup for rollback
        const originalData = JSON.parse(JSON.stringify(currentData));

        try {
            // 3. API UPDATE (Save to DB)
            const param = { query: draggedId, data: { parentId: newParentId } };
            await this.config().onNodeUpdate(param);

            // 4. DELAY (Wait for DB to settle)
            await new Promise(resolve => setTimeout(resolve, 1500));

            // 5. ATTEMPT FETCH
            let freshData = null;
            try {
                const query = `kvdrId=${this.config().id}`;
                let response = await this.config().onNodeFetch(query);
                if (response && response.data) response = response.data;
                freshData = response;
            } catch (err) {
                console.warn("Fetch failed, switching to local update mode.");
            }

            // 6. INTELLIGENT UPDATE
            if (Array.isArray(freshData) && freshData.length > 0) {
                this.config().data.graphData = freshData;
            } else {
                // Fail-safe: Update locally if server list is empty
                const node = safeGraphData(this.config()).find(n => n.selfId === draggedId);
                if (node) node.parentId = newParentId;
            }

            // 7. RENDER CHART
            this.createKVDR(this.config());
            
            // --- REMOVED THE DUPLICATE SUCCESS TOAST HERE ---
            // The global system notification ("Role Update") will handle it now.

            // if (typeof Utils.playBellSound === 'function') {
            //     Utils.playBellSound(800, 840, 'square');
            // }

        } catch (error) {
            console.error("Critical Failure:", error);
            
            // ROLLBACK
            this.config().data.graphData = originalData;
            this.createKVDR(this.config());

            this.showToast("Move failed. Restoring previous state.", "error");
        } finally {
            // 8. HIDE LOADER
            this.toggleLoadingScreen(false);
        }
    }

    // Helper to prevent infinite loops
    isDescendant(draggedId, targetId, graphData) {
        if (draggedId === targetId) return true;
        let current = graphData.find(n => n.selfId === targetId);
        while (current) {
            if (current.parentId === draggedId) return true;
            current = graphData.find(n => n.selfId === current.parentId);
        }
        return false;
    }

    // Helper for nice notifications
    showToast(message, type = "info") {
        // Remove existing toasts first to prevent stacking
        const existing = document.querySelector('.organigram-toast');
        if(existing) existing.remove();

        const toast = document.createElement("div");
        toast.className = 'organigram-toast';
        toast.innerText = message;
        
        let bg = "#333"; // info
        if(type === 'success') bg = "#00b894";
        if(type === 'error') bg = "#d63031";

        Object.assign(toast.style, {
            position: "fixed", bottom: "30px", right: "30px",
            background: bg, color: "#fff", padding: "12px 24px", 
            borderRadius: "8px", boxShadow: "0 5px 15px rgba(0,0,0,0.2)", 
            zIndex: "10000", fontWeight: "600", fontSize: "14px", 
            transition: "all 0.3s ease", opacity: "0", transform: "translateY(10px)"
        });

        document.body.appendChild(toast);
        
        // Animation
        requestAnimationFrame(() => {
            toast.style.opacity = "1";
            toast.style.transform = "translateY(0)";
        });

        setTimeout(() => {
            toast.style.opacity = "0";
            toast.style.transform = "translateY(10px)";
            setTimeout(() => toast.remove(), 300);
        }, 3000);
    }

    confirmMovePopup(draggedName, targetName, onConfirm) {
    const wrapper = Utils.createElem("div");
    Utils.applyStyles(wrapper, {
        padding: "16px 20px",
        textAlign: "left" // 🔥 LEFT ALIGN EVERYTHING
    });

    // Warning Icon (left aligned, inline with text style)
    const icon = Utils.createElem("div", [], "", "⚠️");
    Utils.applyStyles(icon, {
        fontSize: "28px",
        marginBottom: "10px",
        marginTop: "-8px" // 🔥 pulls icon upward
    });

    // Title
    const msg = Utils.createElem("h3", [], "", "Change Reporting Line?");
    Utils.applyStyles(msg, {
        margin: "0 0 8px 0",
        color: "#111",
        fontSize: "18px",
        fontWeight: "600",
        textAlign: "left"
    });

    // Description
    const desc = Utils.createElem(
        "p",
        [],
        "",
        `Are you sure you want to move <b>${draggedName}</b> to report under <b>${targetName}</b>?`
    );
    Utils.applyStyles(desc, {
        margin: "0",
        color: "#555",
        fontSize: "14px",
        lineHeight: "1.6",
        textAlign: "left"
    });

    wrapper.append(icon, msg, desc);

    // Confirm Button (Yellow like Pic 2)
    const confirmBtn = Utils.createElem("button", [], "", "Yes, Move it");
    Utils.applyStyles(confirmBtn, {
        background: "#ffc107",        // 🔥 YELLOW BUTTON
        color: "#000",
        border: "none",
        padding: "10px 24px",         // 🔥 BETTER BUTTON PADDING
        borderRadius: "6px",
        cursor: "pointer",
        fontWeight: "600",
        fontSize: "14px"
    });

    // Popup
    const backdrop = document.getElementById("back-drop-overlay");

    const popupConfig = {
        headerText: "Confirm Reorganization",
        onCloseClick: () => {
            backdrop.style.display = "none";
            backdrop.innerHTML = "";
            isViewportActive.status = true;
        },
        data: wrapper,
        displaySettings: { width: "420px" }, // Slightly wider like Pic 2
        footer: confirmBtn
    };

    const popup = this.createPopup(popupConfig);

    // Confirm Action
    confirmBtn.addEventListener("click", () => {
        backdrop.style.display = "none";
        backdrop.innerHTML = "";
        isViewportActive.status = true;
        onConfirm();
    });

    backdrop.innerHTML = "";
    backdrop.append(popup);
    backdrop.style.display = "flex";
}

    async createNode(e, p){
        // Safely handle the event if it exists in the browser window
        const ev = window.event;
        if (ev) {
            ev.preventDefault();
            ev.stopPropagation();
        }
        
        // RESTORED: Use the original random string generator required by Python DB
        const nodeId = Utils.randomString(24);
        
        // Safely look for the parent node
        const parent = (ev && ev.target) ? ev.target.closest(".member") : null;
        
        // Safe fallback for Root node clicks
        let parentId = parent ? (parent.dataset.empid || parent.id || 0) : (this.config().root ? this.config().root.id : 0);
        
        // Check if the user is making a REQUEST (not an admin)
        const isRequest = !this.can('addRole') && this.can('addRoleRequest');

        // IF it's a request, OR the Vue instance is missing, use the OLD internal popup
        if (isRequest || !this.vueInstance) {
            try {
                const newData = await this.addRolePopup(e, p, parentId, nodeId);
                if (newData) {
                    if (!this.config().data) this.config().data = { graphData: [] };
                    
                    // 👇 FIX: Explicitly clear users/profiles so it doesn't inherit from the parent node
                    newData.profiles = [];
                    newData.kvdrRoleProfiles = [];
                    newData.users = [];

                    this.config().data.graphData.push(newData); 

                    const newNodeData = { ...e, ...newData, isCurrentUserNode: false };
                    const node = this.importNodeKVDR(newNodeData, p);
                    
                    if (parent) {
                        parent.append(node);
                    } else {
                        const rootContainer = document.querySelector('.member.root');
                        if(rootContainer) rootContainer.append(node);
                    }
                    // if (typeof Utils.playBellSound === 'function') Utils.playBellSound(800, 840, 'sine');
                }
            } catch (err) {
                console.log("Role creation cancelled or failed", err);
            }
        } else {
            // ADMIN logic using the new Vue Modal
            this.vueInstance.openVueRoleModal({
                detail: {
                    mode: 'CREATE',
                    role: { selfId: nodeId, parentId: parentId }, 
                    onSave: async (newData) => {
                        try {
                            newData.selfId = nodeId;
                            newData.parentId = parentId;
                            newData.status = 'published';
                            newData.requestedBy = this.user()._id;
                            newData.analyzedBy = this.user()._id;
                            newData.kvdrId = this.config().id;

                            // 1. Create the base role via POST to FeathersJS
                            const response = await e.onNodeClick(newData);
                            
                            // 2. Extract real _id returned from the DB array
                            let createdItem = response;
                            if (response && response.data && Array.isArray(response.data) && response.data.length > 0) {
                                createdItem = response.data[0];
                            } else if (Array.isArray(response) && response.length > 0) {
                                createdItem = response[0];
                            }

                            // Merge the REAL database ID into the final data
                            const finalData = { ...newData, ...(createdItem || {}) };
                            finalData.profiles = [];
                            finalData.kvdrRoleProfiles = [];
                            finalData.users = [];
                            
                            if (!this.config().data) this.config().data = { graphData: [] };
                            this.config().data.graphData.push(finalData); 

                            const newNodeData = { ...e, ...finalData, isCurrentUserNode: false };
                            const node = this.importNodeKVDR(newNodeData, p);
                            if (parent) {
                                parent.append(node);
                            } else {
                                const rootContainer = document.querySelector('.member.root');
                                if(rootContainer) rootContainer.append(node);
                            }
                            
                            // Return the final data containing _id back to Vue!
                            return finalData;
                        } catch (err) {
                            // --- ERROR HANDLING FIX ---
                            console.error("API Error during Role Creation:", err);
                            if (this.showToast) this.showToast("Failed to create role. Network or API error.", "error");
                            throw err; // Let Vue catch it
                        }
                    }
                }
            });
        }
    }
    async addNodeKVDR(e,p,parentId,nodeId,title,parent) {
        const newNode = Utils.createElem("div", ["member"],"","",{"data-selected-usr":"","data-empid" : nodeId,"data-parentid":parentId});
        newNode.addEventListener("click", (event) => event.preventDefault());
        
        const addUserIcon = Utils.createElem("i", ["vs-icon", "notranslate", "icon-scale", "feather", "icon-plus"]);
        Utils.applyStyles(addUserIcon, { fontSize: "14px", color: "#28c76f" });

        const addUserButton = Utils.createElem("button", ["openUsrListBtn"]);
        Utils.applyStyles(addUserButton, {
            border: "1px solid #ddd",
            background: "#fff", 
            cursor: "pointer",
            borderRadius: "50%",
            width: "24px", 
            height: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0",
            marginLeft: "8px"
        });
        
        addUserButton.setAttribute("title", this.translate('orgDashboard.userDashboard.evaluation.addroles'));
        addUserButton.append(addUserIcon);
        
        addUserButton.addEventListener("click",()=>{
            const popupConfig = {
                headerText: "Select User(s)",
                onCloseClick: () => { event.stopPropagation(); p.style.display = "none"; p.innerHTML = ""; isViewportActive.status = true; },
                data: this._popupUsrListCollection(event, e, p),
                displaySettings: e.displaySettings, footer: "",
            };
            const popup = this.createPopup(popupConfig);
            e.addUsersToDesig(popup);
        });

        const selectedUserImg = Utils.createElem("img", ["selectedUsrImg"]);
        Utils.applyStyles(selectedUserImg, {
            position: "relative", marginLeft: "-5px", width: "32px", height: "32px",
            objectFit: "cover", objectPosition: "center", border: "2px solid", borderRadius: "50%", display: "none",
        });

        const selectedUserBox = Utils.createElem("span", ["selectedUsrBox"]);
        Utils.applyStyles(selectedUserBox, { display: "flex", margin: "10px 5px", alignItems: "center" });
        selectedUserBox.append(selectedUserImg, addUserButton);

        const titleBox = Utils.createElem("i", [], "", title, { contentEditable: "true" });
        Utils.applyStyles(titleBox, { display: "flex", alignItems: "center", marginRight: "20px" });
        titleBox.addEventListener("focusout", () => e.onNodeUpdate({ data: { title: event.target.innerText }, query: nodeId }));
        
        const titleWrapper = Utils.createElem("div");
        Utils.applyStyles(titleWrapper, { display: "flex", alignItems: "center" });
        titleWrapper.append(titleBox,selectedUserBox);

        const deleteBtn = Utils.createElem("i", ["deleteNodeBtn", "vs-icon", "notranslate", "icon-scale", "feather", "icon-x"], "", "");
        Utils.applyStyles(deleteBtn, { cursor: "pointer", fontSize: "16px", color: "#000" });
        deleteBtn.setAttribute("title", "Delete Role"); 
        deleteBtn.dataset.removenode = true;
        
        const deleteNodeData = {
            target: newNode, deleteNode: (target) => e.onNodeDelClick(target), deleteProfile: (target) => e.onNodeRemoveProfileClick(target),
            popupBody: p, displaySettings: e.displaySettings,
        };
        deleteBtn.addEventListener("click", () => this.delNodeKVDR(deleteNodeData));

        const deleteBtnWrapper = Utils.createElem("div", ["delNodeBtnBox", "node-action-icon"]); 
        Utils.applyStyles(deleteBtnWrapper, { position: "absolute", top: "10px", right: "10px", zIndex: "5" });
        deleteBtnWrapper.append(deleteBtn);

        const expandBtn = Utils.createElem("img", ["roleExpandBtn", "node-action-icon"], "", "", { src: FullScreen }); 
        Utils.applyStyles(expandBtn, { width: "13px", height: "13px", filter: "invert(0)", position: "absolute", right: "0px", bottom: "0px" });
        const expandConfig = {
            kvdrRoleId: nodeId, candidateList: e.candidateList, kvdrOrgConfigData: e.data.kvdrOrgConfigData,
            removeProfile: (target) => { e.onNodeRemoveProfileClick(target); selectedUserImg.innerHTML = ""; selectedUserImg.style.display = "none"; },
            profileData: async (data) => e.onNodeProfileFetch(data), profileUpdate: async (data) => e.onNodeProfileUpdate(data),
            roleData: async (data) => e.onNodeFetch(data), roleUpdate: async (data) => e.onNodeUpdate(data),
            displaySettings: e.displaySettings,
        };
        expandBtn.addEventListener("click", async () => this.expandRole(expandConfig,'ROLE'));

        const footerLeft = Utils.createElem("div", ["roleFooterLeft"]);
        const footerRight = Utils.createElem("div", ["roleFooterRight"]);
        footerRight.append(expandBtn);

        const footer = Utils.createElem("div", ["roleFooter"]);
        Utils.applyStyles(footer, { border: "none", padding: "5px 0px", display: "flex", alignItems: "center", justifyContent: "space-between", flex: "1 1 100%", position: "relative" });
        footer.append(footerLeft, footerRight);

        // --- UPDATED: Add 'node-hover-target' to CARD ---
        const userCard = Utils.createElem("fieldset", ["userCard", "onlyCardType", "node-hover-target"]);
        Utils.applyStyles(userCard, { backgroundColor: e.displaySettings.cc, color: e.displaySettings.tc, borderColor: e.displaySettings.bc, flexWrap: "wrap", position: "relative" });
        
        const addNodeBtn = Utils.createElem("div", ["toggleBtn", "addNodeBtn", "node-action-icon"], "", "", {"data-addnode": "true"}); 
        
        const plusIconImg = Utils.createElem("i", ["vs-icon", "notranslate", "icon-scale", "feather", "icon-plus"]);
        Utils.applyStyles(plusIconImg, { fontSize: "10px", fontWeight: "900", display: "block", color: "#000" });

        addNodeBtn.append(plusIconImg);
        
        addNodeBtn.addEventListener('click',()=>this.createNode(e,p));
        
        Utils.applyStyles(addNodeBtn, {
             position: "absolute", 
             bottom: "-32px", 
             left: "50%", 
             transform: "translateX(-50%)",
             background: "#FFFFFF", 
             border: "1px solid #000", 
             borderRadius: "3px",
             width: "14px",
             height: "14px",
             display: "flex", 
             justifyContent: "center", 
             alignItems: "center",
             cursor: "pointer", 
             zIndex: "999",
             filter: "drop-shadow(0px 1px 2px rgba(0,0,0,0.1))",
             marginLeft: "0" 
        });

        userCard.append(deleteBtnWrapper, titleWrapper, footer);
        
        // --- UPDATED: Append Add Btn to CARD ---
        userCard.append(addNodeBtn);

        // --- UPDATED: Remove 'node-hover-target' from label ---
        const label = Utils.createElem("label", ["emptitle"]); 
        Utils.applyStyles(label, { position: "relative", overflow: "visible !important" });
        label.append(userCard);
        newNode.append(label);
        parent.append(newNode);

        this.counter++;
    }

    // NEW HELPER: Fetch Levels directly from Organization Config API
    async _fetchOrgLevels() {
        try {
            const orgId = this.getActualOrgId();
            const token = localStorage.getItem('feathers-jwt') || localStorage.getItem('accessToken');
            const res = await fetch(`https://api-core-gateway.getboarded.com/organization/organization-config/${orgId}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                const json = await res.json();
                if (json.data && json.data.level && json.data.level.values) {
                    return json.data.level.values; // Returns the array from the API
                }
            }
        } catch (err) {
            console.error("Failed to fetch org levels:", err);
        }
        // Fallback if API fails
        return [
        ];
    }

    // UPDATE this helper to map the API object properly
    _createLevelDropdown(options, selectedValue, onChange) {
        const wrapper = Utils.createElem('div');
        Utils.applyStyles(wrapper, { position: 'relative', display: 'flex', alignItems: 'center', marginLeft: '15px' });
        
        const select = Utils.createElem('select', ['role-level-select']);
        Utils.applyStyles(select, {
            padding: '8px 12px', borderRadius: '6px', border: '1px solid #E5E7EB',
            fontFamily: 'inherit', fontSize: '14px', outline: 'none', background: '#f9fafb',
            cursor: 'pointer', minWidth: '130px', color: '#111827', fontWeight: '500'
        });

        const defaultOpt = document.createElement('option');
        defaultOpt.value = "";
        defaultOpt.innerText = "Select Level";
        select.appendChild(defaultOpt);

        if (options && options.length) {
            options.forEach(opt => {
                const label = opt.label || opt; // Handles object {label: "..."} or raw string
                const option = document.createElement('option');
                option.value = label;
                option.innerText = label;
                if (label === selectedValue) option.selected = true;
                select.appendChild(option);
            });
        }

        if (onChange) select.addEventListener('change', onChange);
        wrapper.appendChild(select);
        return { wrapper, select };
    }

    // Helper 2: Rich Text Editor Generator
    // Helper: Rich Text Editor Generator (Updated with Left Alignment)
    _createRichTextEditor(placeholderText, initialHtml) {
        if (!document.getElementById('rich-text-styles')) {
            const style = document.createElement('style');
            style.id = 'rich-text-styles';
            style.innerHTML = `
                .rich-text-editor[contenteditable]:empty:before { content: attr(data-placeholder); color: #9ca3af; pointer-events: none; display: block; }
                .rtf-toolbar-btn { width: 28px; height: 28px; background: #fff; border: 1px solid #ddd; border-radius: 4px; cursor: pointer; color: #333; transition: 0.2s; display:flex; align-items:center; justify-content:center; }
                .rtf-toolbar-btn:hover { background: #f0f0f0; border-color: #bbb; }
            `;
            document.head.appendChild(style);
        }

        const container = Utils.createElem('div');
        Utils.applyStyles(container, {
            display: 'flex', flexDirection: 'column', width: '100%', flex: '1',
            border: '1px solid #e5e7eb', borderRadius: '8px', overflow: 'hidden', background: '#fff', position: 'relative'
        });

        const toolbar = Utils.createElem('div');
        Utils.applyStyles(toolbar, {
            display: 'flex', padding: '6px 10px', background: '#f9fafb', borderBottom: '1px solid #e5e7eb', gap: '8px', alignItems: 'center', flexWrap: 'wrap'
        });

        const tools = [
            { icon: '<b>B</b>', cmd: 'bold', title: 'Bold' },
            { icon: '<i>I</i>', cmd: 'italic', title: 'Italic' },
            { icon: '<u>U</u>', cmd: 'underline', title: 'Underline' }
        ];

        tools.forEach(t => {
            const btn = Utils.createElem('button', ['rtf-toolbar-btn']);
            btn.innerHTML = t.icon;
            btn.title = t.title;
            btn.onclick = (e) => { e.preventDefault(); document.execCommand(t.cmd, false, null); editor.focus(); };
            toolbar.appendChild(btn);
        });

        const fontSizeSelect = Utils.createElem('select');
        Utils.applyStyles(fontSizeSelect, { padding: '4px', border: '1px solid #ddd', borderRadius: '4px', cursor: 'pointer', outline: 'none', fontSize: '13px' });
        [1, 2, 3, 4, 5, 6, 7].forEach(size => {
            const opt = document.createElement('option');
            opt.value = size; opt.innerText = `Size ${size}`;
            if(size === 3) opt.selected = true;
            fontSizeSelect.appendChild(opt);
        });
        fontSizeSelect.onchange = (e) => { document.execCommand('fontSize', false, e.target.value); editor.focus(); };
        toolbar.appendChild(fontSizeSelect);

        const editor = Utils.createElem('div', ['rich-text-editor', 'invisible-scroll-y']);
        editor.contentEditable = true;
        editor.dataset.placeholder = placeholderText;
        editor.innerHTML = initialHtml || '';
        
        // --- UPDATED THIS BLOCK ---
        Utils.applyStyles(editor, {
            padding: '15px', 
            paddingRight: '75px', 
            flex: '1', 
            outline: 'none', 
            overflowY: 'auto', 
            minHeight: '150px', 
            fontSize: '14px', 
            color: '#333',
            textAlign: 'left' // <--- Explicitly left aligned
        });

        container.append(toolbar, editor);
        return { container, editor };
    }
    
    addRolePopup = async(e,p,parentId,nodeId) => {
        return new Promise(async (resolve, reject) => { 
            let skills =[]; let softSkills = [];
            
            const wrapper = Utils.createElem('div');
            Utils.applyStyles(wrapper,{ display:'flex', gap:'15px', flexFlow:'column', height: '100%', boxSizing: 'border-box' });
            
            // --- Title and Level Row ---
            const titleRow = Utils.createElem('div');
            Utils.applyStyles(titleRow, { display: 'flex', alignItems: 'center', borderBottom: `2px solid #e5e7eb`, paddingBottom: '5px', flexShrink: 0 });

            const roleTitle = Utils.createElem('input',[],'','',{'placeholder':'Designation'});
            Utils.applyStyles(roleTitle,{ border:'none', fontFamily:'inherit', padding:'10px 5px', fontSize: '16px', fontWeight: 'bold', outline: 'none', flexGrow: '1' });

            // Fetch Level Options dynamically from API
            const levelOptions = await this._fetchOrgLevels();
            
            let selectedLevel = "";
            const { wrapper: levelDropdownWrapper } = this._createLevelDropdown(levelOptions, "", (evt) => {
                selectedLevel = evt.target.value;
            });

            titleRow.append(roleTitle, levelDropdownWrapper);
            
            // --- Skills Section ---
            const skillSection = Utils.createElem('div')
            Utils.applyStyles(skillSection,{ display:'flex', gap:'20px', alignItems:'flex-start', width:'100%', height: '150px', flexShrink: 0 });

            const functionalSkillContainer = Utils.createElem('div');
            Utils.applyStyles(functionalSkillContainer,{flex:'1', minWidth: '0', display: 'flex', flexDirection: 'column'});
            const functionalSkillBox = Utils.createElem('div');
            Utils.applyStyles(functionalSkillBox, { marginTop: '5px', display: 'flex', flexWrap: 'wrap', gap: '6px', alignContent: 'flex-start', height: '80px', overflowY: 'auto', width: '100%', padding: '4px', border: '1px solid #f1f5f9', borderRadius: '6px', background: '#fafafa', boxSizing: 'border-box' });
            const functionalSkillInput = Utils.createSuggestiveDropDown(this.skills(),'functionalSkills','Functional Skills');
            functionalSkillInput.addEventListener('keydown', (event) => { if (event.key === 'Enter') this.updateRoleSkills('',functionalSkillBox,skills,'','functionalSkills'); });
            
            const skillSeprator = Utils.createElem('span');
            Utils.applyStyles(skillSeprator,{width:'1px', background:'#E5E7EB', height: '100%'});
            
            const behavioralSkillContainer = Utils.createElem('div');
            Utils.applyStyles(behavioralSkillContainer,{flex:'1', minWidth: '0', display: 'flex', flexDirection: 'column'});
            const behavioralSkillBox = Utils.createElem('div');
            Utils.applyStyles(behavioralSkillBox, { marginTop: '5px', display: 'flex', flexWrap: 'wrap', gap: '6px', alignContent: 'flex-start', height: '80px', overflowY: 'auto', width: '100%', padding: '4px', border: '1px solid #f1f5f9', borderRadius: '6px', background: '#fafafa', boxSizing: 'border-box' });
            const behavioralSkillInput = Utils.createSuggestiveDropDown(this.softSkills(),'behavioralSkills','Soft Skills');
            behavioralSkillInput.addEventListener('keydown', (event) => { if (event.key === 'Enter') this.updateRoleSkills('',behavioralSkillBox,softSkills,'','behavioralSkills'); });
            
            functionalSkillContainer.append(functionalSkillInput,functionalSkillBox);
            behavioralSkillContainer.append(behavioralSkillInput,behavioralSkillBox);
            skillSection.append(functionalSkillContainer,skillSeprator,behavioralSkillContainer);

            // --- Rich Text Editor Section ---
            const { container: descWrapper, editor: roleDescription } = this._createRichTextEditor('Insert Role Description', '');
            
            const aiGenerateBtn = Utils.createElem('button');
            aiGenerateBtn.title = "Use AI to enhance description";
            Utils.applyStyles(aiGenerateBtn, {
                position: 'absolute', bottom: '15px', right: '15px', background: '#f0f0f0', border: 'none', borderRadius: '50%', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', zIndex: '2', transition: 'all 0.2s ease'
            });
            const aiIcon = Utils.createElem('img');
            aiIcon.src = AIGenerateIcon;
            Utils.applyStyles(aiIcon, { width: '20px', height: '20px' });
            aiGenerateBtn.append(aiIcon);
            
            aiGenerateBtn.addEventListener('click', async (event) => {
                event.preventDefault();
                const title = roleTitle.value;
                if (!title) { alert("Please enter a Designation first."); return; }
                aiIcon.classList.add('ai-icon-loading'); aiGenerateBtn.disabled = true;
                try {
                    const token = localStorage.getItem('feathers-jwt') || localStorage.getItem('accessToken');
                    const response = await fetch(`${API_BASE_URL}/api/generate-role-description`, {
                        method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                        body: JSON.stringify({ role_id: "new_role", role_title: title, technical_skills: skills, soft_skills: softSkills })
                    });
                    const data = await response.json();
                    
                    roleDescription.innerHTML = data.description.replace(/\n/g, '<br>');
                    roleDescription.dispatchEvent(new Event('input'));
                    
                    if (data.recommended_technical_skills && data.recommended_technical_skills.length > 0) {
                        const funcInput = functionalSkillInput.querySelector('input');
                        if (funcInput) {
                            const currentVal = funcInput.value.trim();
                            const newSkillsStr = data.recommended_technical_skills.join(', ');
                            funcInput.value = currentVal ? currentVal + ', ' + newSkillsStr : newSkillsStr;
                        }
                    }
                    if (data.recommended_soft_skills && data.recommended_soft_skills.length > 0) {
                        const softInput = behavioralSkillInput.querySelector('input');
                        if (softInput) {
                            const currentVal = softInput.value.trim();
                            const newSkillsStr = data.recommended_soft_skills.join(', ');
                            softInput.value = currentVal ? currentVal + ', ' + newSkillsStr : newSkillsStr;
                        }
                    }
                } catch (error) { console.error("AI Generation Error:", error); alert("AI Generation Failed"); } 
                finally { aiIcon.classList.remove('ai-icon-loading'); aiGenerateBtn.disabled = false; }
            });
            descWrapper.append(aiGenerateBtn);

            const roleBtn = Utils.createElem('button','','',this.can('addRoleRequest')?'Request Role':'Create Role');
            Utils.applyStyles(roleBtn,{
                background:'#ff9505', border:'none', padding:'8px 16px',
                borderRadius:'6px', fontFamily:'inherit', cursor:'pointer', fontWeight: '600', color: '#fff'
            });

            // KVDR Button UI code completely removed from here

            roleBtn.addEventListener('click', async () => {
                if(roleBtn.disabled) return;
                roleBtn.disabled = true; 
                
                const descValue = roleDescription.innerHTML;
                const BACKUP_TAG = "[ROLE_DESC_SAVE]"; 

                const apiData = {
                    title: roleTitle.value,
                    level: selectedLevel, 
                    skills: skills,
                    softSkills: softSkills,
                    roleSummary: descValue,
                    description: descValue ? [{ msg: BACKUP_TAG + " " + descValue, userId: this.user()._id, createdAt: new Date() }] : [],
                    status: this.can('addRole') ? 'published' : 'pending',
                    requestedBy: this.user()._id,
                    analyzedBy: this.user()._id,
                    parentId: parentId,
                    selfId: nodeId,
                    kvdrId: this.config().id,
                    is_kvdr: false, // Defaulting to false since KVDR feature is removed here
                    isKvdr: false
                };
                
                try {
                    const response = await e.onNodeClick(apiData);
                    
                    let finalResponse = response || apiData;
                    finalResponse.is_kvdr = false;
                    finalResponse.isKvdr = false;

                    resolve(finalResponse);
                    
                    p.style.display = "none"; p.innerHTML = "";
                    if (typeof isViewportActive !== 'undefined') isViewportActive.status = true;
                    if (apiData.status === 'pending') this.showToast("Role request submitted successfully.", "success");

                } catch (err) { roleBtn.disabled = false; reject(err); }
            });
            
            wrapper.append(titleRow, skillSection, descWrapper);

            const popupConfig = {
                headerText: `Create Role ${this.can('addRoleRequest')?'Request':''}`,
                onCloseClick: () => { p.style.display = "none"; p.innerHTML = ""; isViewportActive.status = true; },
                data: wrapper,
                displaySettings: {
                    primaryColor: e.displaySettings.cc, 
                    secondaryColor: e.displaySettings.tc,
                    width: "700px",
                    height: "650px" 
                },
                footer: roleBtn,
            };
            const popup = this.createPopup(popupConfig);
            p.append(popup); p.style.display = "flex";
            // FIX: Use parentId directly instead of relying on the global event object
            wrapper.dataset.selectedNode = parentId; 
        })
    }

    expandRole = async (data, type, id) => {
        this._activePopupArgs = { data, type, id };
        // CRITICAL FIX: Force fetch the latest Org Config directly from the API 
        // right before opening the popup, guaranteeing both User & Org side are in sync.
        await this.fetchOrgConfig();

        const { kvdrRoleId, candidateList, displaySettings, kvdrOrgConfigData } = data;
        
        const node = document.querySelector(`[data-empid='${kvdrRoleId}']`);
        if (!node) return console.error(`Node with kvdrRoleId ${kvdrRoleId} not found`);
        
        const selectedProfiles = type === 'ROLE' 
            ? (node.dataset.selectedUsr ? node.dataset.selectedUsr.split(",").filter(Boolean) : [])
            : id;
        
        const popupBox = document.querySelector("#back-drop-overlay");

        const filteredProfiles = selectedProfiles
            .map(profileId => candidateList.find(cand => cand.id === profileId))
            .filter(profile => profile !== undefined);
    
        const updatedData = {
            ...data,
            profile: filteredProfiles,
            type
        };
    
        // --- MODIFIED: Destructure all needed parts from the response ---
        const { content: contentHtml, customHeader, levelDropdownWrapper } = await this._roleProfileData(updatedData);
    
        const dynamicOrgConfig = this.getDynamicConfig(kvdrOrgConfigData);

        // --- NEW: Assemble the right side of the header for perfect layout (KVDR Removed) ---
        let headerRightContent = null;
        if (type === 'ROLE' && levelDropdownWrapper) {
            headerRightContent = Utils.createElem('div');
            Utils.applyStyles(headerRightContent, { display: 'flex', alignItems: 'center', gap: '15px' }); 
            headerRightContent.append(levelDropdownWrapper);
        }
    
        const popupData = {
            headerText: customHeader ? "" : `${type} Evaluation`,
            headerLeftControlls: customHeader, 
            headerRightControlls: headerRightContent, // Use the new right-side container
            onCloseClick: (event) => {
                event.stopPropagation();
                popupBox.style.display = "none";
                popupBox.innerHTML = "";
                if (typeof isViewportActive !== 'undefined') isViewportActive.status = true;
            },
            data: contentHtml,
            footer: "", // Legends removed as requested
            displaySettings: { ...displaySettings, width: "900px" } 
        };

        const popupElement = this.createPopup(popupData);
        const footerElement = popupElement.querySelector('.OrganiGramPopupFooter');
        if (footerElement) footerElement.style.display = 'none';
        
        popupBox.innerHTML = ""; 
        popupBox.append(popupElement);
        popupBox.style.display = "flex";
        popupElement.dataset.selectedNode = kvdrRoleId;
        if (type === 'Talent' && footerElement) {
            footerElement.style.display = 'flex';
        }
    }

    _updateJobGradeBadge = (profileId, directScore, minSalary, maxSalary, containerElement = null) => {
        const renderBadge = () => {
            const badgeContainer = containerElement || document.getElementById(`grade-badge-container-${profileId}`);
            if (!badgeContainer || !this.jobGrades || this.jobGrades.length === 0) return;

            if (directScore === null || directScore === undefined) {
                badgeContainer.style.display = "none";
                return;
            }

            const sortedGrades = [...this.jobGrades].sort((a,b) => b.minScore - a.minScore);
            
            let assignedGrade = null;
            for (let g of sortedGrades) {
                if (directScore >= g.minScore) {
                    assignedGrade = g;
                    break;
                }
            }

            if (assignedGrade) {
                badgeContainer.innerHTML = ""; 
                badgeContainer.style.display = "inline-flex";
                badgeContainer.style.alignItems = "center";
                badgeContainer.style.gap = "8px"; 
                badgeContainer.style.marginLeft = "10px";

                // The Yellow Grade Badge (G6) generation has been completely removed.

                // Generate Salary Badge (Green) if limits exist
                if (minSalary !== null && maxSalary !== null && !isNaN(minSalary) && !isNaN(maxSalary)) {
                    const range = maxSalary - minSalary;
                    const calculatedSalary = minSalary + (range * (assignedGrade.position / 100));
                    
                    const formattedSalary = new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(calculatedSalary);

                    const salaryBadge = document.createElement("span");
                    salaryBadge.innerText = formattedSalary;
                    salaryBadge.style.cssText = "font-size:11px; padding:2px 8px; border-radius:12px; border:1px solid #bbf7d0; font-weight:700; background:#f0fdf4; color:#15803d; cursor:help;";
                    this.attachTooltip(salaryBadge, `Based on ${assignedGrade.id} (${assignedGrade.position}% band position)\nBand limits: €${minSalary} - €${maxSalary}`);
                    
                    badgeContainer.appendChild(salaryBadge);
                }

            } else {
                badgeContainer.style.display = "none";
            }
        };

        if (containerElement) {
            renderBadge();
        } else {
            setTimeout(renderBadge, 50);
        }
    }

    createRelativeUsrData(e, t, target, profiles, s, profileUpdate, settings, viewType) {
        const dynamicT = this.getDynamicConfig(t);
        this.selectBtn(target, settings);
        let _calProfileEval = [];

        const configKey = target.value;
        const dataKey = configKey.replace('Data', '');
        const n = target.innerText;

        s.innerHTML = "";
        _totalEvaluation.total = 0;
        _calculateEvaluation.total = 0;

        if (!document.getElementById('invisible-scroll-styles')) {
            const style = document.createElement('style');
            style.id = 'invisible-scroll-styles';
            style.innerHTML = `.invisible-scroll { overflow-x: auto; overflow-y: hidden; scrollbar-width: none; -ms-overflow-style: none; scroll-behavior: auto; } .invisible-scroll::-webkit-scrollbar { display: none; }`;
            document.head.appendChild(style);
        }

        const metricConfig = dynamicT[dataKey] || dynamicT[configKey] || {};
        const l = Utils.createElem("div", ["assessmentDataContainer"], "assessment-data-container", "");
        l.style.cssText = `overflow: visible; border:1px solid rgba(0,0,0,0.1); border-radius:16px; width: 100%; box-sizing: border-box; background: #fff;`;    
        const d = Utils.createElem("div", "", "", "");
        d.style.cssText = "display:flex; flex-direction:column; align-items:stretch; width: 100%; position: relative;";

        const colWidth = viewType === 'ROLE' ? "25%" : "35%";
        const weightColWidth = '60px';
        const sidewaysWidth = '40px';
        const baseLeftPad = '15px';
        const titleLeftPad = `calc(${sidewaysWidth} + ${baseLeftPad})`;

        const colWidthCSS = `flex: 0 0 ${colWidth}; width: ${colWidth}; min-width: 200px; box-sizing: border-box;`;
        const weightColCSS = `flex: 0 0 ${weightColWidth}; width: ${weightColWidth}; box-sizing: border-box; border-left: 1px solid rgba(0,0,0,0.1); border-right: 1px solid rgba(0,0,0,0.1);`;
        const profilesColCSS = `flex: 1 1 0%; min-width: 0; box-sizing: border-box;`; 
        
        const profColWidth = (viewType === 'ROLE') ? "70px" : "480px";

        const syncScrollers = [];

        let sortedProfiles = [];
        let sortedAssessments = [];
        if (profiles.length > 0) {
            const defaultType = dynamicT.calculationTypes.find(type => type.default === true);
            const defaultVal = defaultType ? Utils.parseNumber(defaultType.value) : 0;

            const mappedData = profiles.map((profile, index) => {
                const assessment = e[index]; 
                const scoresList = assessment ? (assessment[n] || assessment[configKey] || assessment[dataKey]) : [];
                let calculatedTotal = 0;

                Object.keys(metricConfig).forEach(group => {
                    metricConfig[group].forEach(attr => {
                        const attrKey = attr.key;
                        const compKey = `${group}|${attrKey}`;
                        const weight = Utils.parseNumber(attr.value);
                        const userItem = scoresList ? (scoresList.find(x => x.key === compKey) || scoresList.find(x => x.key === attrKey)) : null;
                        let val = userItem ? Utils.parseNumber(userItem.score !== undefined ? userItem.score : userItem.value) : defaultVal;
                        calculatedTotal += (val * weight);
                    });
                });
                return { profile: profile, assessment: assessment, total: calculatedTotal, isLocked: false };
            });

            mappedData.sort((a, b) => b.total - a.total);
            sortedProfiles = mappedData.map(x => x.profile);
            sortedAssessments = mappedData.map(x => x.assessment);
        }

        const _headerRow = Utils.createElem("div", ["assessment-header-row"]);
        _headerRow.style.cssText = "display:flex; align-items:stretch; width: 100%; border-bottom:1px solid rgba(0,0,0,0.1); box-sizing: border-box;";
        
        const isAppraisalTab = n.toLowerCase().includes('appraisal');
        const canEditAttr = (this.role() !== 0) || isAppraisalTab;
        
        const _headerAttr = Utils.createElem("div", "", "", `<span style="font-weight:bold;">Attribute</span>`);
        _headerAttr.style.cssText = `display:flex; align-items:center; justify-content:flex-start; padding:12px 10px 12px ${titleLeftPad}; text-align: left; ${colWidthCSS}`;

        const _headerWeight = Utils.createElem("div");

        if (canEditAttr) {
            const addButton = Utils.createElem("button", ["add-attribute-btn"]); 
            addButton.innerHTML = '%'; 
            Utils.applyStyles(addButton, {
                width: '24px', height: '24px', border: '1px solid #d1d5db', borderRadius: '6px',
                background: '#ffffff', cursor: 'pointer', display: 'flex', alignItems: 'center',
                justifyContent: 'center', fontSize: '16px', color: '#4b5563', lineHeight: '1'
            });
            this.attachTooltip(addButton, "Weightage"); 
            _headerWeight.append(addButton);
            _headerWeight.style.cssText = `display:flex; align-items:center; justify-content:center; ${weightColCSS}`;

        } else {
            _headerWeight.innerHTML = `<span style="border:1.5px solid;border-radius:5px;padding:1.5px 8px;font-weight:bold;margin:auto;">${dynamicT.calculationUnit || ''}</span>`;
            _headerWeight.style.cssText = `display:flex; align-items:center; justify-content:flex-start; padding:12px 10px 12px ${baseLeftPad}; ${weightColCSS}`;
        }
        
        const _headerProfiles = Utils.createElem("div");
        _headerProfiles.style.cssText = `display:flex; flex-direction:column; overflow-x: auto; ${profilesColCSS}`;
        
        const _roleProfilesContainer = Utils.createElem("div", ["roleProfilesContainer", "invisible-scroll"]);
        _roleProfilesContainer.style.cssText = "display:flex; width:100%; justify-content:flex-start; padding-bottom: 5px; box-sizing: border-box;";
        syncScrollers.push(_roleProfilesContainer);

        const _footerCalEvalSec = Utils.createElem("div"); 

        sortedProfiles.forEach((profile, ind) => {
            if (!profile.isLocked) {
                _calProfileEval.push(0);
                const profileImgWrapper = Utils.createElem("div", ["roleProfileImgWrapper"]);
                profileImgWrapper.style.cssText = `position: relative; display: flex; flex-direction:column; align-items:center; flex: 0 0 ${profColWidth}; min-width: ${profColWidth}; padding: 5px 10px; box-sizing: border-box;`;
                const img = Utils.createElem("img", ["roleProfileImg"]);
                img.setAttribute("src", profile.imageUrl);
                img.style.cssText = "width:35px;height:35px;object-fit:cover;object-position:center;border-radius:50%;border:0px solid; cursor: help; margin: 0;";
                this.attachTooltip(img, profile.name);
                profileImgWrapper.append(img);
                _roleProfilesContainer.append(profileImgWrapper);

                const _profileFooterEvalContainer = Utils.createElem("div");
                _profileFooterEvalContainer.style.cssText = `margin:0; flex: 0 0 ${profColWidth}; min-width: ${profColWidth}; text-align:center; box-sizing: border-box;`;
                _profileFooterEvalContainer.dataset.targetprofile = profile.id;
                _profileFooterEvalContainer.innerText = "0"; 
                _footerCalEvalSec.append(_profileFooterEvalContainer);
            }
        });

        _headerProfiles.append(_roleProfilesContainer);
        _headerRow.append(_headerAttr, _headerProfiles, _headerWeight);
        d.append(_headerRow);

        const _tableBody = Utils.createElem("div", ["assessment-table-body"]);
        _tableBody.style.cssText = "width: 100%; box-sizing: border-box; position: relative;";
        d.append(_tableBody);
        const h = ["#FFFBE5", "#E5FFEA", "#E5F3FF", "#F8E5FF", "#FFE5E5"];

        Object.keys(metricConfig).forEach((a, r) => {
            const _groupWrapper = Utils.createElem("div", ["attri-group-wrapper"]);
            _groupWrapper.style.cssText = "position: relative; display: flex; flex-direction: column; width: 100%; box-sizing: border-box; border-bottom: 1px solid #fff;";

            const _sidewaysLabelWrapper = Utils.createElem("div");
            _sidewaysLabelWrapper.style.cssText = `position: absolute; left: 0; top: 0; bottom: 0; width: ${sidewaysWidth}; background: ${h[r % h.length]}; display:flex; align-items:center; justify-content: center; box-sizing: border-box; z-index: 1; border-right: 1px solid rgba(0,0,0,0.05);`;
            const _sidewaysLabel = Utils.createElem("h6", ["attriGrpTitle"], "", `<span style="transform-origin:50% 50%;">${a}</span>`);
            _sidewaysLabel.style.cssText = `white-space:normal; writing-mode:sideways-lr; margin:0;`;
            _sidewaysLabelWrapper.append(_sidewaysLabel);
            _groupWrapper.append(_sidewaysLabelWrapper);

            for (let l = 0; l < metricConfig[a].length; l++) {
                const _row = Utils.createElem("div", ["assessment-row"]);
                _row.style.cssText = "display:flex; align-items:stretch; min-height: 45px; width: 100%; box-sizing: border-box; position: relative;";

                const _titleCell = Utils.createElem("div", ["attriTitle"], "", metricConfig[a][l].title);
                _titleCell.style.cssText = `background:${h[r % h.length]}; padding:10px 10px 10px ${titleLeftPad}; font-size: 13px; font-weight: 500; display: flex; align-items: center; justify-content: flex-start; text-align: left; border-bottom: 1px solid rgba(0,0,0,0.05); line-height: 1.3; z-index: 0; ${colWidthCSS}`;
                if (metricConfig[a][l].desc) this.attachTooltip(_titleCell, metricConfig[a][l].desc);
                _totalEvaluation.total += Utils.parseNumber(metricConfig[a][l].value);

                const _weightCell = Utils.createElem("div", ["attriVal"], "", metricConfig[a][l].value);
                _weightCell.style.cssText = `padding:10px 10px 10px ${baseLeftPad}; display: flex; align-items: center; justify-content: center; text-align: center; border-bottom: 1px solid #eee; font-size: 13px; background: #fff; ${weightColCSS}`;

                const _scoresCell = Utils.createElem("div", ["profileEvalBtnContainer", "invisible-scroll"]);
                _scoresCell.style.cssText = `display:flex; padding:0px; justify-content:flex-start; border-bottom: 1px solid #eee; position: relative; overflow-x: auto; ${profilesColCSS}`;
                syncScrollers.push(_scoresCell);

                const currentAttrKey = metricConfig[a][l].key;
                const compositeKey = `${a}|${currentAttrKey}`;

                sortedProfiles.forEach((p, ind) => {
                    if (!p.isLocked) {
                        const u = Utils.createElem("div");
                        const justifyStyle = (viewType === 'ROLE') ? 'center' : 'flex-start';
                        u.style.cssText = `padding:5px 10px; display: flex; align-items: center; justify-content: ${justifyStyle}; gap: 10px; flex: 0 0 ${profColWidth}; min-width: ${profColWidth}; position: relative; box-sizing: border-box;`;

                        const _profileEvalContainer = _footerCalEvalSec.childNodes[ind];
                        const userScoreList = sortedAssessments[ind] ? (sortedAssessments[ind][n] || sortedAssessments[ind][configKey] || sortedAssessments[ind][dataKey]) : [];
                        
                        let _currentItem = userScoreList ? (userScoreList.find(e => e.key === compositeKey) || userScoreList.find(e => e.key === currentAttrKey)) : null;
                        
                        let rawVal = 0, remarksText = "", dotColor = "#e0e0e0";

                        if (_currentItem) {
                            rawVal = Utils.parseNumber(_currentItem.score !== undefined ? _currentItem.score : _currentItem.value);
                            remarksText = _currentItem.remarks || _currentItem.reasoning || "";
                            const configColor = dynamicT.calculationTypes.find(type => parseFloat(type.value) === parseFloat(rawVal));
                            dotColor = configColor ? configColor.color : "#e0e0e0";
                            _calProfileEval[ind] += rawVal * Utils.parseNumber(metricConfig[a][l].value);
                        } else {
                            const defaultType = dynamicT.calculationTypes.find(type => type.default === true);
                            if (defaultType) {
                                rawVal = Utils.parseNumber(defaultType.value); dotColor = defaultType.color;
                                _calProfileEval[ind] += rawVal * Utils.parseNumber(metricConfig[a][l].value);
                            }
                        }
                        if (_profileEvalContainer) _profileEvalContainer.innerText = Math.round(_calProfileEval[ind]);

                        const isEditable = !p.isLocked && canEditAttr && viewType !== 'ROLE';

                        const _userCalValueBtn = Utils.createElem("div");
                        _userCalValueBtn.dataset.group = configKey;
                        _userCalValueBtn.dataset.value = rawVal;
                        _userCalValueBtn.dataset.key = compositeKey; 
                        _userCalValueBtn.dataset.keyValue = metricConfig[a][l].value;
                        _userCalValueBtn.dataset.targetProfile = p.id;
                        _userCalValueBtn.style.cssText = `width: 22px; height: 22px; border-radius: 50%; background: ${dotColor}; position: relative; border: 1px solid rgba(0,0,0,0.1); flex-shrink: 0;`;

                        if (viewType === 'ROLE') {
                            if (remarksText) {
                                _userCalValueBtn.style.pointerEvents = "auto";
                                _userCalValueBtn.style.cursor = "help";
                                
                                _userCalValueBtn.addEventListener("mouseenter", () => {
                                    const tooltip = document.createElement("div");
                                    tooltip.className = "role-remarks-hover-tip";
                                    tooltip.innerText = remarksText;
                                    Object.assign(tooltip.style, {
                                        position: "fixed", background: "rgba(33, 33, 33, 0.95)", color: "#fff",
                                        padding: "8px 12px", borderRadius: "6px", fontSize: "12px", lineHeight: "1.4",
                                        maxWidth: "280px", zIndex: "1000000", pointerEvents: "none",
                                        boxShadow: "0 4px 15px rgba(0,0,0,0.3)", fontFamily: "inherit",
                                        whiteSpace: "normal", wordWrap: "break-word", textAlign: "left"
                                    });
                                    document.body.appendChild(tooltip);
                                    const rect = _userCalValueBtn.getBoundingClientRect();
                                    const tipRect = tooltip.getBoundingClientRect();
                                    tooltip.style.top = (rect.top - tipRect.height - 10) + "px";
                                    tooltip.style.left = (rect.left - (tipRect.width / 2) + (rect.width / 2)) + "px";
                                });
                                _userCalValueBtn.addEventListener("mouseleave", () => {
                                    document.querySelectorAll(".role-remarks-hover-tip").forEach(el => el.remove());
                                });
                            } else {
                                _userCalValueBtn.style.pointerEvents = "none";
                                _userCalValueBtn.style.cursor = "default";
                            }
                            u.append(_userCalValueBtn);
                        } else {
                            if (isEditable) {
                                _userCalValueBtn.style.pointerEvents = "auto";
                                _userCalValueBtn.style.cursor = "pointer";
                                
                                const _colorDropdown = Utils.createElem("div", ["eval-color-dropdown"]);
                                Utils.applyStyles(_colorDropdown, {
                                    position: "absolute", top: "100%", left: "0", marginTop: "5px",
                                    background: "#ffffff", // Explicit solid white
                                    border: "1px solid #d1d5db", 
                                    borderRadius: "8px",
                                    boxShadow: "0 10px 30px rgba(0,0,0,0.3)", // Stronger shadow for depth
                                    zIndex: "999999", // Guarantee it sits above everything
                                    display: "none", flexDirection: "column", minWidth: "160px", padding: "6px 0"
                                });

                                dynamicT.calculationTypes.forEach(ct => {
                                    const opt = Utils.createElem("div");
                                    Utils.applyStyles(opt, {
                                        padding: "6px 12px", display: "flex", alignItems: "center", gap: "8px", 
                                        cursor: "pointer", fontSize: "12px", color: "#333", textAlign: "left", whiteSpace: "nowrap"
                                    });
                                    opt.innerHTML = `<span style="width:12px;height:12px;border-radius:50%;background:${ct.color};display:inline-block;flex-shrink:0;"></span> ${ct.value}: ${ct.title}`;
                                    opt.onmouseenter = () => opt.style.background = "#f5f5f5";
                                    opt.onmouseleave = () => opt.style.background = "transparent";
                                    opt.onclick = (ev) => {
                                        ev.stopPropagation();
                                        _userCalValueBtn.dataset.value = ct.value;
                                        _userCalValueBtn.style.background = ct.color;
                                        _colorDropdown.style.display = "none";
                                        _scoresCell.style.overflowX = 'auto';
                                        _groupWrapper.style.zIndex = ''; _row.style.zIndex = ''; u.style.zIndex = '';
                                        const query = `userId=${p.id}&kvdrRoleId=${target.closest("div#candidate-list-popup").dataset.selectedNode}`;
                                        this.updateUserEvaluation(_userCalValueBtn, dynamicT.calculationTypes, _tableBody, query, profileUpdate, true);
                                    };
                                    _colorDropdown.append(opt);
                                });

                                if (!window.evalDropdownListenerAdded) {
                                    document.addEventListener("click", () => { 
                                        document.querySelectorAll('.eval-color-dropdown').forEach(el => el.style.display = 'none'); 
                                        document.querySelectorAll('.profileEvalBtnContainer').forEach(el => {
                                            el.style.overflow = '';
                                            el.style.overflowX = 'auto';
                                        });
                                        // FIX: Reset z-indexes on outside click to prevent stacking bugs
                                        document.querySelectorAll('.attri-group-wrapper, .assessment-row').forEach(el => {
                                            el.style.zIndex = '';
                                        });
                                    });
                                    window.evalDropdownListenerAdded = true;
                                }

                                 _userCalValueBtn.addEventListener("click", (e) => {
                                    e.stopPropagation();
                                    const isCurrentlyOpen = _colorDropdown.style.display === "flex";
                                    
                                    // Close all other dropdowns safely
                                    document.querySelectorAll('.eval-color-dropdown').forEach(el => el.style.display = 'none');
                                    document.querySelectorAll('.profileEvalBtnContainer').forEach(el => {
                                        el.style.overflow = '';
                                        el.style.overflowX = 'auto';
                                    });
                                    document.querySelectorAll('.attri-group-wrapper, .assessment-row').forEach(el => {
                                        el.style.zIndex = '';
                                    });
                                    
                                    if (!isCurrentlyOpen) {
                                        _colorDropdown.style.display = "flex";
                                        _groupWrapper.style.zIndex = '100'; 
                                        _row.style.zIndex = '101'; 
                                        u.style.zIndex = '102';
                                        // Override overflow so the absolute dropdown escapes the cell bounds
                                        _scoresCell.style.overflow = 'visible';

                                        // --- FIX: Smart Dropdown Positioning (Prevents bottom cutoff) ---
                                        const btnRect = _userCalValueBtn.getBoundingClientRect();
                                        const spaceBelow = window.innerHeight - btnRect.bottom;
                                        
                                        // If there's less than 180px below the button, open the dropdown UPWARDS
                                        if (spaceBelow < 180) {
                                            _colorDropdown.style.top = "auto";
                                            _colorDropdown.style.bottom = "100%";
                                            _colorDropdown.style.marginTop = "0";
                                            _colorDropdown.style.marginBottom = "5px";
                                        } else {
                                            // Normal downward drop
                                            _colorDropdown.style.top = "100%";
                                            _colorDropdown.style.bottom = "auto";
                                            _colorDropdown.style.marginTop = "5px";
                                            _colorDropdown.style.marginBottom = "0";
                                        }
                                        // -----------------------------------------------------------------

                                    } else {
                                        _colorDropdown.style.display = "none";
                                        _scoresCell.style.overflow = '';
                                        _scoresCell.style.overflowX = 'auto';
                                        _groupWrapper.style.zIndex = ''; 
                                        _row.style.zIndex = ''; 
                                        u.style.zIndex = '';
                                    }
                                });

                                u.append(_userCalValueBtn, _colorDropdown);
                            } else {
                                _userCalValueBtn.style.pointerEvents = "none";
                                _userCalValueBtn.style.cursor = "default";
                                u.append(_userCalValueBtn);
                            }

                            const _remarksInput = Utils.createElem("textarea", ["remarks-input"]);
                            _remarksInput.value = remarksText;
                            _remarksInput.placeholder = !isEditable ? "" : "Add remarks...";
                            _remarksInput.disabled = !isEditable;
                            _remarksInput.dataset.key = compositeKey;
                            const collapsedStyle = `flex: 1; border: 1px solid transparent; background: transparent; font-size: 12px; padding: 6px; color: #666; text-align: left; transition: all 0.2s ease; min-width: 0; font-family: inherit; resize: none; height: 28px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; cursor: ${!isEditable ? 'default' : 'text'}; box-sizing: border-box;`;
                            _remarksInput.style.cssText = collapsedStyle;

                            if (isEditable) {
                                _remarksInput.addEventListener('focus', () => { 
                                    _groupWrapper.style.zIndex = '100'; _row.style.zIndex = '101'; u.style.zIndex = '102';
                                    _scoresCell.style.overflow = 'visible';
                                    Object.assign(_remarksInput.style, { position: 'absolute', left: '45px', top: '2px', width: '400px', zIndex: '5000', background: '#ffffff', border: '1px solid #28c76f', borderRadius: '8px', boxShadow: '0 10px 25px rgba(0,0,0,0.2)', whiteSpace: 'normal', padding: '10px', outline: 'none', color: '#111', height: 'auto' }); 
                                    _remarksInput.style.height = (_remarksInput.scrollHeight) + 'px';
                                });
                                _remarksInput.addEventListener('blur', () => { 
                                    _groupWrapper.style.zIndex = ''; _row.style.zIndex = ''; u.style.zIndex = '';
                                    _scoresCell.style.overflow = ''; _scoresCell.style.overflowX = 'auto';
                                    _remarksInput.style.cssText = collapsedStyle; 
                                    const query = `userId=${p.id}&kvdrRoleId=${target.closest("div#candidate-list-popup").dataset.selectedNode}`; 
                                    this.updateUserEvaluation(_userCalValueBtn, dynamicT.calculationTypes, _tableBody, query, profileUpdate, true); 
                                });
                            }
                            u.append(_remarksInput);
                        }

                        _scoresCell.append(u);
                    }
                });
                _row.append(_titleCell, _scoresCell, _weightCell);
                _groupWrapper.append(_row);
            }
            _tableBody.append(_groupWrapper);
        });

        const _footerRow = Utils.createElem("div", ["assessment-footer-row"]);
        _footerRow.style.cssText = "display:flex; align-items:stretch; width: 100%; border-top:1px solid rgba(0,0,0,0.1); box-sizing: border-box; background: #fff;";
        
        const _footerLabel = Utils.createElem("div", "", "", "Total");
        _footerLabel.style.cssText = `padding:10px 10px 10px ${titleLeftPad}; font-size:14px; font-weight:bold; display:flex; align-items:center; justify-content:flex-start; text-align: left; ${colWidthCSS}`;
        
        const _footerTotalWeight = Utils.createElem("div", "", "", _totalEvaluation.total);
        _footerTotalWeight.style.cssText = `padding:10px 10px 10px ${baseLeftPad}; font-size:14px; font-weight:bold; display:flex; align-items:center; justify-content: center; text-align: center; ${weightColCSS}`;
        
        const _footerScores = _footerCalEvalSec; 
        _footerScores.classList.add("invisible-scroll");
        _footerScores.style.cssText = `font-size:14px; font-weight:bold; padding:10px 0px; display:flex; justify-content:flex-start; align-items:center; overflow-x: auto; ${profilesColCSS}`;
        syncScrollers.push(_footerScores);

        _footerRow.append(_footerLabel, _footerScores, _footerTotalWeight);
        d.append(_footerRow);
        l.append(d);
        s.append(l);

        let isSyncingLeftScroll = false;
        syncScrollers.forEach(el => {
            el.addEventListener('scroll', (e) => {
                if (!isSyncingLeftScroll) {
                    isSyncingLeftScroll = true;
                    const scrollValue = e.target.scrollLeft;
                    syncScrollers.forEach(target => { if (target !== e.target) target.scrollLeft = scrollValue; });
                    window.requestAnimationFrame(() => { isSyncingLeftScroll = false; });
                }
            }, { passive: true });
        });
    }

    async _roleProfileData(e){
        this.assessmentData = null; 

        const t = Utils.createElem("ul");
        t.style.cssText = "display:flex; flex-direction:column; height:100%; width:100%; row-gap:15px; box-sizing:border-box;";
        
        const cacheBuster = `&_t=${Date.now()}`;
        
        // --- API FETCHES INCLUDING GRADES & SALARY BANDS ---
        const roleDataPromise = (e.type === 'ROLE') ? e.roleData(`selfId=${e.kvdrRoleId}${cacheBuster}`) : e.profileData(`userId=${e.profile[0].id}&kvdrRoleId=${e.kvdrRoleId}${cacheBuster}`);
        const levelPromise = fetch(`${API_BASE_URL}/api/role/${e.kvdrRoleId}/level`).then(res => res.ok ? res.json() : null);
        
        const orgId = this.getActualOrgId();
        const token = localStorage.getItem('feathers-jwt') || localStorage.getItem('accessToken');
        
        // Fetch Grades
        const gradesPromise = fetch(`${API_BASE_URL}/api/v2/organization/${orgId}/job-grades`, { headers: { 'Authorization': `Bearer ${token}` } }).then(res => res.ok ? res.json() : null);
        // Fetch Salary Bands
        const bandsPromise = fetch(`${API_BASE_URL}/api/v2/organization/${orgId}/salary-bands`, { headers: { 'Authorization': `Bearer ${token}` } }).then(res => res.ok ? res.json() : null);

        // --- NEW: Fetch Actual User Evaluation Score ---
        const evalPromise = (e.type === 'Talent' && e.profile.length > 0)
            // ADDED CACHE BUSTER query param to force fresh real-time data
            ? fetch(`${API_BASE_URL}/api/v2/user-evaluations/${orgId}/${e.kvdrRoleId}/${e.profile[0].id}?_t=${Date.now()}`, { headers: { 'Authorization': `Bearer ${token}` } }).then(res => res.ok ? res.json() : null).catch(() => null)
            : Promise.resolve(null);

        const [roleDataFull, levelData, gradesData, bandsData, userEvalData] = await Promise.all([roleDataPromise, levelPromise, gradesPromise, bandsPromise, evalPromise]);
        this.jobGrades = (gradesData && gradesData.data) ? gradesData.data : [];
        const salaryBands = (bandsData && bandsData.data) ? bandsData.data : [];

        // Locate the salary boundaries for this specific role
        const currentBand = salaryBands.find(b => b.role_id === e.kvdrRoleId || b.selfId === e.kvdrRoleId || b._id === e.kvdrRoleId) || {};
        const roleMinSalary = currentBand.min_salary || null;
        const roleMaxSalary = currentBand.max_salary || null;
        this._activeBandLimits = { min: roleMinSalary, max: roleMaxSalary };
        
        let _currentRoleData = e._localNodeData || {};
        if (roleDataFull && roleDataFull.length > 0) {
            _currentRoleData = Object.assign({}, _currentRoleData, roleDataFull[0]);
        }

        if (levelData && levelData.level) {
            _currentRoleData.level = levelData.level;
        }

        const BACKUP_TAG = "[ROLE_DESC_SAVE]";
        let allLogs = (_currentRoleData.description && Array.isArray(_currentRoleData.description)) ? _currentRoleData.description : [];
        
        let currentTitleValue = _currentRoleData.title || "";
        let currentLevelValue = _currentRoleData.level || ""; 
        let customHeader = null;
        let levelDropdownWrapper = null; 
        
        if (e.type === 'ROLE') {
            customHeader = Utils.createElem("div");
            Utils.applyStyles(customHeader, { display: "flex", alignItems: "center", gap: "10px", flex: "1", minWidth: "0" });
            const titleLabel = Utils.createElem("span", [], "", currentTitleValue);
            Utils.applyStyles(titleLabel, { fontSize: "1.2rem", fontWeight: "700", color: "#111827", fontFamily: "inherit" });
            
            if (currentLevelValue) {
                const levelBadge = Utils.createElem("span", [], "", currentLevelValue);
                Utils.applyStyles(levelBadge, { fontSize: "12px", background: "#f3f4f6", color: "#4b5563", padding: "2px 8px", borderRadius: "12px", border: "1px solid #e5e7eb", fontWeight: "600" });
                customHeader.append(titleLabel, levelBadge);
            } else {
                customHeader.append(titleLabel);
            }
        }

        const accessMap = { 'Appraisal (Self)': 'appraisalData', 'Fitment (Fit)': 'fitmentData', 'Performance (Drive)': 'performanceData', 'Succession (Secure)': 'successionData' };
        const roleAccess = { 0: ['Appraisal (Self)'], 1: ['Appraisal (Self)', 'Fitment (Fit)', 'Performance (Drive)'], 2: ['Appraisal (Self)', 'Fitment (Fit)', 'Performance (Drive)', 'Succession (Secure)'] };
        const allowedFields = roleAccess[this.role()] || [];

        const l = Utils.createElem("li");
        l.style.cssText = "border:2px solid #d0d5dd;border-radius:5px;display:flex;align-items:center;justify-content:space-between;";

        if(e.profile.length && e.profile.length > 0){
             let ids = e.profile.map(p => `&userId=${p.id}`).join('');
             const profileData = await e.profileData(`${ids}&kvdrRoleId=${e.kvdrRoleId}${cacheBuster}`).catch(() => []);
             
             this.assessmentData = []; 
             e.profile.forEach(p => {
                 let apiRecord = profileData.find(pd => pd.userId === p.id) || {};
                 
                 const gData = safeGraphData(this.config());
                 const localNode = gData.find(n => String(n.selfId) === String(e.kvdrRoleId)) || e._localNodeData || {};
                 
                 let localRecord = null;
                 if (localNode.kvdrRoleProfiles) {
                     localRecord = localNode.kvdrRoleProfiles.find(rp => String(rp.userId) === String(p.id));
                 }
                 if (!localRecord && localNode.profiles) {
                     localRecord = localNode.profiles.find(rp => String(rp.userId) === String(p.id));
                 }

                 const cacheKey = `${e.kvdrRoleId}_${p.id}`;
                 const memoryCacheRecord = this.optimisticProfileCache ? this.optimisticProfileCache[cacheKey] : null;
                 
                 let source = JSON.parse(JSON.stringify({ 
                     ...apiRecord, 
                     ...(localRecord || {}),
                     ...(memoryCacheRecord || {})
                 }));
                 
                 // FIX: Inject the userId so we can target it when updating tabs locally
                 let entry = { userId: p.id }; 
                 allowedFields.forEach(field => { 
                     entry[field] = source[accessMap[field]] || ''; 
                 }); 
                 this.assessmentData.push(entry); 
             });
        }
        
        if(e.type === 'Talent'){
            l.style.justifyContent = "flex-start";
            
            if (this.assessmentData && this.assessmentData.length > 0) {
                this.assessmentData = [this.assessmentData[0]];
            }

            const a = Utils.createElem("label", "", "", ""); 
            a.style.cssText = "display:flex;align-items:center;padding:5px;";
            
            const r = Utils.createElem("img", ["roleProfileImg"], "", ""); 
            r.setAttribute("src", e.profile[0].imageUrl); 
            r.style.cssText = "width:45px;height:45px;oveflow:hidden;object-fit:cover;object-position:center;border-radius:50%;margin-right:10px";
            
            const s = Utils.createElem("span", "", "", ""); 
            s.style.cssText = "text-align:left;";
            
            // --- NEW: RENDER BADGE HERE ---
            const nameRow = Utils.createElem("div");
            nameRow.style.cssText = "display:flex; align-items:center;";
            
            const o = Utils.createElem("h5", "", "", e.profile[0].name); 
            o.style.cssText = "margin:0; font-size:16px; font-weight:700; color:#111827;";
            
            // Evaluated vs Pending Tag
            const evalTag = Utils.createElem("span", ["eval-status-tag"], `eval-tag-${e.profile[0].id}`, "");
            
            // Salary/Grade Badge Container
            const gradeBadgeContainer = Utils.createElem("span", ["job-grade-container"], `grade-badge-container-${e.profile[0].id}`, "");
            gradeBadgeContainer.style.display = "none"; // Hidden until explicitly calculated
            
            nameRow.append(o, evalTag, gradeBadgeContainer);

            const n = Utils.createElem("span", "", "", e.profile[0].emailId); 
            n.style.cssText = "font-size:12px; font-weight:500; color:#6B7280; display:block; margin-top:2px;"; 
            
            s.append(nameRow, n);

            // --- FIX: Strictly Determine if Evaluated ---
            const candidateData = e.profile[0];
            let hasBeenEvaluated = false;
            let actualScore = null;

            // Check if backend returned valid evaluation data (Safely check BOTH keys)
            if (userEvalData && userEvalData.data) {
                let rawTotal = userEvalData.data.total_weighted_score !== undefined ? userEvalData.data.total_weighted_score : userEvalData.data.total_score;
                if (rawTotal !== undefined && rawTotal !== null) {
                    hasBeenEvaluated = true;
                    actualScore = rawTotal;
                }
            }

            if (hasBeenEvaluated) {
                // evalTag.innerText = "Evaluated";
                // evalTag.style.cssText = "font-size:11px; padding:2px 8px; border-radius:12px; border:1px solid #bbf7d0; font-weight:700; background:#f0fdf4; color:#15803d; margin-left: 10px;";
                this._updateJobGradeBadge(candidateData.id, actualScore, roleMinSalary, roleMaxSalary, gradeBadgeContainer);
            } else {
                // evalTag.innerText = "Pending Evaluation";
                // evalTag.style.cssText = "font-size:11px; padding:2px 8px; border-radius:12px; border:1px solid #fde68a; font-weight:700; background:#fef3c7; color:#b45309; margin-left: 10px;";
                this._updateJobGradeBadge(candidateData.id, null, roleMinSalary, roleMaxSalary, gradeBadgeContainer);
            }

            const i = Utils.createElem("span", ["removeRoleProfile"], "remove-role-profile-" + e.profile[0].id + "-btn", "-");
            i.style.cssText = "background:#FF0000;border-radius:50%;width:30px;height:30px;line-height:30px;font-size:30px;cursor:pointer;color:#FFF;margin-right:15px;margin-left:auto;display:flex;justify-content:center;align-items:center;padding-bottom:4px;flex-shrink:0;";
            this.attachTooltip(i, "Remove Profile");
            
            // NEW LOGIC: Intercept click to show confirmation popup
            i.addEventListener("click", (evt) => {
                evt.preventDefault();
                evt.stopPropagation();

                const userName = e.profile[0].name || e.profile[0].emailId || "this user";
                const roleName = currentTitleValue || "this role";

                const wrapper = Utils.createElem("div");
                Utils.applyStyles(wrapper, { padding: "16px 20px", textAlign: "left" });

                const icon = Utils.createElem("div", [], "", "⚠️");
                Utils.applyStyles(icon, { fontSize: "28px", marginBottom: "10px", marginTop: "-8px" });

                const msg = Utils.createElem("h3", [], "", "Remove User?");
                Utils.applyStyles(msg, { margin: "0 0 8px 0", color: "#d32f2f", fontSize: "18px", fontWeight: "600", textAlign: "left" });

                const desc = Utils.createElem("p", [], "", `Are you sure you want to remove <b>${userName}</b> from the role <b>${roleName}</b>?<br><br>All evaluation data, scores, and remarks added for this user in this role will be permanently deleted.`);
                Utils.applyStyles(desc, { margin: "0", color: "#555", fontSize: "14px", lineHeight: "1.6", textAlign: "left" });

                wrapper.append(icon, msg, desc);

                const confirmBtn = Utils.createElem("button", [], "", "Yes, Remove");
                Utils.applyStyles(confirmBtn, {
                    background: "#dc3545", color: "#fff", border: "none", padding: "10px 24px",
                    borderRadius: "6px", cursor: "pointer", fontWeight: "600", fontSize: "14px"
                });

                // Create a temporary overlay just for this confirmation
                const confirmOverlay = Utils.createElem("div", ["confirm-remove-overlay"]);
                Utils.applyStyles(confirmOverlay, {
                    position: "fixed", top: "0", left: "0", width: "100%", height: "100%",
                    background: "rgba(0,0,0,0.6)", zIndex: "9999999", display: "flex",
                    alignItems: "center", justifyContent: "center"
                });

                const popupConfig = {
                    headerText: "Confirm Removal",
                    onCloseClick: () => { confirmOverlay.remove(); },
                    data: wrapper,
                    displaySettings: { width: "450px", height: "auto" },
                    footer: confirmBtn
                };

                const popup = this.createPopup(popupConfig);
                
                // Override the close button behavior to only close this specific secondary overlay
                const closeBtn = popup.querySelector('.popupShutDownBtn');
                if (closeBtn) {
                    closeBtn.onclick = (ev) => { 
                        ev.stopPropagation(); 
                        confirmOverlay.remove(); 
                    };
                }

                confirmBtn.addEventListener("click", () => {
                    confirmOverlay.remove();
                    // Trigger actual API removal (this will also safely close the parent evaluation modal via your existing setup)
                    e.removeProfile({ userId: e.profile[0].id, kvdrRoleId: e.kvdrRoleId });
                });

                confirmOverlay.append(popup);
                document.body.append(confirmOverlay);
            });
            
            a.append(r, s); 
            l.append(a, i);
        } else {
             l.style.display = "none"; 
        }

        const d = Utils.createElem("div");
        d.style.cssText = "display:flex; flex-direction:column; flex:1; width:100%; row-gap:10px; min-height:0;";
        const tabBtnsContainer = Utils.createElem("div");
        tabBtnsContainer.style.cssText = "gap:10px;display:flex;align-items:center;flex-wrap:wrap;";
        const contentContainer = Utils.createElem("div");
        Utils.applyStyles(contentContainer, { flex: '1', width: '100%', display: 'flex', flexDirection: 'column' });

        const criteriaBtn = Utils.createElem("button", ["criteriaBtn"]);
        const slidersIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNjQ2NDY0IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGxpbmUgeDE9IjQiIHkxPSIyMSIgeDI9IjQiIHkyPSIxNCI+PC9saW5lPjxsaW5lIHgxPSI0IiB5MT0iMTAiIHgyPSI0IiB5Mj0iMyI+PC9saW5lPjxsaW5lIHgxPSIxMiIgeTE9IjIxIiB4Mj0iMTIiIHkyPSIxMiI+PC9saW5lPjxsaW5lIHgxPSIxMiIgeTE9IjgiIHgyPSIxMiIgeTI9IjMiPjwvbGluZT48bGluZSB4MT0iMjAiIHkxPSIyMSIgeDI9IjIwIiB5Mj0iMTYiPjwvbGluZT48bGluZSB4MT0iMjAiIHkxPSIxMiIgeDI9IjIwIiB5Mj0iMyI+PC9saW5lPjxsaW5lIHgxPSIxIiB5MT0iMTQiIHgyPSI3IiB5Mj0iMTQiPjwvbGluZT48bGluZSB4MT0iOSIgeTE9IjgiIHgyPSIxNSIgeTI9IjgiPjwvbGluZT48bGluZSB4MT0iMTciIHkxPSIxNiIgeDI9IjIzIiB5Mj0iMTYiPjwvbGluZT48L3N2Zz4=";
        criteriaBtn.style.cssText = `width: 40px; height: 40px; border: none; border-radius: 8px; cursor: pointer; padding: 4px 10px; background-color: #f0f0f0; background-image: url('${slidersIcon}'); background-position: center center; background-size: 20px; background-repeat: no-repeat;`;
        criteriaBtn.title = "Evaluation Criteria Configuration";
        
        criteriaBtn.addEventListener("click", (evt) => {
            evt.preventDefault();
            const roleId = e.kvdrRoleId;
            let userId = null;
            if (e.type === 'Talent' && e.profile && e.profile.length > 0) {
                userId = e.profile[0].id;
            }

            if (this.vueInstance && typeof this.vueInstance.openEvaluationCriteriaModal === 'function') {
                this.vueInstance.openEvaluationCriteriaModal(this.getActualOrgId(), roleId, userId, () => {
                    document.dispatchEvent(new CustomEvent('organigram-force-popup-refresh'));
                });
            }
            if (window._boundTagUpdate) {
            document.removeEventListener('update-job-grade-tags', window._boundTagUpdate);
        }
        window._boundTagUpdate = (e) => {
            const { userId, newScore } = e.detail;
            if (userId && newScore !== undefined) {
                const badgeContainer = document.getElementById(`grade-badge-container-${userId}`);
                const evalTag = document.getElementById(`eval-tag-${userId}`);
                
                // Update Grade and Salary
                if (badgeContainer) {
                    const min = this._activeBandLimits ? this._activeBandLimits.min : null;
                    const max = this._activeBandLimits ? this._activeBandLimits.max : null;
                    this._updateJobGradeBadge(userId, newScore, min, max, badgeContainer);
                }
                
                // Ensure 'Evaluated' pill turns Green
                if (evalTag) {
                    evalTag.innerText = "Evaluated";
                    evalTag.style.cssText = "font-size:11px; padding:2px 8px; border-radius:12px; border:1px solid #bbf7d0; font-weight:700; background:#f0fdf4; color:#15803d; margin-left: 10px;";
                }
            }
        };
        document.addEventListener('update-job-grade-tags', window._boundTagUpdate);
        });

        const notesBtn = Utils.createElem("button", ["descBtn"]);
        notesBtn.style.cssText = `width: 40px; height: 40px; border: none; border-radius: 8px; cursor: pointer; padding: 4px 10px; background-color: #f0f0f0; background-image: url(${Comment}); background-position: center center; background-size: auto; background-repeat: no-repeat;`;
        notesBtn.title = "Notes & Logs";
        
        const notesWrapper = Utils.createElem("div");    
        const togglePopupFooter = (event, show) => {
            const popup = event.target.closest('.organiGramPopup');
            if (popup) {
                const footer = popup.querySelector('.OrganiGramPopupFooter');
                if (footer) footer.style.display = show ? 'flex' : 'none';
            }
        };

        const switchTab = (viewName, targetBtn) => {
            contentContainer.innerHTML = "";
            Array.from(tabBtnsContainer.children).forEach(btn => { btn.style.backgroundColor = "#f0f0f0"; btn.style.color = "#646464"; });
            if(targetBtn){ targetBtn.style.backgroundColor = e.displaySettings.cc; if(targetBtn !== notesBtn) targetBtn.style.color = e.displaySettings.tc; }
            if (viewName === 'NOTES') contentContainer.append(notesWrapper);
        };

        const dynamicT = this.getDynamicConfig(e.kvdrOrgConfigData);
        const defaultType = dynamicT.calculationTypes ? dynamicT.calculationTypes.find(type => type.default === true) : null;
        const defaultVal = defaultType ? Utils.parseNumber(defaultType.value) : 0;

        if (this.assessmentData) {
            allowedFields.forEach((item) => {
                if (!item) return;
                const btn = Utils.createElem("button", ["tabBtn"], "", item);
                const configKey = accessMap[item.trim()];
                const dataKey = configKey ? configKey.replace('Data', '') : '';
                
                let hasData = false;
                if (Array.isArray(this.assessmentData)) {
                    hasData = this.assessmentData.some(candData => {
                        const tabData = candData[item] || candData[configKey] || candData[dataKey];
                        if (Array.isArray(tabData) && tabData.length > 0) {
                            return tabData.some(entry => 
                                Utils.parseNumber(entry.score !== undefined ? entry.score : entry.value) !== defaultVal
                            );
                        }
                        return false;
                    });
                }

                btn.style.cssText = `min-width:100px;height:40px;color:#646464;font-size:13px;text-align:center;border:2px solid transparent;border-radius:8px;cursor:pointer;font-weight:bold;padding:2px 8px;line-height:15px;transition:all 0.2s;background-color:#f0f0f0;`;
                if (hasData) btn.style.borderColor = "#28c76f";
                btn.value = configKey || ''; 
                
                btn.addEventListener("click", (evt) => {
                    evt.preventDefault(); 
                    const popup = evt.target.closest('.organiGramPopup');
                    if (popup) {
                        const footer = popup.querySelector('.OrganiGramPopupFooter');
                        if (footer) footer.style.display = 'flex';
                    }
                    if (typeof togglePopupFooter === 'function') togglePopupFooter(evt, true);
                    
                    this.createRelativeUsrData(
                        this.assessmentData, e.kvdrOrgConfigData, evt.target, e.profile, contentContainer, e.profileUpdate, e.displaySettings, e.type 
                    );
                });
                tabBtnsContainer.append(btn);
            });
        }
        
        const PYTHON_API_URL = process.env.VUE_APP_API_URL; 

        let roleNotes = [];
        if (e.type === 'ROLE') {
            try {
                const token = localStorage.getItem('feathers-jwt') || localStorage.getItem('accessToken');
                const res = await fetch(`${PYTHON_API_URL}/api/roles/${e.kvdrRoleId}/notes`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (res.ok) {
                    const notesData = await res.json();
                    roleNotes = notesData.data || [];
                }
            } catch(err) { console.error("Failed to fetch role notes from Python:", err); }
        }

        notesBtn.addEventListener("click", (evt) => { evt.preventDefault(); switchTab('NOTES', evt.currentTarget); togglePopupFooter(evt, false); });
        
        const isUserSide = window.location.pathname.includes('/user/');
        
        // ONLY append the criteria button if we are NOT clicking on the main Role card
        // if (!isUserSide && e.type !== 'ROLE') {
        //     criteriaBtn.style.marginLeft = "auto";
        //     tabBtnsContainer.append(criteriaBtn);
        // } else {
        //     // Pushes the chat bubble to the far right since the settings icon is hidden
        //     notesBtn.style.marginLeft = "auto";
        // }
        notesBtn.style.marginLeft = "auto";
        tabBtnsContainer.append(notesBtn);
        
        Utils.applyStyles(notesWrapper, { position: "relative", width: "100%" });

        const mentionBox = Utils.createElem("div", ["mention-dropdown"]);
        Utils.applyStyles(mentionBox, { position: 'absolute', background: '#fff', border: '1px solid #ddd', borderRadius: '8px', boxShadow: '0 4px 15px rgba(0,0,0,0.2)', maxHeight: '200px', overflowY: 'auto', zIndex: '999999', display: 'none', width: '250px', bottom: '70px', left: '15px' });

        const notesLogTextarea = Utils.createElem("textarea",["descBox", "invisible-scroll-y"], "", "", {'placeholder':"Add a new note... Type @ to mention someone", 'rows':5, 'maxlength':2500});
        notesLogTextarea.style.cssText = `width:100%;height:240px;font-family:inherit;color:${e.displaySettings.tc};resize:none;padding:15px;padding-right:75px;border-radius:10px;border:1px solid #ddd;box-sizing:border-box; overflow-y: auto; scrollbar-width: none; -ms-overflow-style: none;`;
        
        const notesSaveBtn = Utils.createElem("button", ["saveNoteBtn"], "", "");
        const noteTickIcon = Utils.createElem("i", ["vs-icon", "notranslate", "icon-scale", "feather", "icon-check"]);
        Utils.applyStyles(noteTickIcon, { fontSize: "18px", color: "#fff", fontWeight: "bold" });
        notesSaveBtn.append(noteTickIcon);
        Utils.applyStyles(notesSaveBtn, { position: 'absolute', top: '190px', right: '12px', backgroundColor: "#28c76f", border: "none", borderRadius: "50%", width: "36px", height: "36px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", boxShadow: "0 2px 5px rgba(0,0,0,0.2)", zIndex: "3", transition: "all 0.2s", opacity: "0", transform: "scale(0.8)", pointerEvents: "none" });

        let activeMentions = [];

        notesLogTextarea.addEventListener('input', () => {
            if(notesLogTextarea.value.trim().length > 0) {
                notesSaveBtn.style.opacity = "1"; notesSaveBtn.style.transform = "scale(1)"; notesSaveBtn.style.pointerEvents = "all";
            } else {
                notesSaveBtn.style.opacity = "0"; notesSaveBtn.style.transform = "scale(0.8)"; notesSaveBtn.style.pointerEvents = "none";
            }
            const val = notesLogTextarea.value;
            const cursorPos = notesLogTextarea.selectionStart;
            const textBeforeCursor = val.substring(0, cursorPos);
            const lastAtSignIndex = textBeforeCursor.lastIndexOf('@');
            
            if (lastAtSignIndex !== -1) {
                const query = textBeforeCursor.substring(lastAtSignIndex + 1).toLowerCase();
                if (!query.includes(' ') && !query.includes('\n')) {
                    const candidates = e.candidateList || (typeof this.config === 'function' ? this.config().candidateList : []) || [];
                    const matches = candidates.filter(c => (c.name && c.name.toLowerCase().includes(query)) || (c.email && c.email.toLowerCase().includes(query))).slice(0, 5); 
                    
                    if (matches.length > 0) {
                        mentionBox.innerHTML = '';
                        matches.forEach(match => {
                            const item = Utils.createElem('div');
                            Utils.applyStyles(item, { padding: '10px 12px', cursor: 'pointer', fontSize: '13px', borderBottom: '1px solid #eee', display: 'flex', alignItems: 'center', gap: '8px', color: '#000' });
                            const avatar = match.imageUrl || match.image_url || "https://cdn-icons-png.flaticon.com/512/149/149071.png";
                            item.innerHTML = `<img src="${avatar}" style="width:24px;height:24px;border-radius:50%;object-fit:cover;"> <span style="font-weight:600;color:#333;">${match.name || match.email.split('@')[0]}</span>`;
                            item.onmouseenter = () => item.style.background = '#f9fafb';
                            item.onmouseleave = () => item.style.background = '#fff';
                            item.onclick = () => {
                                const insertText = `${match.name || match.email.split('@')[0]} `;
                                notesLogTextarea.value = val.substring(0, lastAtSignIndex + 1) + insertText + val.substring(cursorPos);
                                const trueId = match.id || match.user_id || match._id;
                                if (trueId && !activeMentions.includes(trueId)) activeMentions.push(trueId);
                                mentionBox.style.display = 'none';
                                notesLogTextarea.focus();
                                notesLogTextarea.dispatchEvent(new Event('input')); 
                            };
                            mentionBox.append(item);
                        });
                        mentionBox.style.display = 'block';
                    } else { mentionBox.style.display = 'none'; }
                } else { mentionBox.style.display = 'none'; }
            } else { mentionBox.style.display = 'none'; }
        });

        document.addEventListener('click', (ev) => {
            if (ev.target !== notesLogTextarea && !mentionBox.contains(ev.target)) mentionBox.style.display = 'none';
        });

        notesSaveBtn.addEventListener('click', async (evt) => {
            evt.preventDefault(); evt.stopPropagation();
            const noteText = notesLogTextarea.value.trim();
            if(!noteText) return;
            noteTickIcon.className = "vs-icon notranslate icon-scale feather icon-loader ai-icon-loading";
            
            const token = localStorage.getItem('feathers-jwt') || localStorage.getItem('accessToken');
            const currentUserId = (typeof this.user === 'function' ? this.user()._id : this.config().user._id);

            if (e.type === 'ROLE') {
                try {
                    const payload = { user_id: currentUserId, note_text: noteText, mentions: activeMentions };
                    const res = await fetch(`${PYTHON_API_URL}/api/roles/${e.kvdrRoleId}/notes`, {
                        method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify(payload)
                    });

                    if (res.ok) {
                        const fetchRes = await fetch(`${PYTHON_API_URL}/api/roles/${e.kvdrRoleId}/notes`, { headers: { 'Authorization': `Bearer ${token}` } });
                        const notesData = await fetchRes.json();
                        roleNotes = notesData.data || [];
                        const oldHistory = notesWrapper.querySelector('.descLogsBox');
                        if(oldHistory) oldHistory.remove();
                        const newHistory = this.descriptionLogs(roleNotes, notesLogTextarea);
                        notesWrapper.append(newHistory);
                        notesLogTextarea.value = ""; activeMentions = [];
                        notesSaveBtn.style.opacity = "0"; notesSaveBtn.style.transform = "scale(0.8)"; notesSaveBtn.style.pointerEvents = "none";
                        setTimeout(() => { noteTickIcon.className = "vs-icon notranslate icon-scale feather icon-check"; }, 500);
                    } else {
                        alert("Failed to save to Python DB."); noteTickIcon.className = "vs-icon notranslate icon-scale feather icon-x";
                    }
                } catch(err) { alert("Network error."); noteTickIcon.className = "vs-icon notranslate icon-scale feather icon-x"; }
            } else {
                const newLog = { msg: noteText, userId: currentUserId, createdAt: new Date() };
                const updatedLogs = [...allLogs, newLog];
                const param = { query : `userId=${e.profile[0].id}&kvdrRoleId=${e.kvdrRoleId}`, data : { description: updatedLogs } };
                try {
                    await e.profileUpdate(param);
                    allLogs = updatedLogs;
                    let visibleNotes = updatedLogs.filter(log => !log.msg || !log.msg.startsWith(BACKUP_TAG));
                    const oldHistory = notesWrapper.querySelector('.descLogsBox');
                    if(oldHistory) oldHistory.remove();
                    const newHistory = this.descriptionLogs(visibleNotes, notesLogTextarea);
                    notesWrapper.append(newHistory);
                    notesLogTextarea.value = "";
                    notesSaveBtn.style.opacity = "0"; notesSaveBtn.style.transform = "scale(0.8)"; notesSaveBtn.style.pointerEvents = "none";
                    setTimeout(() => { noteTickIcon.className = "vs-icon notranslate icon-scale feather icon-check"; }, 500);
                } catch(err) { console.error(err); noteTickIcon.className = "vs-icon notranslate icon-scale feather icon-x"; }
            }
        });
        
        let initialNotes = (e.type === 'ROLE') ? roleNotes : allLogs.filter(log => !log.msg || !log.msg.startsWith(BACKUP_TAG));
        let notesLogHistory = this.descriptionLogs(initialNotes, notesLogTextarea);
        notesWrapper.append(mentionBox, notesLogTextarea, notesSaveBtn, notesLogHistory);
        
        const firstEvalButton = tabBtnsContainer.querySelector('button.tabBtn');
        if (firstEvalButton) {
            firstEvalButton.click(); 
        } else if (notesBtn) {
            notesBtn.click();
        } else {
            contentContainer.innerHTML = "<p style='padding:20px; color:#666;'>No evaluation data available.</p>";
        }

        d.append(tabBtnsContainer, contentContainer);
        t.append(l, d);
        
        return { content: t, customHeader: customHeader, levelDropdownWrapper: levelDropdownWrapper, rawData: _currentRoleData };
    }

    // ==========================================
    // 4. UPDATED EVALUATION UPDATER
    // ==========================================
    updateUserEvaluation(target, calType, container, query, profileUpdate, isTextOnlyUpdate = false) {
        if (!isTextOnlyUpdate) {
            let calTypeIndex = calType.findIndex(x => parseFloat(x.value) === parseFloat(target.dataset.value));
            (calTypeIndex === 0) ? calTypeIndex = calType.length - 1 : calTypeIndex--;
            target.dataset.value = calType[calTypeIndex].value;
            target.style.background = calType[calTypeIndex].color;
        }

        let data = [],
            total = 0,
            group = target.dataset.group;

        const keyAttris = container.querySelectorAll('[data-target-profile="' + target.dataset.targetProfile + '"]');
        
        keyAttris.forEach(item => {
            const parent = item.parentElement; 
            const remarksInput = parent.querySelector('textarea.remarks-input');
            const remarksVal = remarksInput ? remarksInput.value : "";

            data.push({
                key: item.dataset.key,
                value: item.dataset.value, 
                score: item.dataset.value, 
                remarks: remarksVal        
            });
            
            total += Utils.parseNumber(item.dataset.keyValue) * Utils.parseNumber(item.dataset.value);
        });

        const footerTotal = container.parentElement.querySelector('[data-targetprofile="' + target.dataset.targetProfile + '"]');
        if (footerTotal) footerTotal.innerText = Math.round(total);

        // --- NEW: Update the Job Grade Badge live ---
        this._updateJobGradeBadge(target.dataset.targetProfile, total, _totalEvaluation.total);

        try {
                const kvdrRoleId = target.closest("div#candidate-list-popup")?.dataset?.selectedNode;
                const profileId = target.dataset.targetProfile;
                
                // ---> CRITICAL FIX START: Instantly update active tab data so it survives tab switching <---
                if (this.assessmentData && Array.isArray(this.assessmentData)) {
                    const candData = this.assessmentData.find(c => String(c.userId) === String(profileId));
                    if (candData) {
                        const clonedData = JSON.parse(JSON.stringify(data));
                        candData[group] = clonedData; // Updates 'performanceData'
                        
                        // FIX: The view renderer prioritizes the literal Tab Title (e.g. "Performance (Drive)") 
                        // over the internal key name. We MUST update the literal name as well, otherwise it reverts to the initial DB state!
                        const reverseAccessMap = { 
                            'appraisalData': 'Appraisal (Self)', 
                            'fitmentData': 'Fitment (Fit)', 
                            'performanceData': 'Performance (Drive)', 
                            'successionData': 'Succession (Secure)' 
                        };
                        const tabName = reverseAccessMap[group];
                        if (tabName) {
                            candData[tabName] = clonedData;
                        }
                    }
                }
                // ---> CRITICAL FIX END <---

                if (kvdrRoleId && profileId) {
                    this.optimisticProfileCache = this.optimisticProfileCache || {};
                    const cacheKey = `${kvdrRoleId}_${profileId}`;
                    this.optimisticProfileCache[cacheKey] = this.optimisticProfileCache[cacheKey] || {};
                    this.optimisticProfileCache[cacheKey][group] = JSON.parse(JSON.stringify(data));

                let gData = [];
                if (typeof this.config === 'function') {
                    const conf = this.config();
                    if (conf && conf.data && Array.isArray(conf.data.graphData)) {
                        gData = conf.data.graphData;
                    }
                }

                if (gData.length > 0) {
                    const localNode = gData.find(n => String(n.selfId) === String(kvdrRoleId));
                    if (localNode) {
                        if (!localNode.kvdrRoleProfiles) localNode.kvdrRoleProfiles = [];
                        let localProfile = localNode.kvdrRoleProfiles.find(p => String(p.userId) === String(profileId));
                        if (!localProfile) {
                            localProfile = { userId: profileId };
                            localNode.kvdrRoleProfiles.push(localProfile);
                        }
                        localProfile[group] = JSON.parse(JSON.stringify(data));
                        
                        if (!localNode.profiles) localNode.profiles = [];
                        let pProfile = localNode.profiles.find(p => String(p.userId) === String(profileId));
                        if (pProfile) {
                            pProfile[group] = JSON.parse(JSON.stringify(data));
                        } else {
                            localNode.profiles.push(JSON.parse(JSON.stringify(localProfile)));
                        }
                    }
                }
            }
        } catch (e) {
            console.warn("Local cache sync skipped:", e);
        }

        const dataObj = {};
        dataObj[group] = data;
        this.param = { query: query, data: dataObj };
        
        if (typeof profileUpdate === 'function') {
            profileUpdate(this.param).catch(err => console.error("Sync Error:", err));
        }
    }

    // Helper to recreate the header if needed (keep logic clean)
    _createTitleHeader(ref, updateFn, roleId) {
        const customHeader = Utils.createElem("div");
        Utils.applyStyles(customHeader, { display: "flex", alignItems: "center", gap: "10px", width: "100%", paddingRight: "10px" });
        const titleInput = Utils.createElem("input", ["roleTitleInputHeader"], "", "");
        titleInput.value = ref.value;
        titleInput.placeholder = "Role Name";
        Utils.applyStyles(titleInput, { fontSize: "1.2rem", fontWeight: "700", color: "#111827", border: "1px solid transparent", background: "transparent", width: "auto", minWidth: "250px", padding: "4px 8px", borderRadius: "4px", fontFamily: "inherit" });
        titleInput.addEventListener('input', (evt) => { ref.value = evt.target.value; }); // Sync with ref for save button
        customHeader.append(titleInput);
        return customHeader;
    }

    createRoleConfig(body){
        const container = body.querySelector(`#organigram-popup-body`);
        const configPanel = Utils.createElem("div",["configPanel"]);
        Utils.applyStyles(configPanel,{
            position : "absolute",
            inset : "0px",
            background: "rgba(255, 255, 255, 0.5)",
            padding: "10px",
            display: "flex",
            flexFlow: "column"
        })
        const headerPanel = Utils.createElem("div",["headerPanel"]);
        Utils.applyStyles(headerPanel,{display:"flex",justifyContent:"space-between",padding:"0px 10px",position:"sticky",top:"0px"});
        const tips = Utils.createElem("span","","","&#128161;");
        const controlPanel = Utils.createElem("div",["controlPanel"]);
        Utils.applyStyles(controlPanel,{display:"flex",gap:"10px",alignItems:"center"});
        const saveBtn = Utils.createElem("button");
        const cancelBtn = Utils.createElem("button");
        const btnStyles = {};
        Utils.applyStyles(saveBtn,btnStyles),Utils.applyStyles(cancelBtn,btnStyles);
        //append buttons to control panel
        controlPanel.append(saveBtn,cancelBtn);
        //append controls and tips to header panel
        headerPanel.append(tips,controlPanel)
        //append header Panel to config panel
        configPanel.append(headerPanel)
        container.append(configPanel);
    }
    createSkillSpan = (skills, roleId, roleUpdateAPI, keyName) => {
        const skillsContainer = Utils.createElem('div');
        Utils.applyStyles(skillsContainer, {
            marginTop: '10px',
            display: 'flex',
            flexWrap: 'wrap',
            gap: '6px',
            alignContent: 'flex-start',
            height: '80px',         // Fixed Height
            overflowY: 'auto',      // Scroll if needed
            width: '100%',
            padding: '4px',
            border: '1px solid #f1f5f9',
            borderRadius: '6px',
            background: '#fafafa',
            boxSizing: 'border-box'
        });

        if (Array.isArray(skills)) {
            skills.forEach(skill => {
                const skillPill = Utils.createElem('span', [], '', '', { 'data-value': skill });
                Utils.applyStyles(skillPill, {
                    background: '#fff', color: '#334155', borderRadius: '16px', 
                    padding: '4px 8px 4px 12px', display: 'inline-flex', alignItems: 'center',
                    gap: '6px', fontSize: '12px', border: '1px solid #e2e8f0',
                    maxWidth: '100%', height: '24px', boxSizing: 'border-box', flexShrink: 0
                });

                const skillText = Utils.createElem('span', [], '', skill);
                skillText.setAttribute('title', skill);
                Utils.applyStyles(skillText, {
                    maxWidth: '120px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block'
                });

                const delSkillBtn = Utils.createElem('button', [], '', '×', { 'data-value': skill });
                Utils.applyStyles(delSkillBtn, {
                    background: 'transparent', color: '#94a3b8', border: 'none', cursor: 'pointer',
                    width: '16px', height: '16px', display: 'flex', alignItems: 'center',
                    justifyContent: 'center', fontSize: '14px', fontWeight: 'bold', padding: '0', flexShrink: 0
                });
                
                delSkillBtn.addEventListener('click', () => this.delRoleSkill(skillPill, roleId, roleUpdateAPI, skills, keyName));
                skillPill.append(skillText, delSkillBtn);
                skillsContainer.append(skillPill);
            });
        }
        return skillsContainer;
    }
   
    descriptionLogs = (logs,box) =>{
        let currentIndex = logs.length;
        const container = Utils.createElem("div",["descLogsBox"]);
        Utils.applyStyles(container,{display:"flex",gap:'10px',alignItems:"center",justifyContent:"space-between"})
        const msgBox = Utils.createElem("div",["descLog"],"",`This description is being logged by you.`);
              msgBox.style.cssText = `flex: 0 1 calc(100% - 70px);`;
    
        const handleLog = (log) => {
            const logUser = this.config().candidateList.find(candidate => candidate.id === log.userId) || log.userId;
            msgBox.innerText = `This description was logged by ${logUser.name} at ${log.createdAt}`;
            box.value = log.msg;
        }
        const btnStyles = {
            background: "#d7d7d7",
            border: "none",
            padding: "5px",
            fontSize: "15px",
            borderRadius: "2px",
            cursor: "pointer"
        }
        const prevBtn = Utils.createElem("button",["prevLogBtn"],"",`&larr;`);
        Utils.applyStyles(prevBtn,btnStyles);
        prevBtn.addEventListener('click',(e)=>{
            e.preventDefault();
            if(currentIndex == 0) {Utils.playBellSound(800,840,'square'); return;}
            currentIndex--;
            handleLog(logs[currentIndex]);
        });
        const nextBtn = Utils.createElem("button",["nextLogBtn"],"",`&rarr;`);
        Utils.applyStyles(nextBtn,btnStyles);
        nextBtn.addEventListener('click',(e)=>{
            e.preventDefault();
            currentIndex++;
            if(currentIndex > logs.length){currentIndex = logs.length;Utils.playBellSound(800,840,'square'); return;}
            else if(currentIndex == logs.length){msgBox.innerText = `This description is being logged by you.`;box.value=""}
            else handleLog(logs[currentIndex]);
        })
        container.append(prevBtn,msgBox,nextBtn);
        return container;
    }
    // a small function to use change background color of selected tab button
    selectBtn(target,settings){
        let nextSibling = target.nextElementSibling;
        let prevSibling = target.previousElementSibling;
        while(nextSibling){
            nextSibling.style.backgroundColor = "#f0f0f0";
            nextSibling.style.color = "#646464";
            nextSibling = nextSibling.nextElementSibling;
        }
        while(prevSibling){
            prevSibling.style.backgroundColor = "#f0f0f0"
            prevSibling.style.color = "#646464";
            prevSibling = prevSibling.previousElementSibling;
        }
        target.style.backgroundColor = settings.cc;
        target.style.color = settings.tc;
    }
    getDynamicConfig(passedConfig) {
        // 1. STRICT PRIORITY: The live API data fetched directly from /kvdr-org-config
        if (this.cachedOrgConfig && this.cachedOrgConfig.appraisalData) {
            let config = { ...this.cachedOrgConfig };
            // Map legacy keys just in case
            if (!config.appraisalData && config.appraisal) config.appraisalData = config.appraisal;
            if (!config.fitmentData && config.fitment) config.fitmentData = config.fitment;
            return config;
        }

        // 2. FALLBACK: Data passed from Vue (if the internal fetch hasn't finished yet)
        let finalConfig = { ...passedConfig };
        if (!finalConfig.appraisalData && finalConfig.appraisal) finalConfig.appraisalData = finalConfig.appraisal;
        if (!finalConfig.fitmentData && finalConfig.fitment) finalConfig.fitmentData = finalConfig.fitment;
        
        return finalConfig;
    }   
    
    updateRoleSkills = (roleId, container, skills, api, keyName) => {
        // Trigger ONLY on 'Enter'
        if (event.key === 'Enter') {
            event.preventDefault();
            let rawValue = event.target.value || '';
            
            // Split the input by commas, trim extra spaces, and remove empty strings
            let items = rawValue.split(',').map(item => item.trim()).filter(item => item !== '');
            
            if (items.length === 0) {
                event.target.value = '';
                return; 
            }

            let addedNew = false;
            
            items.forEach(item => {
                // Prevent duplicate skill tags from being added
                if (skills.some(s => s.toLowerCase() === item.toLowerCase())) {
                    return; 
                }

                const query = `${roleId}`;
                skills.push(item);
                addedNew = true;

                const skillPill = Utils.createElem('span', [], '', '', { 'data-value': item });
                Utils.applyStyles(skillPill, {
                    background: '#fff', color: '#334155', borderRadius: '16px', 
                    padding: '4px 8px 4px 12px', display: 'inline-flex', alignItems: 'center',
                    gap: '6px', fontSize: '12px', border: '1px solid #e2e8f0',
                    maxWidth: '100%', height: '24px', boxSizing: 'border-box', flexShrink: 0,
                    marginTop: '0'
                });

                const skillText = Utils.createElem('span', [], '', item);
                skillText.setAttribute('title', item);
                Utils.applyStyles(skillText, {
                    maxWidth: '120px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block'
                });

                const delSkillBtn = Utils.createElem('button', [], '', '×', { 'data-value': item });
                Utils.applyStyles(delSkillBtn, {
                    background: 'transparent', color: '#94a3b8', border: 'none', cursor: 'pointer',
                    width: '16px', height: '16px', display: 'flex', alignItems: 'center',
                    justifyContent: 'center', fontSize: '14px', fontWeight: 'bold', padding: '0', flexShrink: 0
                });

                delSkillBtn.addEventListener('click', () => this.delRoleSkill(skillPill, roleId, api, skills, keyName));
                skillPill.append(skillText, delSkillBtn);
                
                container.append(skillPill);
            });
            
            // Only update backend and scroll if valid new skills were actually added
            if (addedNew) {
                const param = { query: `${roleId}`, data: { [keyName]: skills } };
                if (api) { api(param) }
                container.scrollTop = container.scrollHeight;
            }

            event.target.value = '';
            event.target.focus();
        }
    }
    delRoleSkill = (container,roleId,api,skills,keyName) => {
        const query = `${roleId}`;
        const item = event.target.dataset.value;
        const index = skills.indexOf(item);
        if (index !== -1){
            skills.splice(index, 1);
        } 
        const param = {query : query,data:{[keyName] : skills}};
        if(api) api(param);
        container.remove();
    }

    /**
     * Handles a "destructive" user move. It removes the user from all other roles
     * before adding them to the new one. This is used for the manual '+' add action.
     * @param {string} userId - The ID of the user to move.
     * @param {string} newRoleId - The ID of the destination role.
     * @param {object} context - The 'e' context object from the caller.
     * @param {HTMLElement} userImage - The image element of the user being added.
     */
    async _handleDestructiveUserMove(userId, newRoleId, context, userImage) {
        const allRoles = this.config().data.graphData;
        const removalPromises = [];

        // 1. Find and remove user from all other roles
        allRoles.forEach(role => {
            if (role.selfId !== newRoleId && role.profiles && role.profiles.some(p => p.userId === userId)) {
                console.log(`Removing user ${userId} from old role ${role.selfId}`);
                
                // Call API to remove from backend
                const promise = context.onNodeRemoveProfileClick({ roleId: role.selfId, userId: userId });
                removalPromises.push(promise);

                // Update local data and DOM for the old role
                const oldRoleNode = document.querySelector(`[data-empid='${role.selfId}']`);
                if (oldRoleNode) {
                    const oldSelectedUsers = oldRoleNode.dataset.selectedUsr.split(',').filter(Boolean);
                    const updatedUsers = oldSelectedUsers.filter(id => id !== userId);
                    oldRoleNode.dataset.selectedUsr = updatedUsers.join(',');
                    
                    const imgToRemove = oldRoleNode.querySelector(`#img-${userId}`);
                    if (imgToRemove) imgToRemove.remove();
                }
                role.profiles = role.profiles.filter(p => p.userId !== userId);
            }
        });

        await Promise.all(removalPromises);

        // 2. Add user to the new role
        console.log(`Adding user ${userId} to new role ${newRoleId}`);
        await context.onNodeAddProfileClick({ roleId: newRoleId, userId: userId });

        const newRoleNode = document.querySelector(`[data-empid='${newRoleId}']`);
        if (newRoleNode) {
            const currentSelectedUsers = newRoleNode.dataset.selectedUsr.split(',').filter(Boolean);
            if (!currentSelectedUsers.includes(userId)) {
                currentSelectedUsers.push(userId);
                newRoleNode.dataset.selectedUsr = currentSelectedUsers.join(',');
            }
            
            const r = newRoleNode.querySelector("label>fieldset>div>span");
            const _selectedUser = Utils.createElem("img", ["selectedUsrImg"], "img-" + userId, "",{ src : userImage.src});
            Utils.applyStyles(_selectedUser,{ position: "relative", marginLeft: "-5px", width: "32px", height: "32px", objectFit:"cover", objectPosition:"center", border:"2px solid", borderRadius:"50%", cursor: "pointer" });
            const candProfile = context.candidateList.find(c => c.id === userId) || {};
            const hoverName = candProfile.name || candProfile.firstName || "User Profile";
            this.attachTooltip(_selectedUser, hoverName);
            // --- FIX: Create the correctly structured data object for expandRole ---
            const expandData = {
                kvdrRoleId: newRoleId,
                candidateList: context.candidateList,
                kvdrOrgConfigData: context.data.kvdrOrgConfigData || context.kvdrOrgConfigData,
                removeProfile: (t) => context.onNodeRemoveProfileClick(t),
                profileData: async (t) => context.onNodeProfileFetch(t),
                profileUpdate: async (t) => context.onNodeProfileUpdate(t),
                roleData: async (t) => context.onNodeFetch(t),
                roleUpdate: async (t) => context.onNodeUpdate(t),
                displaySettings: context.displaySettings
            };

            _selectedUser.addEventListener("click", (ev) => { ev.preventDefault(); ev.stopPropagation(); this.expandRole(expandData, 'Talent', [userId]); });
            r.prepend(_selectedUser);
        }
    }

    _popupUsrListCollection = (event, e, t) => {
    const roleNode = event.target.closest('div.member');
    const roleId = e.selfId;
    const orgId = this.getActualOrgId();
    const roleTitle = e.title;
    const token = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt') || "";

    // FIX: Create a deep copy to ensure this popup's data is isolated and deduplicate to avoid UI clones.
    const rawCandidates = JSON.parse(JSON.stringify(e.candidateList || []));
    const localCandidateList = [];
    const seenIds = new Set();
    const seenEmails = new Set();

    rawCandidates.forEach(cand => {
        // --- FIX: Prevent removed users from showing up in the Add/Assign list (ADDED 'deactivated') ---
        if (cand.isActive === false || cand.isDeleted === true || (cand.status && ['inactive', 'deleted', 'removed', 'deactivated'].includes(String(cand.status).toLowerCase()))) return;
        if (cand.userData && (cand.userData.isActive === false || cand.userData.isDeleted === true || (cand.userData.status && ['inactive', 'deleted', 'removed', 'deactivated'].includes(String(cand.userData.status).toLowerCase())))) return;

        const cId = String(cand.id || cand.user_id);
        const cEmail = (cand.email || cand.emailId || "").toLowerCase().trim();
        const hasId = cId && cId !== "undefined";
        const hasEmail = cEmail && cEmail.length > 0;
        
        let isDuplicate = false;
        if (hasId && seenIds.has(cId)) isDuplicate = true;
        if (hasEmail && seenEmails.has(cEmail)) isDuplicate = true;
        
        if (!isDuplicate) {
            if (hasId) seenIds.add(cId);
            if (hasEmail) seenEmails.add(cEmail);
            localCandidateList.push(cand);
        }
    });

    const rawSelected = roleNode.dataset.selectedUsr;
    const selectedUsr = rawSelected ? rawSelected.split(',').filter(Boolean) : [];
    const activeTask = this.activeAiTasks.get(roleId);

    const createSkeletonRow = () => {
        const listItem = Utils.createElem("li");
        listItem.className = 'skeleton-user-row';
        listItem.innerHTML = `
            <div style="display: flex; align-items: center; padding: 12px 20px; border-bottom: 1px solid #F3F4F6; animation: pulse 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;">
                <div style="width: 16px; height: 16px; margin-right: 16px; background-color: #e5e7eb; border-radius: 4px;"></div>
                <div style="width: 38px; height: 38px; border-radius: 50%; margin-right: 16px; background-color: #e5e7eb;"></div>
                <div style="flex: 1; display: flex; flex-direction: column; gap: 6px;">
                    <div style="height: 14px; width: 40%; background-color: #e5e7eb; border-radius: 4px;"></div>
                    <div style="height: 12px; width: 60%; background-color: #e5e7eb; border-radius: 4px;"></div>
                </div>
            </div>
        `;
        if (!document.getElementById('organigram-skeleton-style')) {
            const style = document.createElement('style');
            style.id = 'organigram-skeleton-style';
            style.innerHTML = `@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }`;
            document.head.appendChild(style);
        }
        return listItem;
    };

    // --- FIX: MORE ROBUST ROLE TITLE LOOKUP ---
    const getUserCurrentRoleTitles = (userId) => {
        if (!userId) return "Unassigned";
        const uidStr = String(userId);
        const allRoles = (this.config().data && this.config().data.graphData) ? this.config().data.graphData : [];
        let foundRoles = new Set(); // Use a Set to avoid duplicate role titles

        for (const r of allRoles) {
            if (r.profiles?.some(p => String(p.userId) === uidStr)) {
                foundRoles.add(r.title);
            }
            if (r.kvdrRoleProfiles?.some(p => String(p.userId) === uidStr)) {
                foundRoles.add(r.title);
            }
            // Fallback check on the DOM node's data attribute, which is often more up-to-date
            const domNode = document.querySelector(`[data-empid='${r.selfId}']`);
            if (domNode && domNode.dataset.selectedUsr?.split(',').includes(uidStr)) {
                foundRoles.add(r.title);
            }
        }
        
        const rolesArray = Array.from(foundRoles);
        return rolesArray.length > 0 ? rolesArray.join(', ') : "Unassigned";
    };

    const getUserCurrentRoleNodeIds = (userId) => {
        if (!userId) return [];
        const uidStr = String(userId);
        const allRoles = (this.config().data && this.config().data.graphData) ? this.config().data.graphData : [];
        let foundIds = new Set();
        for (const r of allRoles) {
             if (r.profiles?.some(p => String(p.userId) === uidStr)) {
                foundIds.add(r.selfId);
            }
             if (r.kvdrRoleProfiles?.some(p => String(p.userId) === uidStr)) {
                foundIds.add(r.selfId);
            }
            const domNode = document.querySelector(`[data-empid='${r.selfId}']`);
            if (domNode && domNode.dataset.selectedUsr?.split(',').includes(uidStr)) {
                foundIds.add(r.selfId);
            }
        }
        return Array.from(foundIds);
    };

    const mainContainer = Utils.createElem("div", ["popup-main-container"], "", "");
    Utils.applyStyles(mainContainer, { display: "flex", flexDirection: "column", width: "100%", height: "100%", maxHeight: "70vh", position: "relative" });

    const searchRow = Utils.createElem("div", ["search-row"], "", "");
    Utils.applyStyles(searchRow, { display: "flex", alignItems: "center", padding: "16px 20px", gap: "12px", flexShrink: "0", borderBottom: "1px solid #f0f0f0", position: "relative", zIndex: "50" });
    const searchInputWrapper = Utils.createElem("div");
    Utils.applyStyles(searchInputWrapper, { flex: "1", position: "relative", display: "flex", alignItems: "center" });
    const searchInput = Utils.createElem("input", ["search-mem-box"], "search-mem-box", "");
    searchInput.type = "text"; searchInput.placeholder = "Search candidates...";
    Utils.applyStyles(searchInput, { width: "100%", padding: "10px 14px", border: "1px solid #E5E7EB", background: "#F9FAFB", borderRadius: "8px", fontFamily: "inherit", fontSize: "14px", outline: "none", transition: "border 0.2s ease" });
    searchInput.addEventListener("focus", () => searchInput.style.borderColor = e.displaySettings.cc || "#F2C244");
    searchInput.addEventListener("blur", () => searchInput.style.borderColor = "#E5E7EB");
    searchInputWrapper.append(searchInput);
    const filterWrapper = Utils.createElem("div");
    Utils.applyStyles(filterWrapper, { position: "relative" });
    const filterBtn = Utils.createElem("button");
    filterBtn.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>`;
    Utils.applyStyles(filterBtn, { display: "flex", alignItems: "center", justifyContent: "center", width: "40px", height: "40px", background: "#fff", border: "1px solid #E5E7EB", borderRadius: "8px", cursor: "pointer", color: "#6B7280", transition: "background 0.2s" });
    filterBtn.onmouseenter = () => filterBtn.style.background = "#F9FAFB";
    filterBtn.onmouseleave = () => filterBtn.style.background = "#fff";
    this.attachTooltip(filterBtn, "Filter by Role");
    const filterDropdown = Utils.createElem("div");
    Utils.applyStyles(filterDropdown, {
        position: "fixed", background: "#fff", border: "1px solid #E5E7EB", borderRadius: "8px", boxShadow: "0 10px 25px rgba(0,0,0,0.15)", zIndex: "999999",
        minWidth: "220px", display: "none", flexDirection: "column", maxHeight: "250px", overflowY: "auto", padding: "8px 0"
    });
    let currentFilter = "all";
    const renderFilterDropdown = () => {
        filterDropdown.innerHTML = "";
        const graphDataSafe = (this.config().data && this.config().data.graphData) ? this.config().data.graphData : [];
        const roleOptions = [{ selfId: "all", title: "All Roles" }, { selfId: "unassigned", title: "Unassigned" }, ...graphDataSafe];
        roleOptions.forEach(r => {
            const opt = Utils.createElem("div");
            Utils.applyStyles(opt, { padding: "10px 16px", fontSize: "13px", color: "#374151", cursor: "pointer", transition: "background 0.2s", fontWeight: r.selfId === "all" ? "600" : "400", display: "flex", alignItems: "center", justifyContent: "space-between" });
            const titleSpan = Utils.createElem("span", [], "", r.title);
            opt.append(titleSpan);
            if (currentFilter === r.selfId) {
                const tick = Utils.createElem("span");
                tick.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="${e.displaySettings.cc || '#F2C244'}" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>`;
                opt.append(tick);
                opt.style.background = "#F9FAFB";
            }
            opt.onmouseenter = () => { if (currentFilter !== r.selfId) opt.style.background = "#F3F4F6"; };
            opt.onmouseleave = () => { if (currentFilter !== r.selfId) opt.style.background = "transparent"; };
            opt.onclick = () => {
                currentFilter = r.selfId;
                renderFilterDropdown();
                applySearchAndFilter();
                filterDropdown.style.display = "none";
                filterBtn.style.color = currentFilter !== "all" ? (e.displaySettings.cc || "#F2C244") : "#6B7280";
                filterBtn.style.borderColor = currentFilter !== "all" ? (e.displaySettings.cc || "#F2C244") : "#E5E7EB";
            };
            filterDropdown.append(opt);
        });
    };
    renderFilterDropdown();
    filterBtn.onclick = (ev) => {
        ev.stopPropagation();
        if (filterDropdown.style.display === "flex") {
            filterDropdown.style.display = "none";
        } else {
            const rect = filterBtn.getBoundingClientRect();
            filterDropdown.style.top = (rect.bottom + 8) + "px";
            filterDropdown.style.left = (rect.right - 220) + "px";
            filterDropdown.style.display = "flex";
        }
    };
    document.addEventListener("click", (ev) => {
        if (!filterWrapper.contains(ev.target)) filterDropdown.style.display = "none";
    });
    filterWrapper.append(filterBtn);
    document.body.appendChild(filterDropdown);
    searchRow.append(searchInputWrapper, filterWrapper);

    const listHeader = Utils.createElem("div");
    Utils.applyStyles(listHeader, { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 20px", borderBottom: "1px solid #f0f0f0", background: "#fafafa", flexShrink: "0", minHeight: "56px", boxSizing: "border-box" });
    const listHeaderLeft = Utils.createElem("div");
    Utils.applyStyles(listHeaderLeft, { display: "flex", alignItems: "center" });
    const selectAllCb = Utils.createElem("input");
    selectAllCb.type = "checkbox";
    Utils.applyStyles(selectAllCb, { width: "16px", height: "16px", cursor: "pointer", accentColor: e.displaySettings.cc || "#F2C244", marginRight: "16px" });
    const listTotalLabel = Utils.createElem("span");
    Utils.applyStyles(listTotalLabel, { fontSize: "13px", color: "#6B7280", fontWeight: "500", transition: "color 0.2s" });
    const clearSelectionBtn = Utils.createElem("button", [], "", "Clear");
    Utils.applyStyles(clearSelectionBtn, { background: "transparent", border: "none", color: "#6B7280", fontSize: "12px", cursor: "pointer", padding: "0", textDecoration: "underline", marginLeft: "10px", display: "none" });
    clearSelectionBtn.onclick = () => {
        userList.querySelectorAll('input[type="checkbox"]:checked').forEach(cb => { cb.checked = false; });
        selectAllCb.checked = false;
        updateHeaderState();
    };
    listHeaderLeft.append(selectAllCb, listTotalLabel, clearSelectionBtn);
    const listHeaderRight = Utils.createElem("div");
    Utils.applyStyles(listHeaderRight, { display: "none", alignItems: "center", gap: "10px" });
    const bulkAddBtn = Utils.createElem("button", ["bulk-add-btn"]);
    bulkAddBtn.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line></svg>`;
    Utils.applyStyles(bulkAddBtn, {
        height: "32px", width: "32px", background: "#fff", color: "#374151", border: "1px solid #E5E7EB", borderRadius: "6px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.2s"
    });
    bulkAddBtn.onmouseenter = () => bulkAddBtn.style.background = "#F9FAFB";
    bulkAddBtn.onmouseleave = () => bulkAddBtn.style.background = "#fff";
    bulkAddBtn.title = "Add to Role";
    const aiEvalButton = Utils.createElem("button", ["ai-eval-btn"], "", "");
    const btnYellowColor = e.displaySettings.cc || "#F2C244";
    aiEvalButton.innerHTML = `<img src="${AIGenerateIcon}" style="width:16px; height:16px; filter:brightness(0) invert(1);" />`;
    Utils.applyStyles(aiEvalButton, {
        height: "32px", width: "32px", background: btnYellowColor, border: "none", borderRadius: "6px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", transition: "all 0.2s ease"
    });
    listHeaderRight.append(bulkAddBtn, aiEvalButton);
    listHeader.append(listHeaderLeft, listHeaderRight);

    const userList = Utils.createElem("ul", ["user-list-container"], "", "");
    Utils.applyStyles(userList, { flex: "1", overflowY: "auto", overflowX: "hidden", display: "flex", flexDirection: "column", padding: "0", margin: "0" });

    searchInput.disabled = true;
    filterBtn.disabled = true;
    selectAllCb.disabled = true;
    mainContainer.style.pointerEvents = 'none';
    mainContainer.style.opacity = '0.8';
    for (let i = 0; i < 7; i++) {
        userList.append(createSkeletonRow());
    }
    
    // --- NEW: UNIFIED SORTING FUNCTION ---
    const sortUserList = () => {
        const listItems = Array.from(userList.querySelectorAll('li'));
        listItems.sort((a, b) => {
            const dataA = a.candidateData || {};
            const dataB = b.candidateData || {};

            // An AI suggestion is a candidate with a 'score' from the suggestions API.
            const isAiA = dataA.score !== undefined && dataA.score !== null;
            const isAiB = dataB.score !== undefined && dataB.score !== null;

            // Priority 1: AI-matched candidates go to the top.
            if (isAiA && !isAiB) return -1; // A comes first
            if (!isAiA && isAiB) return 1;  // B comes first

            // Priority 2: If both are AI-matched, sort by their score (descending).
            if (isAiA && isAiB) {
                return (parseFloat(dataB.score) || 0) - (parseFloat(dataA.score) || 0);
            }

            // Priority 3: If neither are AI-matched, sort by keyword match percentage (descending).
            const matchA = dataA.keywordMatch?.match_percentage || 0;
            const matchB = dataB.keywordMatch?.match_percentage || 0;
            return matchB - matchA;
        });

        // Re-append the sorted items to the DOM.
        listItems.forEach(li => userList.append(li));
    };

    // --- DYNAMIC LOGIC ---
    const updateListTotal = () => {
        const visibleRows = userList.querySelectorAll("li:not([style*='display: none'])");
        const checkedCount = userList.querySelectorAll("li:not([style*='display: none']) input[type='checkbox']:checked").length;
        
        if (checkedCount === 0) {
            listTotalLabel.innerText = `${visibleRows.length} candidates`;
        }
        
        const visibleCheckboxes = userList.querySelectorAll("li:not([style*='display: none']) input[type='checkbox']:not([disabled])");
        if (visibleCheckboxes.length > 0) {
            selectAllCb.checked = (checkedCount > 0 && checkedCount === visibleCheckboxes.length);
            selectAllCb.disabled = false;
        } else {
            selectAllCb.checked = false;
            selectAllCb.disabled = true;
        }
    };

    const applySearchAndFilter = () => {
        const searchTerm = searchInput.value.toLowerCase().trim();
        let visibleCount = 0; // Track visible rows
        
        userList.querySelectorAll("li:not(.skeleton-user-row)").forEach(li => {
            const cand = li.candidateData;
            if(!cand) return;
            const text = li.innerText.toLowerCase();
            const candEmail = (cand.email || cand.emailId || "").toLowerCase();
            
            // Enhanced search: Explicitly check against the email as well
            const matchesSearch = text.includes(searchTerm) || candEmail.includes(searchTerm);
            
            let matchesFilter = true;
            if (currentFilter !== "all") {
                const candRoleIds = getUserCurrentRoleNodeIds(cand.id || cand.user_id);
                if (currentFilter === "unassigned") {
                    matchesFilter = candRoleIds.length === 0;
                } else {
                    matchesFilter = candRoleIds.includes(currentFilter);
                }
            }
            const isVisible = matchesSearch && matchesFilter;
            li.style.display = isVisible ? "" : "none";
            
            if (isVisible) visibleCount++;
        });

        // --- NEW: Handle No Results & Show Invite UI ---
        let noResultsBox = userList.querySelector('.no-results-invite-box');
        
        if (visibleCount === 0 && searchTerm.length > 0) {
            if (!noResultsBox) {
                noResultsBox = Utils.createElem("div", ["no-results-invite-box"]);
                Utils.applyStyles(noResultsBox, { 
                    padding: "40px 20px", textAlign: "center", display: "flex", 
                    flexDirection: "column", alignItems: "center", gap: "12px", 
                    width: "100%", boxSizing: "border-box" 
                });
                userList.append(noResultsBox);
            }
            noResultsBox.style.display = "flex";

            // Check if the search term looks like an email address
            const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(searchTerm);
            let inviteText = isEmail ? `Invite ${searchTerm}` : "Invite New Candidate";

            noResultsBox.innerHTML = `
            <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; gap: 16px;">
                
                <div style="display: flex; align-items: center; gap: 12px; text-align: left;">
                    <div style="width: 50px; height: 50px; border-radius: 50%; background: #F3F4F6; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                            <circle cx="8.5" cy="7" r="4"></circle>
                            <line x1="20" y1="8" x2="20" y2="14"></line>
                            <line x1="23" y1="11" x2="17" y2="11"></line>
                        </svg>
                    </div>

                    <p style="color: #4B5563; font-size: 14px; margin: 0; text-align: left;">
                        No candidates found matching "<b>${searchTerm}</b>"
                    </p>
                </div>

                <button 
                    class="invite-new-user-btn" 
                    style="
                        background: #F2C244;
                        color: #fff;
                        border: none;
                        padding: 10px 20px;
                        border-radius: 6px;
                        cursor: pointer;
                        font-weight: 600;
                        transition: opacity 0.2s;
                        white-space: nowrap;
                    "
                >
                    ${inviteText}
                </button>

            </div>
        `;

            // Hover effects and Click Event
            noResultsBox.querySelector('.invite-new-user-btn').onmouseenter = (e) => e.target.style.opacity = '0.9';
            noResultsBox.querySelector('.invite-new-user-btn').onmouseleave = (e) => e.target.style.opacity = '1';
            noResultsBox.querySelector('.invite-new-user-btn').onclick = () => {
                this.openManualInvitePopup(searchTerm, orgId, token);
            };
        } else if (noResultsBox) {
            noResultsBox.style.display = "none";
        }

        updateListTotal();
    };

    searchInput.addEventListener("keyup", applySearchAndFilter);

    const updateHeaderState = () => {
        const checkedBoxes = userList.querySelectorAll('input[type="checkbox"]:checked');
        const count = checkedBoxes.length;

        if (count > 0) {
            listTotalLabel.innerText = `${count} selected`;
            listTotalLabel.style.fontWeight = "600";
            listTotalLabel.style.color = "#111827";
            clearSelectionBtn.style.display = "inline-block";
            listHeaderRight.style.display = "flex";
            
            // Limit AI Evaluation to 5
            if (count > 5) {
                aiEvalButton.disabled = true;
                aiEvalButton.style.opacity = "0.5";
                aiEvalButton.style.cursor = "not-allowed";
                aiEvalButton.title = "Select max 5 profiles for re-evaluation at a time";
            } else {
                aiEvalButton.disabled = false;
                aiEvalButton.style.opacity = "1";
                aiEvalButton.style.cursor = "pointer";
                aiEvalButton.title = `Re-evaluate (${count})`;
            }
        } else {
            listTotalLabel.style.fontWeight = "500";
            listTotalLabel.style.color = "#6B7280";
            clearSelectionBtn.style.display = "none";
            listHeaderRight.style.display = "none";
        }
        updateListTotal();
    };

    selectAllCb.addEventListener("change", (ev) => {
        const isChecked = ev.target.checked;
        userList.querySelectorAll("li:not([style*='display: none']) input[type='checkbox']").forEach(cb => {
            if (cb.dataset.processing !== "true") {
                cb.checked = isChecked;
            }
        });
        updateHeaderState();
    });

    // --- CREATE ROW FUNCTION ---
    const createRow = (candidateData) => {
        const listItem = Utils.createElem("li", [], "", "");
        listItem.candidateData = candidateData;
        
        const cId = candidateData.id || candidateData.user_id;
        const cEmail = (candidateData.email || candidateData.emailId || "").toLowerCase().trim();
        if(cEmail) listItem.dataset.emailKey = cEmail;
        if(cId) listItem.dataset.uid = cId;

        listItem.rebuildRow = (candidate) => {
            listItem.innerHTML = "";
            const isAlreadySelected = selectedUsr.includes(String(candidate.id || candidate.user_id));
            
            let rawScore = candidate.score;
            if (rawScore === undefined || rawScore === null) rawScore = candidate.matchScore;
            if (rawScore === undefined || rawScore === null) rawScore = candidate.ai_score;
            if (rawScore === undefined || rawScore === null) rawScore = candidate.fitment_score;

            const hasScore = rawScore !== undefined && rawScore !== null;
            const scoreVal = hasScore ? Math.round(parseFloat(rawScore)) : 0;

            const row = Utils.createElem("div", ["multi-select-box"], "", "");
            Utils.applyStyles(row, { display: "flex", alignItems: "center", padding: "12px 20px", cursor: "pointer", borderBottom: "1px solid #F3F4F6", background: "#fff", transition: "background 0.2s" });
            row.addEventListener("mouseenter", () => row.style.background = "#F9FAFB");
            row.addEventListener("mouseleave", () => row.style.background = "#fff");

            // Checkbox container
            const cbContainer = Utils.createElem("div", ["cb-container-box"], "", "");
            Utils.applyStyles(cbContainer, { width: "16px", height: "16px", marginRight: "16px", flexShrink: "0", display: "flex", alignItems: "center", justifyContent: "center" });

            if (!isAlreadySelected && !hasScore) {
                const userCheckbox = Utils.createElem("input", "", candidate.id || candidate.user_id, "");
                userCheckbox.type = "checkbox"; 
                userCheckbox.value = candidate.id || candidate.user_id;
                Utils.applyStyles(userCheckbox, { width: "16px", height: "16px", cursor: "pointer", accentColor: e.displaySettings.cc || "#F2C244", margin: "0" });
                userCheckbox.addEventListener("change", updateHeaderState);
                userCheckbox.addEventListener("click", (ev) => ev.stopPropagation()); 
                cbContainer.append(userCheckbox);
            }
            row.append(cbContainer);

            // Avatar
            const userImage = Utils.createElem("img", ["usrListImg"]);
            let avatarSrc = candidate.imageUrl || candidate.image_url;
            if (!avatarSrc) avatarSrc = "https://cdn-icons-png.flaticon.com/512/149/149071.png";
            userImage.src = avatarSrc;
            Utils.applyStyles(userImage, { width: "38px", height: "38px", borderRadius: "50%", margin: "0 16px 0 0", flexShrink: "0", objectFit: "cover", border: "1px solid #E5E7EB" });
            
            // Info Box & Skill Tags
            const infoBox = Utils.createElem("div");
            Utils.applyStyles(infoBox, { flex: "1", textAlign: "left", overflow: "hidden" });
            const dName = candidate.name || (candidate.email ? candidate.email.split('@')[0] : "Candidate");
            const currRoleTitle = getUserCurrentRoleTitles(candidate.id || candidate.user_id);
            
            let htmlContent = `<h5 style="margin:0;font-size:14px;color:#111827;font-weight:600;line-height:1.2;">${dName}</h5><span style="font-size:12px;color:#6B7280;margin-top:2px;display:block;">${currRoleTitle}</span>`;
            
            // Render Keyword Matches with "No Overlap" safe-state
            if (candidate.keywordMatch) {
                const matched = candidate.keywordMatch.matched_skills || [];
                const missing = candidate.keywordMatch.missing_skills || [];

                if (matched.length === 0) {
                    // Cleaner message when there is no match at all
                    htmlContent += `<span style="font-size:11px; color:#9ca3af; font-style:italic; margin-top:6px; display:block; text-align:left;">No skill overlap between Talent and the Role.</span>`;
                } else {
                    let skillsHtml = '<div style="margin-top: 6px; display: flex; flex-wrap: wrap; gap: 4px;">';
                    
                    matched.forEach(skill => {
                        skillsHtml += `<span class="matched-skill-tag" style="background:#e6fffa; color:#00b894; border:1px solid #00b894; padding:2px 6px; border-radius:4px; font-size:10px; font-weight:500; cursor:help; display:inline-block;">✓ ${skill}</span>`;
                    });
                    missing.forEach(skill => {
                        skillsHtml += `<span class="missing-skill-tag" style="background:#f9fafb; color:#9ca3af; border:1px dashed #cbd5e1; padding:2px 6px; border-radius:4px; font-size:10px; cursor:help; display:inline-block;">✗ ${skill}</span>`;
                    });
                    skillsHtml += '</div>';
                    htmlContent += skillsHtml;
                }
            }
            infoBox.innerHTML = htmlContent;

            // Bind tooltips directly to matching tags (safe if none are rendered)
            infoBox.querySelectorAll('.matched-skill-tag').forEach(tag => {
                this.attachTooltip(tag, "This keyword is present in the candidate's profile.");
            });
            infoBox.querySelectorAll('.missing-skill-tag').forEach(tag => {
                this.attachTooltip(tag, "This required keyword is missing from the candidate's profile.");
            });

            row.append(userImage, infoBox);
            

            // Action Box (RESTORED ORIGINAL LOGIC)
            const actionBox = Utils.createElem("div", ["ai-status-box"]);
            Utils.applyStyles(actionBox, { display: "flex", alignItems: "center", gap: "8px", flexShrink: "0", marginLeft: "auto" });

            if (hasScore) {
                const scoreColor = scoreVal > 70 ? "#4caf50" : scoreVal >= 65 ? "#ff9800" : "#f44336";
                const scoreBadge = Utils.createElem("span", [], "", `${scoreVal}%`);
                Utils.applyStyles(scoreBadge, { fontSize: "12px", fontWeight: "bold", color: "#fff", background: scoreColor, padding: "4px 10px", borderRadius: "12px", cursor:"pointer" });
                
                scoreBadge.addEventListener("click", (evt) => {
                     evt.stopPropagation();
                     const orgConfig = e.data && e.data.kvdrOrgConfigData ? e.data.kvdrOrgConfigData : {};
                     this.previewCandidateFitment(candidate, e, roleNode, orgConfig);
                });
                actionBox.append(scoreBadge);

                if (isAlreadySelected) {
                    const addedText = Utils.createElem("span", [], "", "Added");
                    Utils.applyStyles(addedText, { color: "#10B981", fontSize: "12px", fontWeight: "bold", marginLeft: "4px" });
                    actionBox.append(addedText);
                } else {
                    if (scoreVal < 65) {
                        const autoRejectLabel = Utils.createElem("span", [], "", this.translate('orgDashboard.userDashboard.evaluation.autorejected'));
                        Utils.applyStyles(autoRejectLabel, { color: "#f44336", fontWeight: "bold", fontSize: "11px", border: "1px solid #f44336", padding: "2px 6px", borderRadius: "12px", background: "#fff5f5" });
                        
                        const moreOptionsBtn = Utils.createElem("button", [], "", "•••");
                        Utils.applyStyles(moreOptionsBtn, { background: "#f0f0f0", color: "#666", border: "none", fontSize: "14px", fontWeight: "bold", cursor: "pointer", padding: "4px 8px", position: "relative", borderRadius: "4px" });
                        this.attachTooltip(moreOptionsBtn, "More Options");

                        const dropdown = Utils.createElem("div");
                        Utils.applyStyles(dropdown, { position: "absolute", top: "100%", right: "0", marginTop: "4px", background: "#fff", border: "1px solid #eee", borderRadius: "6px", boxShadow: "0 4px 12px rgba(0,0,0,0.15)", zIndex: "100", display: "none", flexDirection: "column", minWidth: "130px", overflow: "hidden" });

                        const addItem = Utils.createElem("div", [], "", "Add to Role");
                        Utils.applyStyles(addItem, { padding: "8px 12px", fontSize: "12px", color: "#333", cursor: "pointer", borderBottom: "1px solid #f5f5f5", textAlign: "left" });
                        addItem.addEventListener("mouseenter", () => addItem.style.background = "#f9f9f9");
                        addItem.addEventListener("mouseleave", () => addItem.style.background = "#fff");
                        
                        addItem.addEventListener("click", async (evt) => {
                            evt.stopPropagation();
                            addItem.innerText = "Adding...";
                            
                            const targetId = candidate.id || candidate.user_id;
                            const sourceFitment = candidate.fitment_data || candidate.fitmentData || [];
                            const finalFitmentData = JSON.parse(JSON.stringify(sourceFitment));

                            const payload = { 
                                user_id: targetId, email: candidate.email, role_id: roleId, organization_id: orgId, api_token: token, 
                                score: candidate.score, reasoning: candidate.reasoning || "Manual Override", fitment_data: finalFitmentData, role_name: e.title 
                            };

                            try {
                                const apiRes = await fetch(`${API_BASE_URL}/api/talent-pool/manual-assign`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
                                
                                if(apiRes.ok) { 
                                    document.dispatchEvent(new CustomEvent('request-talentpool-refresh'));
                                    const forcePatch = async () => {
                                        try {
                                            const fitmentPayload = { query: `userId=${targetId}&kvdrRoleId=${roleId}`, data: { fitmentData: finalFitmentData } };
                                            await e.onNodeProfileUpdate(fitmentPayload);
                                        } catch (e) {}
                                    };
                                    await forcePatch();
                                    setTimeout(forcePatch, 500);

                                    const existingLocal = e.candidateList.find(c => String(c.id) === String(targetId));
                                    if (!existingLocal) {
                                        e.candidateList.push(Object.assign({}, candidate, { id: targetId, fitmentData: finalFitmentData }));
                                    } else {
                                        existingLocal.fitmentData = finalFitmentData;
                                    }
                                    
                                    const current = roleNode.dataset.selectedUsr ? roleNode.dataset.selectedUsr.split(',') : [];
                                    if(!current.includes(String(targetId))) {
                                        current.push(targetId); 
                                        roleNode.dataset.selectedUsr = current.join(',');
                                    }

                                    const r = roleNode.querySelector("label>fieldset>div>span");
                                    if (r && !r.querySelector(`#img-${targetId}`)) {
                                        const newImg = Utils.createElem("img", ["selectedUsrImg"], `img-${targetId}`);
                                        newImg.src = avatarSrc;
                                        Utils.applyStyles(newImg, { position: "relative", marginLeft: "-5px", width: "32px", height: "32px", objectFit:"cover", objectPosition:"center", border:"2px solid", borderRadius:"50%", cursor: "pointer" });
                                        
                                        const expandData = { kvdrRoleId: roleId, candidateList: e.candidateList, kvdrOrgConfigData: e.data.kvdrOrgConfigData, removeProfile: (pl) => e.onNodeRemoveProfileClick(pl), profileData: (p) => e.onNodeProfileFetch(p), profileUpdate: (p) => e.onNodeProfileUpdate(p), roleData: (p) => e.onNodeFetch(p), roleUpdate: (p) => e.onNodeUpdate(p), displaySettings: e.displaySettings };
                                        newImg.addEventListener("click", (ev) => { ev.preventDefault(); ev.stopPropagation(); this.expandRole(expandData, 'Talent', [targetId]); });
                                        r.prepend(newImg);
                                    }
                                    
                                    if(!selectedUsr.includes(String(targetId))) {
                                        selectedUsr.push(String(targetId));
                                        listItem.remove();
                                    }
                                    // if (typeof Utils.playBellSound === 'function') Utils.playBellSound(800, 840, 'square');
                                }
                            } catch (err) { console.error(err); addItem.innerText = "Error"; }
                        });

                        const dismissItem = Utils.createElem("div", [], "", "Dismiss Profile");
                        Utils.applyStyles(dismissItem, { padding: "8px 12px", fontSize: "12px", color: "#f44336", cursor: "pointer", textAlign: "left" });
                        dismissItem.addEventListener("mouseenter", () => dismissItem.style.background = "#fff5f5");
                        dismissItem.addEventListener("mouseleave", () => dismissItem.style.background = "#fff");

                        dismissItem.addEventListener("click", async (evt) => {
                            evt.stopPropagation(); dismissItem.innerText = "Dismissing...";
                            const payload = { user_id: candidate.id || candidate.user_id, role_id: roleId, email: candidate.email || "", organization_id: orgId, role_name: roleTitle, send_email: true };
                            try {
                                const res = await fetch(`${API_BASE_URL}/api/talent-pool/reject-suggestion`, { method: "POST", headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify(payload) });
                                if(res.ok) listItem.remove();
                            } catch (err) { console.error(err); }
                        });

                        dropdown.append(addItem, dismissItem);
                        moreOptionsBtn.addEventListener("click", (evt) => {
                            evt.stopPropagation();
                            const isVisible = dropdown.style.display === "flex";
                            document.querySelectorAll('.auto-reject-dropdown').forEach(el => el.style.display = 'none');
                            dropdown.classList.add('auto-reject-dropdown');
                            if (!isVisible) {
                                dropdown.style.display = "flex";
                                const closeFn = () => { dropdown.style.display = "none"; document.removeEventListener("click", closeFn); };
                                setTimeout(() => document.addEventListener("click", closeFn), 0);
                            } else {
                                dropdown.style.display = "none";
                            }
                        });

                        const btnWrapper = Utils.createElem("div");
                        Utils.applyStyles(btnWrapper, { position: "relative" });
                        btnWrapper.append(moreOptionsBtn, dropdown);
                        actionBox.append(autoRejectLabel, btnWrapper);
                    } else {
                        const rejectBtn = Utils.createElem("button", [], "", "-");
                        Utils.applyStyles(rejectBtn, { background: "#ff4444", color: "#fff", border: "none", width: "28px", height: "28px", borderRadius: "50%", cursor: "pointer", fontSize: "18px", fontWeight: "bold", display:"flex", alignItems:"center", justifyContent:"center", paddingBottom:"2px" });
                        rejectBtn.addEventListener("click", async (evt) => {
                            evt.stopPropagation(); rejectBtn.innerText = ".."; rejectBtn.disabled = true;
                            const payload = { user_id: candidate.id || candidate.user_id, role_id: roleId, email: candidate.email || "", organization_id: orgId, role_name: roleTitle, send_email: true };
                            try {
                                const res = await fetch(`${API_BASE_URL}/api/talent-pool/reject-suggestion`, { method: "POST", headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify(payload) });
                                if(res.ok) listItem.remove();
                                else { rejectBtn.innerText = "-"; rejectBtn.disabled = false; }
                            } catch (err) { console.error(err); rejectBtn.innerText = "-"; rejectBtn.disabled = false; }
                        });

                        const addBtn = Utils.createElem("button", [], "", "+");
                        Utils.applyStyles(addBtn, { background:"#F2C244", color: "#fff", border: "none", width: "28px", height: "28px", borderRadius: "50%", cursor: "pointer", fontSize: "18px", fontWeight: "bold", display:"flex", alignItems:"center", justifyContent:"center" });
                        this.attachTooltip(addBtn, "Add to Role");

                        addBtn.addEventListener("click", async (evt) => {
                            evt.stopPropagation(); 
                            if(addBtn.disabled) return;
                            addBtn.innerText = "..";
                            addBtn.disabled = true;
                            const targetId = candidate.user_id || candidate.id;
                            
                            const rawFit = candidate.fitment_data || candidate.fitmentData || [];
                            const finalFitment = rawFit.map(item => ({ key: item.key, score: item.score || item.value || 0, remarks: item.remarks || item.reasoning || "" }));

                            const payload = { 
                                user_id: targetId, email: candidate.email, role_id: roleId, organization_id: orgId, api_token: token, 
                                score: candidate.score, reasoning: candidate.reasoning || "Manual", fitment_data: finalFitment, 
                                role_name: e.title, overwrite_existing: true 
                            };
                            
                            const apiRes = await fetch(`${API_BASE_URL}/api/talent-pool/manual-assign`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });

                            if(apiRes.ok) { 
                                document.dispatchEvent(new CustomEvent('request-talentpool-refresh'));
                                const forcePatch = async () => {
                                    await e.onNodeProfileUpdate({ query: `userId=${targetId}&kvdrRoleId=${roleId}`, data: { fitmentData: finalFitment } });
                                };
                                await forcePatch();
                                setTimeout(forcePatch, 800);

                                const existingLocal = e.candidateList.find(c => String(c.id) === String(targetId));
                                if (existingLocal) { existingLocal.fitmentData = finalFitment; } 
                                else { e.candidateList.push(Object.assign({}, candidate, { id: targetId, fitmentData: finalFitment })); }
                                
                                const current = roleNode.dataset.selectedUsr ? roleNode.dataset.selectedUsr.split(',') : [];
                                if(!current.includes(String(targetId))) {
                                    current.push(targetId); 
                                    roleNode.dataset.selectedUsr = current.join(',');
                                }

                                const r = roleNode.querySelector("label>fieldset>div>span");
                                if (r && !r.querySelector(`#img-${targetId}`)) {
                                    const newImg = Utils.createElem("img", ["selectedUsrImg"], `img-${targetId}`);
                                    newImg.src = avatarSrc;
                                    Utils.applyStyles(newImg, { position: "relative", marginLeft: "-5px", width: "32px", height: "32px", objectFit:"cover", objectPosition:"center", border:"2px solid", borderRadius:"50%", cursor: "pointer" });
                                    const hoverName = candidate.name || (candidate.email ? candidate.email.split('@')[0] : "User Profile");
                                    this.attachTooltip(newImg, hoverName);
                                    const expandData = { kvdrRoleId: roleId, candidateList: e.candidateList, kvdrOrgConfigData: e.data.kvdrOrgConfigData, removeProfile: (pl) => e.onNodeRemoveProfileClick(pl), profileData: (p) => e.onNodeProfileFetch(p), profileUpdate: (p) => e.onNodeProfileUpdate(p), roleData: (p) => e.onNodeFetch(p), roleUpdate: (p) => e.onNodeUpdate(p), displaySettings: e.displaySettings };
                                    newImg.addEventListener("click", (ev) => { ev.preventDefault(); ev.stopPropagation(); this.expandRole(expandData, 'Talent', [targetId]); });
                                    r.prepend(newImg);
                                }
                                
                                if(!selectedUsr.includes(String(targetId))) {
                                    selectedUsr.push(String(targetId));
                                    listItem.remove(); 
                                }
                                // if (typeof Utils.playBellSound === 'function') Utils.playBellSound(800, 840, 'square');
                            } else {
                                addBtn.innerText = "+";
                                addBtn.disabled = false;
                            }
                        });
                        actionBox.append(rejectBtn, addBtn);
                    }
                }
            }

            // Restore Hover Tooltip for Evaluated Candidates
            let tooltipEl = null;
            if (hasScore && candidate.reasoning) {
                row.addEventListener("mouseenter", () => {
                    document.querySelectorAll('.custom-suggestion-tooltip').forEach(el => el.remove());
                    tooltipEl = Utils.createElem("div", ["custom-suggestion-tooltip"], "", `💡 ${candidate.reasoning}`);
                    Utils.applyStyles(tooltipEl, {
                        position: "fixed", backgroundColor: "#1f1f1f", color: "#fff", padding: "12px 16px", borderRadius: "8px", fontSize: "12px", maxWidth: "420px", zIndex: "200000", pointerEvents: "none", boxShadow: "0 6px 20px rgba(0,0,0,0.3)", lineHeight: "1.6", textAlign: "left", whiteSpace: "normal", wordWrap: "break-word", opacity: '0', transition: 'opacity 0.2s ease'
                    });
                    document.body.appendChild(tooltipEl);
                    requestAnimationFrame(() => { if(tooltipEl) tooltipEl.style.opacity = '1'; });
                    const rect = row.getBoundingClientRect();
                    let leftPos = rect.right + 12; let topPos = rect.top;
                    if (leftPos + tooltipEl.offsetWidth > window.innerWidth) leftPos = rect.left - tooltipEl.offsetWidth - 12;
                    tooltipEl.style.top = topPos + "px"; tooltipEl.style.left = leftPos + "px";
                });
                row.addEventListener("mouseleave", () => { 
                    if(tooltipEl) { tooltipEl.style.opacity = '0'; setTimeout(() => { if(tooltipEl) tooltipEl.remove() }, 200); tooltipEl = null; } 
                });
            }

            row.addEventListener("click", (evt) => {
                if (tooltipEl) { tooltipEl.remove(); tooltipEl = null; }
                if (evt.target.tagName === "BUTTON" || evt.target.tagName === "INPUT" || evt.target.closest('.ai-status-box')) return;
                
                if (hasScore) {
                    const orgConfig = (e.data && e.data.kvdrOrgConfigData) ? e.data.kvdrOrgConfigData : {};
                    this.previewCandidateFitment(candidate, e, roleNode, orgConfig);
                } else {
                    const checkbox = row.querySelector('input[type="checkbox"]');
                    if (checkbox && !checkbox.disabled) { 
                        checkbox.checked = !checkbox.checked;
                        checkbox.dispatchEvent(new Event('change'));
                    }
                }
            });

            row.append(actionBox);
            listItem.append(row);
        };

        listItem.rebuildRow(candidateData);
        return listItem;
    };

    // --- 5. BULK ADD LOGIC ---
    // --- 5. BULK ADD LOGIC ---
    bulkAddBtn.addEventListener("click", async (ev) => {
        ev.stopPropagation();
        const checkedBoxes = userList.querySelectorAll('input[type="checkbox"]:checked');
        if(checkedBoxes.length === 0) return;
        
        bulkAddBtn.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai-icon-loading"><line x1="12" y1="2" x2="12" y2="6"></line><line x1="12" y1="18" x2="12" y2="22"></line><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line><line x1="2" y1="12" x2="6" y2="12"></line><line x1="18" y1="12" x2="22" y2="12"></line><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line></svg>`;
        bulkAddBtn.disabled = true;

        const candidatesToAdd = [];
        Array.from(checkedBoxes).forEach(cb => {
            const li = cb.closest('li');
            if(li && li.candidateData) candidatesToAdd.push(li.candidateData);
        });

        // FIX: Replaced block-scoped "let i" with "for...of" to bypass the Babel "_loop$" reference bug
        for (const candidate of candidatesToAdd) {
            const targetId = candidate.user_id || candidate.id;
            
            let rawScore = candidate.score;
            if (rawScore === undefined || rawScore === null) rawScore = candidate.matchScore;
            if (rawScore === undefined || rawScore === null) rawScore = candidate.ai_score;
            if (rawScore === undefined || rawScore === null) rawScore = candidate.fitment_score;
            
            const hasScore = rawScore !== undefined && rawScore !== null;

            if (hasScore) {
                const rawFit = candidate.fitment_data || candidate.fitmentData || [];
                const finalFitment = rawFit.map(item => ({ key: item.key, score: item.score || item.value || 0, remarks: item.remarks || item.reasoning || "" }));
                const payload = { 
                    user_id: targetId, email: candidate.email, role_id: roleId, organization_id: orgId, api_token: token, 
                    score: candidate.score, reasoning: candidate.reasoning || "Manual Bulk Assign", fitment_data: finalFitment, 
                    role_name: e.title, overwrite_existing: true 
                };
                
                try {
                    const apiRes = await fetch(`${API_BASE_URL}/api/talent-pool/manual-assign`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
                    if(apiRes.ok) { 
                        document.dispatchEvent(new CustomEvent('request-talentpool-refresh'));
                        await e.onNodeProfileUpdate({ query: `userId=${targetId}&kvdrRoleId=${roleId}`, data: { fitmentData: finalFitment } });
                        const existingLocal = e.candidateList.find(c => String(c.id) === String(targetId));
                        if (existingLocal) { existingLocal.fitmentData = finalFitment; } 
                        else { e.candidateList.push(Object.assign({}, candidate, { id: targetId, fitmentData: finalFitment })); }
                    }
                } catch (err) { console.error("Bulk add error:", err); continue; }
            } else {
                let avatarSrc = candidate.imageUrl || candidate.image_url;
                if (!avatarSrc) avatarSrc = "https://cdn-icons-png.flaticon.com/512/149/149071.png";
                const imgPlaceholder = { src: avatarSrc };
                await this._handleDestructiveUserMove(targetId, roleId, e, imgPlaceholder);
            }

            const current = roleNode.dataset.selectedUsr ? roleNode.dataset.selectedUsr.split(',') : [];
            if(!current.includes(String(targetId))) {
                current.push(targetId); 
                roleNode.dataset.selectedUsr = current.join(',');
            }

            const r = roleNode.querySelector("label>fieldset>div>span");
            if (r && !r.querySelector(`#img-${targetId}`)) {
                const newImg = Utils.createElem("img", ["selectedUsrImg"], `img-${targetId}`);
                let avatarSrc = candidate.imageUrl || candidate.image_url;
                if (!avatarSrc) avatarSrc = "https://cdn-icons-png.flaticon.com/512/149/149071.png";
                newImg.src = avatarSrc;
                Utils.applyStyles(newImg, { position: "relative", marginLeft: "-5px", width: "32px", height: "32px", objectFit:"cover", objectPosition:"center", border:"2px solid", borderRadius:"50%", cursor: "pointer" });
                
                const kvdrDataConfig = (e.data && e.data.kvdrOrgConfigData) ? e.data.kvdrOrgConfigData : {};
                const expandData = { kvdrRoleId: roleId, candidateList: e.candidateList, kvdrOrgConfigData: kvdrDataConfig, removeProfile: (pl) => e.onNodeRemoveProfileClick(pl), profileData: (p) => e.onNodeProfileFetch(p), profileUpdate: (p) => e.onNodeProfileUpdate(p), roleData: (p) => e.onNodeFetch(p), roleUpdate: (p) => e.onNodeUpdate(p), displaySettings: e.displaySettings };
                
                newImg.addEventListener("click", (ev) => { ev.preventDefault(); ev.stopPropagation(); this.expandRole(expandData, 'Talent', [targetId]); });
                r.prepend(newImg);
            }
            
            const li = userList.querySelector(`li[data-uid="${targetId}"]`);
            if(li && !selectedUsr.includes(String(targetId))) {
                selectedUsr.push(String(targetId));
                li.remove(); 
            }
        }

        // if (typeof Utils.playBellSound === 'function') Utils.playBellSound(800, 840, 'square');
        bulkAddBtn.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line></svg>`;
        bulkAddBtn.disabled = false;
        
        userList.querySelectorAll('input[type="checkbox"]:checked').forEach(cb => { cb.checked = false; });
        selectAllCb.checked = false;
        updateHeaderState();
    });

    // --- 6. ASSEMBLE INITIAL VIEW ---
    mainContainer.append(searchRow, listHeader, userList);
    let pollInterval; // Declare interval ID in a scope accessible by cleanup

    // This function will be called by the interval
    const pollForUpdates = async () => {
        if (!mainContainer.isConnected) {
            clearInterval(pollInterval);
            return;
        }
        try {
            const res = await fetch(`${API_BASE_URL}/api/talent-pool/suggestions/${orgId}/${roleId}?include_rejected=true&status=all&t=${Date.now()}`);
            const response = await res.json();
            const suggestionsArray = Array.isArray(response.data || response) ? (response.data || response) : [];
            let listWasChanged = false;

            suggestionsArray.forEach(c => {
                const cId = String(c.user_id || c.id);
                const cEmail = (c.email || c.emailId || "").toLowerCase().trim();
                if ((!cId || cId === "undefined") && !cEmail) return;

                // --- FIX: Stronger ID and Email check to prevent duplicates ---
                let existingCand = localCandidateList.find(cand => {
                    const candId = String(cand.id || cand.user_id);
                    const candEmail = (cand.email || cand.emailId || "").toLowerCase().trim();
                    if (cId && cId !== "undefined" && candId === cId) return true;
                    if (cEmail && candEmail === cEmail) return true;
                    return false;
                });

                if (existingCand) {
                    const oldImg1 = existingCand.imageUrl;
                    const oldImg2 = existingCand.image_url;
                    
                    // If candidate exists, merge new data. Check if score changed to avoid needless re-renders.
                    if (existingCand.score !== c.score) {
                        Object.assign(existingCand, c);
                        
                        // Preserve the valid profile picture if the API returned null/missing image.
                        if (!existingCand.imageUrl && oldImg1) existingCand.imageUrl = oldImg1;
                        if (!existingCand.image_url && oldImg2) existingCand.image_url = oldImg2;
                        
                        listWasChanged = true;
                    }
                } else {
                    // If it's a truly new candidate, add it to our local data array.
                    const newCandData = Object.assign({}, c, { id: cId !== "undefined" ? cId : undefined });
                    localCandidateList.push(newCandData);
                    listWasChanged = true;
                }
            });

            if (listWasChanged) {
                // If any data changed, rebuild the entire list from the single source of truth (localCandidateList).
                const currentScroll = userList.scrollTop; // Preserve scroll position
                userList.innerHTML = '';
                localCandidateList.forEach(cand => userList.append(createRow(cand)));
                sortUserList();
                applySearchAndFilter();
                updateListTotal();
                userList.scrollTop = currentScroll; // Restore scroll position
            }
        } catch (err) {
            console.error("Polling error:", err);
        }
    };

    const initializeAndLoadList = async () => {
        try {
            const keywordPromise = new Promise(async (resolve) => {
                const userIds = localCandidateList.map(c => c.id || c.user_id).filter(Boolean);
                if (userIds.length === 0) return resolve();
                try {
                    const res = await fetch(`${API_BASE_URL}/api/talent-pool/keyword-match`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                        body: JSON.stringify({ role_id: roleId, user_ids: userIds })
                    });
                    const result = await res.json();
                    if (result.status === 'success' && result.data) {
                        result.data.forEach(matchData => {
                            const matchId = String(matchData.user_id);
                            const cand = localCandidateList.find(c => String(c.id || c.user_id) === matchId);
                            if (cand) cand.keywordMatch = matchData;
                        });
                    }
                } catch (err) { console.error("Keyword match fetch failed", err); }
                resolve();
            });

            const initialSuggestionsPromise = new Promise(async (resolve) => {
                try {
                    const res = await fetch(`${API_BASE_URL}/api/talent-pool/suggestions/${orgId}/${roleId}?include_rejected=true&status=all&t=${Date.now()}`);
                    const response = await res.json();
                    const suggestionsArray = Array.isArray(response.data || response) ? (response.data || response) : [];
                    
                    suggestionsArray.forEach(c => {
                        const cId = String(c.user_id || c.id);
                        const cEmail = (c.email || c.emailId || "").toLowerCase().trim();
                        if ((!cId || cId === "undefined") && !cEmail) return;

                        let existingCand = localCandidateList.find(cand => {
                            const candId = String(cand.id || cand.user_id);
                            const candEmail = (cand.email || cand.emailId || "").toLowerCase().trim();
                            if (cId && cId !== "undefined" && candId === cId) return true;
                            if (cEmail && candEmail === cEmail) return true;
                            return false;
                        });

                        if (existingCand) {
                            const oldImg1 = existingCand.imageUrl;
                            const oldImg2 = existingCand.image_url;
                            Object.assign(existingCand, c);
                            if (!existingCand.imageUrl && oldImg1) existingCand.imageUrl = oldImg1;
                            if (!existingCand.image_url && oldImg2) existingCand.image_url = oldImg2;
                        } else {
                            localCandidateList.push(Object.assign({}, c, { id: cId !== "undefined" ? cId : undefined }));
                        }
                    });
                } catch (err) { console.error("Initial suggestions fetch failed", err); }
                finally { resolve(); }
            });

            await Promise.allSettled([keywordPromise, initialSuggestionsPromise]);

            userList.innerHTML = '';
            localCandidateList.forEach(c => userList.append(createRow(c)));
            sortUserList();
            applySearchAndFilter();
            updateListTotal();
        } catch (err) {
            console.error("Error during popup initialization:", err);
            userList.innerHTML = '<li style="text-align: center; padding: 20px; color: #dc3545;">Could not load candidates.</li>';
        } finally {
            mainContainer.style.pointerEvents = 'auto';
            mainContainer.style.opacity = '1';
            searchInput.disabled = false;
            filterBtn.disabled = false;
        }
    };

    initializeAndLoadList();
    pollInterval = setInterval(pollForUpdates, 5000);

    aiEvalButton.addEventListener('click', (ev) => {
        ev.stopPropagation();
        if (aiEvalButton.disabled) return;

        const checkedBoxes = userList.querySelectorAll('input[type="checkbox"]:checked');
        let usersToEval = [];
        if(checkedBoxes.length > 0) {
            Array.from(checkedBoxes).forEach(cb => {
                const rowLi = cb.closest('li');
                if (rowLi && rowLi.candidateData) {
                    const candEmail = rowLi.candidateData.email || rowLi.candidateData.emailId || "";
                    usersToEval.push({ email: candEmail, row: rowLi, candidate: rowLi.candidateData });
                }
            });
        }
        if(usersToEval.length === 0) return;

        usersToEval.reverse().forEach(u => {
            if (u.row && userList.contains(u.row)) {
                userList.prepend(u.row);
            }
        });

        aiEvalButton.disabled = true; 
        aiEvalButton.style.opacity = '0.7'; 
        aiEvalButton.style.cursor = 'wait';
        aiEvalButton.innerHTML = `<img src="${OrangeSpinnerIcon}" style="width:16px; height:16px; filter:brightness(0) invert(1);" class="ai-icon-loading" />`;

        const allCheckboxes = userList ? userList.querySelectorAll('input[type="checkbox"]') : [];
        if (allCheckboxes) {
            allCheckboxes.forEach(cb => {
                if (cb) { 
                    cb.disabled = true;
                    cb.dataset.processing = "true"; 
                    const row = cb.closest('.multi-select-box');
                    if (row) { row.style.opacity = "0.6"; row.style.pointerEvents = "none"; }
                }
            });
        }

        const emailsToApi = [];
            usersToEval.forEach(u => {
                let email = u.email;
                if (!email && u.candidate) { email = u.candidate.email || u.candidate.emailId; }
                if(!email) return;

                emailsToApi.push(email);
                
                if (u.row) {
                    u.row.dataset.evalStatus = 'processing';
                    u.row.dataset.processing = 'true';
                }

                const statusBox = u.row ? u.row.querySelector('.ai-status-box') : null;
                if(statusBox) {
                    statusBox.innerHTML = ''; 
                    const loader = Utils.createElem("img", ["ai-icon-loading"]);
                    loader.src = OrangeSpinnerIcon; 
                    Utils.applyStyles(loader, { width: "20px", height: "20px", animation: "spin 1s linear infinite" });
                    statusBox.append(loader);
                }
            });

        if(emailsToApi.length > 0){ 
            this.triggerAiEvaluation(orgId, roleId, emailsToApi, userList, aiEvalButton); 
        }
    });

    const cleanupOnClose = () => {
        if (document.body.contains(filterDropdown)) filterDropdown.remove();
        clearInterval(pollInterval);
    };
    
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.removedNodes.forEach((node) => {
                if (node === mainContainer || node.contains(mainContainer)) {
                    cleanupOnClose();
                    observer.disconnect();
                }
            });
        });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    if (activeTask) {
        if (aiEvalButton) {
            aiEvalButton.disabled = true;
            aiEvalButton.style.opacity = '0.7';
            aiEvalButton.innerHTML = `<img src="${OrangeSpinnerIcon}" style="width:16px; height:16px; filter:brightness(0) invert(1);" class="ai-icon-loading" />`;
        }
        setTimeout(() => {
            if (!userList || !mainContainer.isConnected) return; 
            mainContainer.classList.add('evaluating-lock');
            userList.classList.add('evaluating-lock');
            if (bulkAddBtn) bulkAddBtn.disabled = true;
            if (searchInput) searchInput.disabled = true;

            userList.querySelectorAll('input[type="checkbox"]').forEach(cb => {
                if (cb) { 
                    cb.disabled = true;
                    cb.dataset.processing = "true";
                    const row = cb.closest('.multi-select-box');
                    if (row) { row.style.opacity = '0.6'; row.style.pointerEvents = 'none'; }
                }
            });
            activeTask.emails.forEach(email => {
                const row = userList.querySelector(`li[data-email-key="${email.toLowerCase().trim()}"]`);
                
                if (row) {
                    userList.prepend(row);
                    row.dataset.evalStatus = 'processing';
                }
                
                const statusBox = row ? row.querySelector('.ai-status-box') : null;
                if (statusBox) {
                    statusBox.innerHTML = '';
                    const loader = Utils.createElem("img", ["ai-icon-loading"]);
                    loader.src = OrangeSpinnerIcon;
                    Utils.applyStyles(loader, { width: "20px", height: "20px", animation: "spin 1s linear infinite" });
                    statusBox.append(loader);
                }
            });
        }, 0);
        this._startAiEvaluationPolling(orgId, activeTask.taskId, userList, aiEvalButton, roleId);
    }

    updateHeaderState();
    return mainContainer;
}

    openManualInvitePopup(prefilledSearch, orgId, token) {
        const wrapper = Utils.createElem('div');
        Utils.applyStyles(wrapper, { display: 'flex', flexDirection: 'column', gap: '16px', padding: '10px 5px' });

        const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(prefilledSearch);
        const defaultEmail = isEmail ? prefilledSearch : '';
        const defaultNameParts = !isEmail ? prefilledSearch.split(' ') : [''];
        const defaultFirstName = defaultNameParts[0] || '';
        const defaultLastName = defaultNameParts.slice(1).join(' ') || '';

        // Hint text
        const hint = Utils.createElem('p', [], '', 'Send an email invitation to join this organization.');
        Utils.applyStyles(hint, { margin: '0 0 5px 0', fontSize: '13px', color: '#6B7280' });
        wrapper.append(hint);

        // Inputs style setup
        const inputStyle = { width: '100%', padding: '10px', border: '1px solid #E5E7EB', borderRadius: '6px', boxSizing: 'border-box', fontFamily: 'inherit', fontSize: '14px', outline: 'none' };
        const labelStyle = { fontSize: '12px', color: '#374151', marginBottom: '6px', display: 'block', fontWeight: '500' };

        // Name Row
        const nameRow = Utils.createElem('div');
        Utils.applyStyles(nameRow, { display: 'flex', gap: '15px' });

        const fNameWrapper = Utils.createElem('div', [], '', `<label style="${Object.entries(labelStyle).map(([k,v])=>`${k.replace(/[A-Z]/g, m=>`-${m.toLowerCase()}`)}:${v}`).join(';')}">First Name</label>`);
        Utils.applyStyles(fNameWrapper, { flex: '1' });
        const fNameInput = Utils.createElem('input');
        fNameInput.value = defaultFirstName;
        Utils.applyStyles(fNameInput, inputStyle);
        fNameWrapper.append(fNameInput);

        const lNameWrapper = Utils.createElem('div', [], '', `<label style="${Object.entries(labelStyle).map(([k,v])=>`${k.replace(/[A-Z]/g, m=>`-${m.toLowerCase()}`)}:${v}`).join(';')}">Last Name</label>`);
        Utils.applyStyles(lNameWrapper, { flex: '1' });
        const lNameInput = Utils.createElem('input');
        lNameInput.value = defaultLastName;
        Utils.applyStyles(lNameInput, inputStyle);
        lNameWrapper.append(lNameInput);
        nameRow.append(fNameWrapper, lNameWrapper);

        // Email Row
        const emailWrapper = Utils.createElem('div', [], '', `<label style="${Object.entries(labelStyle).map(([k,v])=>`${k.replace(/[A-Z]/g, m=>`-${m.toLowerCase()}`)}:${v}`).join(';')}">Email Address *</label>`);
        const emailInput = Utils.createElem('input');
        emailInput.type = 'email';
        emailInput.value = defaultEmail;
        Utils.applyStyles(emailInput, inputStyle);
        emailWrapper.append(emailInput);

        wrapper.append(nameRow, emailWrapper);

        // Input Focus Rings
        [fNameInput, lNameInput, emailInput].forEach(inp => {
            inp.addEventListener('focus', () => inp.style.borderColor = '#F2C244');
            inp.addEventListener('blur', () => inp.style.borderColor = '#E5E7EB');
        });

        // Submit button
        const submitBtn = Utils.createElem('button', [], '', 'Send Invite');
        Utils.applyStyles(submitBtn, { background: '#F2C244', color: '#fff', border: 'none', padding: '10px 24px', borderRadius: '6px', fontWeight: '600', cursor: 'pointer', transition: 'opacity 0.2s' });

        const popupConfig = {
            headerText: "Invite New Member",
            onCloseClick: () => { document.querySelector('.manual-invite-overlay-popup')?.remove(); },
            data: wrapper,
            displaySettings: { width: "450px" },
            footer: submitBtn
        };

        const popup = this.createPopup(popupConfig);
        popup.classList.add('manual-invite-overlay-popup');

        // Override default close so it doesn't shut down the parent list popup behind it
        const closeBtn = popup.querySelector('.popupShutDownBtn');
        if (closeBtn) {
            closeBtn.onclick = (e) => { e.stopPropagation(); popup.remove(); };
        }

        // Trigger API
        submitBtn.onclick = async () => {
            const email = emailInput.value.trim();
            const fName = fNameInput.value.trim();
            const lName = lNameInput.value.trim();

            if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                this.showToast("Please enter a valid email address.", "error");
                emailInput.focus();
                return;
            }

            submitBtn.disabled = true;
            submitBtn.innerHTML = 'Sending...';
            submitBtn.style.opacity = '0.7';

            try {
                // Determine API BASE safely
                const API_URL = typeof API_BASE_URL !== 'undefined' ? API_BASE_URL : 'https://api.getboarded.tech';
                
                const res = await fetch(`${API_URL}/api/talent-pool/manual-invite`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        email: email,
                        first_name: fName,
                        last_name: lName,
                        organization_id: orgId,
                        api_token: token
                    })
                });

                if (res.ok) {
                    this.showToast(`Invitation sent successfully to ${email}`, "success");
                    popup.remove();
                } else {
                    const err = await res.json();
                    this.showToast(err.detail || "Failed to send invitation.", "error");
                }
            } catch (e) {
                console.error(e);
                this.showToast("Network error while sending invite.", "error");
            } finally {
                if (document.body.contains(popup)) {
                    submitBtn.disabled = false;
                    submitBtn.innerHTML = 'Send Invite';
                    submitBtn.style.opacity = '1';
                }
            }
        };

        // Render over top of everything utilizing specific shadowing and fixed placement
        Utils.applyStyles(popup, {
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: '9999999', 
            boxShadow: '0 0 0 9999px rgba(0,0,0,0.5), 0 10px 30px rgba(0,0,0,0.2)'
        });

        document.body.appendChild(popup);
    }
    previewCandidateFitment(candidate, roleData, roleDomNode, passedConfig) {
        const roleTitle = roleData.title;
        const roleId = roleData.selfId;
        const orgId = this.getActualOrgId();
        const token = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt') || "";

        const currentSelected = roleDomNode.dataset.selectedUsr ? roleDomNode.dataset.selectedUsr.split(',') : [];
        const isAlreadyAdded = currentSelected.includes(candidate.user_id || candidate.id);

        const container = Utils.createElem("div");
        Utils.applyStyles(container, {
            display: "flex", flexDirection: "column", height: "100%", width: "100%", overflow: "hidden", fontFamily: "inherit"
        });

        const headerSec = Utils.createElem("div");
        Utils.applyStyles(headerSec, {
            display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid #eee", padding: "0 5px 10px 5px", marginBottom: "5px", flexShrink: "0"
        });

        const userInfo = Utils.createElem("div");
        Utils.applyStyles(userInfo, { display: "flex", alignItems: "left", gap: "12px" });
        const img = Utils.createElem("img");
        img.src = candidate.image_url || candidate.imageUrl || "https://cdn-icons-png.flaticon.com/512/149/149071.png";
        Utils.applyStyles(img, { width: "45px", height: "45px", borderRadius: "50%", objectFit: "cover", border: "1px solid #eee" });
        const textInfo = Utils.createElem("div");
        const name = Utils.createElem(
            "h3",
            [],
            "",
            (candidate.name || (candidate.email ? candidate.email.split('@')[0] : "Candidate"))
        );

        Utils.applyStyles(name, {
            margin: "0",
            fontSize: "15px",
            fontWeight: "600",
            textAlign: "left"
        });

        const email = Utils.createElem("span", [], "", candidate.email || candidate.emailId);

        Utils.applyStyles(email, {
            color: "#888",
            fontSize: "12px",
            display: "block",
            textAlign: "left"
        });

        textInfo.append(name, email);
        userInfo.append(img, textInfo);

        const actionContainer = Utils.createElem("div");
        Utils.applyStyles(actionContainer, { display: "flex", alignItems: "center", gap: "8px" });

        const scoreBox = Utils.createElem("div");
        let rawScore = candidate.score;
        if (rawScore === undefined || rawScore === null) rawScore = candidate.matchScore;
        if (rawScore === undefined || rawScore === null) rawScore = candidate.ai_score;
        const scoreVal = rawScore ? Math.round(parseFloat(rawScore)) : 0;
        const scoreColor = scoreVal > 75 ? "#4caf50" : scoreVal >= 65 ? "#ff9800" : "#f44336";
        Utils.applyStyles(scoreBox, {
            width: "40px", height: "40px", borderRadius: "50%", background: scoreColor, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "13px", fontWeight: "bold"
        });
        scoreBox.innerText = `${scoreVal}%`;

        if (!isAlreadyAdded) {
            if (scoreVal < 65) {
                const rejectedMsg = Utils.createElem("span", [], "", "Auto-Rejected");
                Utils.applyStyles(rejectedMsg, { color: "#f44336", fontWeight: "bold", fontSize: "13px", border: "1px solid #f44336", padding: "4px 8px", borderRadius: "5px", background: "#fff5f5" });
                const moreBtn = Utils.createElem("button", [], "", "•••");
                Utils.applyStyles(moreBtn, { background: "#f0f0f0", color: "#444", border: "none", width: "32px", height: "32px", borderRadius: "4px", cursor: "pointer", fontSize: "14px", fontWeight: "bold", marginLeft: "8px", display: "flex", alignItems: "center", justifyContent: "center", position: "relative" });
                this.attachTooltip(moreBtn, "More Options");
                const dropdown = Utils.createElem("div");
                Utils.applyStyles(dropdown, { position: "absolute", top: "100%", right: "0", marginTop: "5px", background: "#fff", border: "1px solid #ddd", borderRadius: "6px", boxShadow: "0 5px 15px rgba(0,0,0,0.2)", zIndex: "10", display: "none", flexDirection: "column", minWidth: "140px", overflow: "hidden" });
                const addOpt = Utils.createElem("div", [], "", "Add to Role");
                Utils.applyStyles(addOpt, { padding: "10px", fontSize: "12px", color: "#333", cursor: "pointer", borderBottom: "1px solid #f0f0f0", fontWeight: "500", textAlign: "left" });
                addOpt.onmouseenter = () => addOpt.style.background = "#f9f9f9";
                addOpt.onmouseleave = () => addOpt.style.background = "#fff";
                addOpt.onclick = async (e) => {
                    e.stopPropagation(); addOpt.innerText = "Adding...";
                    const targetId = candidate.user_id || candidate.id;
                    const rawFit = candidate.fitment_data || candidate.fitmentData || [];
                    const finalFitmentData = rawFit.map(i => ({ key: i.key, score: parseFloat(i.score || i.value || 0), remarks: i.remarks || i.reasoning || "" }));
                    const payload = { user_id: targetId, email: candidate.email, role_id: roleId, organization_id: orgId, api_token: token, score: scoreVal, reasoning: "Manual Override (Auto-Rejected)", fitment_data: finalFitmentData, role_name: roleTitle, overwrite_existing: true };
                    try {
                        const apiRes = await fetch(`${API_BASE_URL}/api/talent-pool/manual-assign`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
                        if (apiRes.ok) {
                            document.dispatchEvent(new CustomEvent('request-talentpool-refresh'));
                            const fitmentPayload = { query: `userId=${targetId}&kvdrRoleId=${roleId}`, data: { fitmentData: finalFitmentData } };
                            await roleData.onNodeProfileUpdate(fitmentPayload);
                            // Utils.playBellSound(800, 840, 'square');
                            document.querySelector(".organiGramPopup.fitment-view")?.remove();
                            document.getElementById("back-drop-overlay").style.display = "none";
                            if (typeof isViewportActive !== 'undefined') isViewportActive.status = true;
                            const currentUsers = roleDomNode.dataset.selectedUsr ? roleDomNode.dataset.selectedUsr.split(',') : [];
                            if (!currentUsers.includes(targetId)) { currentUsers.push(targetId); roleDomNode.dataset.selectedUsr = currentUsers.join(','); }
                            let localCand = roleData.candidateList.find(c => c.id === targetId);
                            if (localCand) { localCand.fitmentData = finalFitmentData; } else { roleData.candidateList.push({ ...candidate, id: targetId, fitmentData: finalFitmentData }); }
                            const r = roleDomNode.querySelector("label>fieldset>div>span");
                            const newImg = Utils.createElem("img", ["selectedUsrImg"], `img-${targetId}`, "", { src: img.src });
                            Utils.applyStyles(newImg, { position: "relative", marginLeft: "-5px", width: "32px", height: "32px", objectFit: "cover", objectPosition: "center", border: "2px solid", borderRadius: "50%", cursor: "pointer" });
                            const hoverName = candidate.name || (candidate.email ? candidate.email.split('@')[0] : "User Profile");
                            this.attachTooltip(newImg, hoverName);
                            const expandData = { kvdrRoleId: roleId, candidateList: roleData.candidateList, kvdrOrgConfigData: roleData.data.kvdrOrgConfigData, removeProfile: (pl) => roleData.onNodeRemoveProfileClick(pl), profileData: (p) => roleData.onNodeProfileFetch(p), profileUpdate: (p) => roleData.onNodeProfileUpdate(p), roleData: (p) => roleData.onNodeFetch(p), roleUpdate: (p) => roleData.onNodeUpdate(p), displaySettings: roleData.displaySettings };
                            newImg.addEventListener("click", (ev) => { ev.preventDefault(); ev.stopPropagation(); this.expandRole(expandData, 'Talent', [targetId]); });
                            r.prepend(newImg);
                            document.querySelector(`li[data-email-key="${(candidate.email || "").toLowerCase().trim()}"]`)?.remove();
                        }
                    } catch (err) { console.error(err); addOpt.innerText = "Error"; }
                };
                const dismissOpt = Utils.createElem("div", [], "", "Dismiss Profile");
                Utils.applyStyles(dismissOpt, { padding: "10px", fontSize: "12px", color: "#f44336", cursor: "pointer", fontWeight: "500", textAlign: "left" });
                dismissOpt.onmouseenter = () => dismissOpt.style.background = "#fff5f5";
                dismissOpt.onmouseleave = () => dismissOpt.style.background = "#fff";
                dismissOpt.onclick = async (e) => {
                    e.stopPropagation(); dismissOpt.innerText = "Dismissing...";
                    const payload = { user_id: candidate.id || candidate.user_id, role_id: roleId, email: candidate.email || "", organization_id: orgId, role_name: roleTitle, send_email: true };
                    try {
                        const res = await fetch(`${API_BASE_URL}/api/talent-pool/reject-suggestion`, { method: "POST", headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify(payload) });
                        if (res.ok) {
                            document.querySelector(".organiGramPopup.fitment-view")?.remove();
                            document.getElementById("back-drop-overlay").style.display = "none";
                            if (typeof isViewportActive !== 'undefined') isViewportActive.status = true;
                            document.querySelector(`li[data-email-key="${(candidate.email || "").toLowerCase().trim()}"]`)?.remove();
                        }
                    } catch (err) { console.error(err); }
                };
                dropdown.append(addOpt, dismissOpt);
                const btnWrapper = Utils.createElem("div");
                Utils.applyStyles(btnWrapper, { position: "relative" });
                btnWrapper.append(moreBtn, dropdown);
                moreBtn.onclick = (e) => {
                    e.stopPropagation();
                    const isVisible = dropdown.style.display === "flex";
                    if (!isVisible) {
                        dropdown.style.display = "flex";
                        const closeFn = () => { dropdown.style.display = "none"; document.removeEventListener("click", closeFn); };
                        setTimeout(() => document.addEventListener("click", closeFn), 0);
                    } else { dropdown.style.display = "none"; }
                };
                actionContainer.append(scoreBox, rejectedMsg, btnWrapper);
            } else {
                const rejectBtn = Utils.createElem("button", [], "", "-");
                Utils.applyStyles(rejectBtn, { background: "#ff4444", color: "#fff", border: "none", width: "40px", height: "40px", borderRadius: "50%", cursor: "pointer", fontSize: "20px", fontWeight: "bold" });
                const addBtn = Utils.createElem("button", [], "", "+");
                Utils.applyStyles(addBtn, { background: "#F2C244", color: "#fff", border: "none", width: "40px", height: "40px", borderRadius: "50%", cursor: "pointer", fontSize: "20px", fontWeight: "bold" });
                addBtn.onclick = async () => {
                    addBtn.innerHTML = ".."; addBtn.disabled = true;
                    try {
                        const targetId = candidate.user_id || candidate.id;
                        const rawFit = candidate.fitment_data || candidate.fitmentData || [];
                        const finalFitmentData = rawFit.map(i => ({ key: i.key, score: parseFloat(i.score || i.value || 0), remarks: i.remarks || i.reasoning || "" }));
                        const payload = { user_id: targetId, email: candidate.email, role_id: roleId, organization_id: orgId, api_token: token, score: scoreVal, reasoning: candidate.reasoning || "Manual", fitment_data: finalFitmentData, role_name: roleTitle, overwrite_existing: true };
                        const apiRes = await fetch(`${API_BASE_URL}/api/talent-pool/manual-assign`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) });
                        if (apiRes.ok) {
                            document.dispatchEvent(new CustomEvent('request-talentpool-refresh'));
                            const fitmentPayload = { query: `userId=${targetId}&kvdrRoleId=${roleId}`, data: { fitmentData: finalFitmentData } };
                            await roleData.onNodeProfileUpdate(fitmentPayload);
                            // Utils.playBellSound(800, 840, 'square');
                            document.querySelector(".organiGramPopup.fitment-view")?.remove();
                            document.getElementById("back-drop-overlay").style.display = "none";
                            if (typeof isViewportActive !== 'undefined') isViewportActive.status = true;
                            const currentUsers = roleDomNode.dataset.selectedUsr ? roleDomNode.dataset.selectedUsr.split(',') : [];
                            if (!currentUsers.includes(targetId)) { currentUsers.push(targetId); roleDomNode.dataset.selectedUsr = currentUsers.join(','); }
                            let localCand = roleData.candidateList.find(c => c.id === targetId);
                            if (localCand) { localCand.fitmentData = finalFitmentData; } else { roleData.candidateList.push({ ...candidate, id: targetId, fitmentData: finalFitmentData }); }
                            const r = roleDomNode.querySelector("label>fieldset>div>span");
                            const newImg = Utils.createElem("img", ["selectedUsrImg"], `img-${targetId}`, "", { src: img.src });
                            Utils.applyStyles(newImg, { position: "relative", marginLeft: "-5px", width: "32px", height: "32px", objectFit: "cover", objectPosition: "center", border: "2px solid", borderRadius: "50%", cursor: "pointer" });
                            const expandData = { kvdrRoleId: roleId, candidateList: roleData.candidateList, kvdrOrgConfigData: roleData.data ? roleData.data.kvdrOrgConfigData : roleData.kvdrOrgConfigData, removeProfile: (pl) => roleData.onNodeRemoveProfileClick(pl), profileData: (p) => roleData.onNodeProfileFetch(p), profileUpdate: (p) => roleData.onNodeProfileUpdate(p), roleData: (p) => roleData.onNodeFetch(p), roleUpdate: (p) => roleData.onNodeUpdate(p), displaySettings: roleData.displaySettings };
                            newImg.addEventListener("click", (ev) => { ev.preventDefault(); ev.stopPropagation(); this.expandRole(expandData, 'Talent', [targetId]); });
                            r.prepend(newImg);
                        } else { alert("Failed to add."); addBtn.innerHTML = "+"; addBtn.disabled = false; }
                    } catch (err) { console.error(err); addBtn.innerHTML = "!"; addBtn.disabled = false; }
                };
                rejectBtn.onclick = async () => {
                    rejectBtn.innerHTML = ".."; rejectBtn.disabled = true;
                    const payload = { user_id: candidate.id || candidate.user_id, role_id: roleId, email: candidate.email || "", organization_id: orgId, role_name: roleTitle, send_email: true };
                    try {
                        await fetch(`${API_BASE_URL}/api/talent-pool/reject-suggestion`, { method: "POST", headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify(payload) });
                        document.querySelector(".organiGramPopup.fitment-view")?.remove();
                        document.getElementById("back-drop-overlay").style.display = "none";
                        if (typeof isViewportActive !== 'undefined') isViewportActive.status = true;
                        document.querySelector(`li[data-email-key="${(candidate.email || "").toLowerCase().trim()}"]`)?.remove();
                    } catch (err) { console.error(err); rejectBtn.innerHTML = "-"; rejectBtn.disabled = false; }
                };
                actionContainer.append(scoreBox, rejectBtn, addBtn);
            }
        } else {
            const addedLabel = Utils.createElem("span", [], "", "Added");
            Utils.applyStyles(addedLabel, { color: "#4caf50", fontWeight: "bold", fontSize: "13px" });
            actionContainer.append(scoreBox, addedLabel);
        }
        headerSec.append(userInfo, actionContainer);

        const contentArea = Utils.createElem("div");
        Utils.applyStyles(contentArea, { flex: "1", overflowY: "auto", overflowX: "hidden", display: "flex", flexDirection: "column", border: "1px solid #eee", borderRadius: "4px" });

        const tableHeader = Utils.createElem("div");
        Utils.applyStyles(tableHeader, { display: "flex", padding: "6px 0", borderBottom: "1px solid #ddd", fontWeight: "700", color: "#444", fontSize: "12px", background: "#f8f9fa" });
        tableHeader.innerHTML = `<div style="width: 260px; padding-left: 55px; text-align: left;">Attribute</div><div style="width: 60px; text-align: center;">Weight</div><div style="flex: 1; text-align: center;">Score</div>`;
        contentArea.append(tableHeader);

        const rawFitmentData = candidate.fitment_data || candidate.fitmentData || [];
        const orgConfig = passedConfig || (this.config().data ? this.config().data.kvdrOrgConfigData : {});
        const dynamicOrgConfig = this.getDynamicConfig(orgConfig);
        let fitmentStructure = dynamicOrgConfig['fitment'] || dynamicOrgConfig['fitmentData'] || dynamicOrgConfig['fitment_data'];
        
        const catColors = ["#FFFBE5", "#E5FFEA", "#E5F3FF", "#F8E5FF", "#FFE5E5"];
        let colorIdx = 0;
        
        // --- THIS IS THE FIX: Load dynamic calc types instead of a hardcoded VAL_MAP ---
        const calcTypes = dynamicOrgConfig.calculationTypes || [
            { value: 0, color: "#e0e0e0", title: "Absent" },
            { value: -1, color: "#f44336", title: "Poor" },
            { value: 1, color: "#FFC107", title: "Good" },
            { value: 1.5, color: "#4caf50", title: "Exceptional" }
        ];

        if (fitmentStructure) {
            Object.keys(fitmentStructure).forEach(groupName => {
                const attributes = fitmentStructure[groupName];
                const groupRow = Utils.createElem("div");
                Utils.applyStyles(groupRow, { display: "flex", borderBottom: "1px solid #eee", alignItems: "stretch" });
                const sidebar = Utils.createElem("div", [], "", groupName);
                Utils.applyStyles(sidebar, { backgroundColor: catColors[colorIdx % catColors.length], width: "40px", display: "flex", alignItems: "center", justifyContent: "center", writingMode: "vertical-rl", transform: "rotate(180deg)", fontWeight: "bold", fontSize: "10px", color: "#555", padding: "5px 0", borderRight: "1px solid #ddd", flexShrink: "0" });
                colorIdx++;
                const rowsContainer = Utils.createElem("div");
                Utils.applyStyles(rowsContainer, { flex: "1", display: "flex", flexDirection: "column" });
                attributes.forEach(attr => {
                    const row = Utils.createElem("div");
                    Utils.applyStyles(row, { display: "flex", alignItems: "center", padding: "4px 0", minHeight: "34px" });
                    const label = Utils.createElem("div", [], "", attr.title);
                    Utils.applyStyles(label, { width: "220px", fontSize: "12px", fontWeight: "500", color: "#333", paddingLeft: "15px", textAlign: "left" });
                    const weight = Utils.createElem("div", [], "", attr.value || "10");
                    Utils.applyStyles(weight, { width: "60px", textAlign: "center", fontSize: "12px", color: "#666" });
                    const scoreData = rawFitmentData.find(i => i.key === attr.key);
                    const aiReasoning = scoreData ? (scoreData.remarks || scoreData.reasoning) : "No AI analysis available for this attribute.";
                    let val = scoreData ? parseFloat(scoreData.score || scoreData.value) : 0;
                    if(isNaN(val)) val = 0;
                    const dotContainer = Utils.createElem("div");
                    Utils.applyStyles(dotContainer, { flex: "1", display: "flex", justifyContent: "center" });
                    const dot = Utils.createElem("div");

                    // --- THIS IS THE FIX: Use the dynamic calcTypes array to find the color ---
                    const configColorObj = calcTypes.find(type => parseFloat(type.value) === parseFloat(val));
                    const dotColor = configColorObj ? configColorObj.color : "#cbd5e1";

                    Utils.applyStyles(dot, { width: "20px", height: "20px", borderRadius: "50%", backgroundColor: dotColor, border: "1px solid rgba(0,0,0,0.1)", cursor: "help" });
                    dot.addEventListener("mouseenter", () => {
                        const tooltip = document.createElement("div");
                        tooltip.className = "fitment-ai-reasoning-tip";
                        tooltip.innerText = aiReasoning;
                        Object.assign(tooltip.style, { position: "fixed", background: "rgba(33, 33, 33, 0.95)", color: "#fff", padding: "8px 12px", borderRadius: "6px", fontSize: "12px", lineHeight: "1.4", maxWidth: "280px", zIndex: "1000000", pointerEvents: "none", boxShadow: "0 4px 15px rgba(0,0,0,0.3)", fontFamily: "inherit", whiteSpace: "normal", wordWrap: "break-word" });
                        document.body.appendChild(tooltip);
                        const rect = dot.getBoundingClientRect();
                        const tipRect = tooltip.getBoundingClientRect();
                        tooltip.style.top = (rect.top - tipRect.height - 10) + "px";
                        tooltip.style.left = (rect.left - (tipRect.width / 2) + (rect.width / 2)) + "px";
                    });
                    dot.addEventListener("mouseleave", () => { document.querySelectorAll(".fitment-ai-reasoning-tip").forEach(el => el.remove()); });
                    dotContainer.append(dot); row.append(label, weight, dotContainer); rowsContainer.append(row);
                });
                groupRow.append(sidebar, rowsContainer); contentArea.append(groupRow);
            });
        }

        container.append(headerSec, contentArea);
        const footer = Utils.createElem("div");
        Utils.applyStyles(footer, { display: "flex", justifyContent: "center", gap: "15px", padding: "10px 0", borderTop: "1px solid #eee", fontSize: "11px", fontWeight: "bold" });
        const createLegendItem = (color, text) => {
            const item = Utils.createElem("div");
            Utils.applyStyles(item, { display: "flex", alignItems: "center", gap: "5px" });
            const d = Utils.createElem("div");
            Utils.applyStyles(d, { width: "10px", height: "10px", borderRadius: "50%", background: color });
            item.append(d, document.createTextNode(text));
            return item;
        };

        // --- THIS IS THE FIX: Dynamically build the legend ---
        calcTypes.forEach(ct => {
            footer.append(createLegendItem(ct.color, `${ct.title} (${ct.value})`));
        });

        container.append(footer);

        const popupConfig = {
            headerText: this.translate('orgDashboard.userDashboard.evaluation.fitmentdetails', { roleTitle: roleTitle }),
            onCloseClick: () => { document.querySelector(".organiGramPopup.fitment-view")?.remove(); document.getElementById("back-drop-overlay").style.display = "none"; if (typeof isViewportActive !== 'undefined') isViewportActive.status = true; },
            data: container, displaySettings: { width: "900px", height: "600px" }, footer: "" 
        };
        const popup = this.createPopup(popupConfig);
        popup.classList.add("fitment-view");
        const bodyPart = popup.querySelector('.OrganiGramPopupBody');
        if(bodyPart) { bodyPart.style.height = "100%"; bodyPart.style.display = "flex"; bodyPart.style.padding = "10px 15px"; }
        const backdrop = document.getElementById("back-drop-overlay");
        backdrop.innerHTML = ""; backdrop.style.display = "flex"; backdrop.append(popup);
    }
    
    _popupUsrListSelectFunction = async (e, t) => {
        const a = event.target.closest("div#candidate-list-popup").dataset.selectedNode,
            r = document.querySelector("[data-empid='" + a + "']>label>fieldset>div>span"),
            s = document.querySelector("[data-empid='" + a + "']").dataset.selectedUsr.split(","),
            v = event.target.value,
            o = {
            kvdrRoleId: a,
            candidateList: e.candidateList,
            kvdrOrgConfigData: e.data.kvdrOrgConfigData || e.kvdrOrgConfigData,
            removeProfile: (a) => {
                e.onNodeRemoveProfileClick(a), (t.innerHTML = ""), (t.style.display = "none");
            },
            profileData: async (a) => { return e.onNodeProfileFetch(a) },
            profileUpdate:async  (t) => {return e.onNodeProfileUpdate(t)},
            roleData: async (t) => {return e.onNodeFetch(t)},
            roleUpdate: async (t) => {return e.onNodeUpdate(t)},
            displaySettings : e.displaySettings,
        },
        _selectedUser = Utils.createElem("img", ["selectedUsrImg"], "img-" + v, "",{ src : event.target.parentNode.childNodes[1].src});
        Utils.applyStyles(_selectedUser,{ 
            position: "relative", marginLeft: "-5px",
            width: "32px",
            height: "32px",
            objectFit:"cover",objectPosition:"center",
            border:"2px solid",borderRadius:"50%"
        })
        const candProfile = e.candidateList.find(c => String(c.id) === String(v)) || {};
        const hoverName = candProfile.name || candProfile.firstName || "User Profile";
        this.attachTooltip(_selectedUser, hoverName);
        if (s.includes(v)){
            if ("vibrate" in navigator) {
                navigator.vibrate(200);
            } else {
                console.log("Vibration API not supported on this device.");
            }
            Utils.playBellSound(800,840,'square');
            return;
        }  
        else {
            _selectedUser.addEventListener("click", (evt) => {
                evt.preventDefault();
                evt.stopPropagation();
                this.expandRole(o,'Talent',[v]);
            });

            r.prepend(_selectedUser);
            document.querySelector("[data-empid='" + a + "']").dataset.selectedUsr += `,${v}`;
            const l = { roleId: a, userId: v };
            
            // 1. Wait for the API to confirm the add
            await e.onNodeAddProfileClick(l);
            
            // 2. SOFT REFRESH LOGIC (FIXED)
            // We fetch latest data to keep internal state synced, but we REMOVED createKVDR()
            // to prevent wiping the DOM while the popup is still open.
            if (typeof e.onNodeFetch === 'function') {
                const query = `kvdrId=${this.config().id}`;
                const latestData = await e.onNodeFetch(query);
                
                // Silent Update: Keep data synced for future actions
                this.config().data.graphData = latestData;
            }
        }
    }
    uploadDesignations = (e, t) => {
        const a = Utils.createElem("div", ["chartCanvasLeftPanel"], "", "");
        a.style.cssText = "position:relative;height:" + t + "px;flex:0 0 200px;overflow:auto;border-right:1px solid #f1f5f9";
        const r = Utils.createElem("ul", ["desigList"], "", "<li>Upload designations</li>"),
            s = Utils.createElem("input", ["uploadDesingnation","hidden"], "upload-designation", "");
        (s.type = "file"), (s.accept = ".csv");
        const o = Utils.createElem("i", ["uploadDesingnationImg"], "upload-designation-img", "");
        o.style.cssText = "font-size:1.2em;";
        const n = Utils.createElem("label", ["uploadDesingnationLbl"], "upload-designation-lbl", "");
        (n.htmlFor = s.id),
            (n.style.cssText = "display:flex;padding:5px;font-size:2em;place-content:center;position:sticky;top:0;background:#fff;"),
            n.append(o, s),
            a.append(n, r),
            e.prepend(a),
            s.addEventListener("change", function (e) {
                e.stopPropagation();
                const t = e.target.files[0],
                    a = new FileReader();
                a.readAsText(t),
                    (a.onload = function (e) {
                        let t = JSON.parse(Utils.CSVToJSON(e.target.result));
                        if (t.length) {
                            r.innerHTML = "";
                            for (let e = 0; e < t.length - 1; e++) {
                                let a,
                                    s = t[e].Label;
                                if (((a = t[e].id ? t[e].id : "lbl_desig_" + e), "" !== s || null !== s)) {
                                    const e = Utils.createElem("li", "", a, s);
                                    (e.style.cssText = "padding:5px;cursor:pointer;border-bottom: 1px solid #f1f5f9;"), r.append(e);
                                }
                            }
                        }
                    }),
                    (a.onerror = function (e) {
                        console.log("error reading file", e);
                    });
            });
    };
    createKVDRSwitchDisplayButtons(e, t, a) {
        let r = a.type;
        const s = Utils.createElem("div", ["switchBtnBox"], "", "");
        Array.from(["F", "A", "S"]).forEach((e, t) => {
            const o = Utils.createElem("label", ["switchBtnLbl"], "", e);
            (o.htmlFor = t + "_" + e), (o.style.cssText = "display:flex;flex-flow:column;margin:auto;place-item:center;padding:5px;border-radius:3px"), r === e && (o.style.background = a.displaySettings.cardColor);
            const n = Utils.createElem("input", ["switchBtn"], t + "_" + e, e);
            (n.type = "radio"), n.setAttribute("name", "switchBtnGrp"), n.setAttribute("value", e), (n.style.display = "none"), a.type == e && n.setAttribute("checked", !0), o.append(n), s.append(o);
        });
        let o = document.querySelector("#" + e);
        o.prepend(s);
        let n = o.querySelectorAll(".switchBtn");
        Array.from(n).forEach((e) => {
            e.addEventListener("click", function () {
                (a.type = this.value), r !== a.type && (alert(a.type), (this.createKVDR = a));
            });
        });
    }
    notificationsPanel = (container) => {
        const notifyContainer = Utils.createElem('div');
        Utils.applyStyles(notifyContainer, { 
            position: 'relative', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center'
        });
    
        this.notifyBtn = Utils.createElem('button', [], '', '');
        
        const bellImg = Utils.createElem('i', [
            "vs-icon",
            "notranslate",
            "icon-scale",
            "feather",
            "icon-bell"
        ]);

        Utils.applyStyles(bellImg, {
            fontSize: '20px',        // cleaner toolbar size
            color: '#FFC107',
            display: 'block',
            pointerEvents: 'none'
        });
        Utils.applyStyles(this.notifyBtn, { 
            background: 'transparent',
            padding: '0',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            outline: 'none',
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            transition: 'background 0.2s ease, color 0.2s ease'
        });
        this.attachTooltip(this.notifyBtn, this.translate('orgDashboard.userDashboard.evaluation.notifications'));

        this.notifyBtn.title = this.translate('orgDashboard.userDashboard.evaluation.notifications');
        this.notifyBtn.addEventListener('mouseenter', () => {
        this.notifyBtn.style.background = '#FFC107';
            bellImg.style.color = '#fff';
        });

        this.notifyBtn.addEventListener('mouseleave', () => {
        this.notifyBtn.style.background = 'transparent';
            bellImg.style.color = '#FFC107';
        });
        this.notifyBtn.append(bellImg);

        this.notifyBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggleNotifications(this.notifyPanel);
        });

    
        this.badge = Utils.createElem('span', [], '', '');
        Utils.applyStyles(this.badge, {
            position: 'absolute',
            top: '8px',   // Adjusted for new size
            right: '8px', // Adjusted for new size
            background: '#FFD700',
            color: '#000',
            fontSize: '10px',
            fontWeight: 'bold',
            borderRadius: '50%',
            minWidth: '14px',
            height: '14px',
            lineHeight: '14px',
            textAlign: 'center',
            display: 'none',
            border: '1px solid #fff',
            zIndex: '10',
            boxShadow: '0 1px 2px rgba(0,0,0,0.2)'
        });
        this.notifyBtn.append(this.badge);
    
        this.notifyPanel = Utils.createElem('div', ['notifyPanel'], 'notification-panel');
        Utils.applyStyles(this.notifyPanel, { 
            position: 'absolute', border: 'none', right: '-5px', top: '45px', 
            boxShadow: '0 4px 15px rgba(0,0,0,0.15)', padding: '0', display: 'none', 
            zIndex: '9999', background: '#fff', width: '300px', maxHeight: '400px', 
            overflowY: 'auto', borderRadius: '8px'
        });
    
        notifyContainer.append(this.notifyBtn, this.notifyPanel);
        container.append(notifyContainer);
        if (!this.notifyPanel || !document.body.contains(this.notifyPanel)) {
            this.notifyPanel = Utils.createElem('div', ['notifyPanel'], 'notification-panel');
            Utils.applyStyles(this.notifyPanel, {
                position: 'fixed', // Use 'fixed' to break out of parent stacking contexts
                display: 'none',
                zIndex: '100000', // Very high z-index to appear above all other elements
                width: '300px',
                maxHeight: '400px',
                background: '#fff',
                borderRadius: '8px',
                boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
                overflowY: 'auto',
                padding: '0'
            });
            document.body.appendChild(this.notifyPanel);
        }
        
        document.addEventListener('click', (e) => {
            if (this.notifyPanel && this.notifyPanel.style.display === 'block') {
                // Hide if the click is outside both the button and the panel itself
                if (!this.notifyBtn.contains(e.target) && !this.notifyPanel.contains(e.target)) {
                    this.notifyPanel.style.display = 'none';
                }
            }
        });

        this.startAutoNotificationRefresh();
    }
    createImportResumesBtn = (container) => {
        const importBtnContainer = Utils.createElem('div');
        
        Utils.applyStyles(importBtnContainer, { 
            position: 'relative', display: 'flex', alignItems: 'center', 
            justifyContent: 'center', marginLeft: 'auto'
        });

        const importBtn = Utils.createElem('button', [], '', '');
        const uploadImg = Utils.createElem('i', ["vs-icon", "notranslate", "icon-scale", "feather", "icon-file-text"]);

        Utils.applyStyles(uploadImg, { 
            fontSize: '20px', color: '#28C76F', display: 'block', pointerEvents: 'none', lineHeight: '1'
        });

        Utils.applyStyles(importBtn, { 
            background: 'transparent', padding: '0', border: 'none', cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative',
            outline: 'none', width: '32px', height: '32px', borderRadius: '50%',
            transition: 'background 0.2s ease, color 0.2s ease'
        });

        importBtn.appendChild(uploadImg);
        this.attachTooltip(importBtn, this.translate('orgDashboard.userDashboard.evaluation.importResumes'));

        importBtn.addEventListener('mouseenter', () => {
            importBtn.style.background = '#28C76F';
            uploadImg.style.color = '#fff';
        });

        importBtn.addEventListener('mouseleave', () => {
            importBtn.style.background = 'transparent';
            uploadImg.style.color = '#28C76F';
        });

        importBtn.addEventListener('click', () => {
            const orgSlug = this.config().slug;
            if (orgSlug) localStorage.setItem(`onboardingStep_${orgSlug}`, '2');
            this.openResumeUploadModal();
        });

        // Appends only the icon button (no text anymore)
        importBtnContainer.append(importBtn);
        container.append(importBtnContainer);
    }
    // New styled Toast function matching your screenshot perfectly
    showResumeSuccessToast = (count) => {
        const existing = document.getElementById('resume-success-toast');
        if (existing) existing.remove();

        const countText = count ? `${count} ` : "";

        const toast = document.createElement('div');
        toast.id = 'resume-success-toast';
        
        // Updated inner HTML
        toast.innerHTML = `
            <div style="font-weight: 700; font-size: 15px; margin-bottom: 6px;">Import Started</div>
            <div style="font-size: 13px; line-height: 1.5; font-weight: 500;">
                ${countText}Resume(s) uploaded successfully. Processing has started in the background.
            </div>
        `;

        Object.assign(toast.style, {
            position: 'fixed',
            bottom: '30px',
            right: '30px',
            backgroundColor: '#5cb82a', // Green
            color: '#ffffff',
            padding: '16px 20px',
            borderRadius: '8px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.15)',
            zIndex: '999999',
            fontFamily: 'inherit',
            maxWidth: '350px',
            opacity: '0',
            transform: 'translateY(20px)',
            transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
        });

        document.body.appendChild(toast);

        // Slide up
        requestAnimationFrame(() => {
            toast.style.opacity = '1';
            toast.style.transform = 'translateY(0)';
        });

        // Auto remove after 6 seconds
        setTimeout(() => {
            toast.style.opacity = '0';
            toast.style.transform = 'translateY(20px)';
            setTimeout(() => toast.remove(), 400);
        }, 6000);
    }

    toggleNotifications = async () => {
        const panel = this.notifyPanel;
        if (!panel) return;

        if (panel.style.display === 'block') {
            panel.style.display = 'none';
            return;
        }
        await this.fetchLatestNotifications();
        this.loadNotifications(panel);

    const btnRect = this.notifyBtn.getBoundingClientRect();
    const panelWidth = 300;
    const sidebarWidth = 80; // adjust to your sidebar width

    let top = btnRect.bottom + 6;
    let left = btnRect.right - panelWidth;

    // Prevent popup from going under sidebar
    if (left < sidebarWidth + 10) {
        left = sidebarWidth + 10;
    }

    panel.style.position = 'fixed';
    panel.style.top = `${top}px`;
    panel.style.left = `${left}px`;
    panel.style.right = 'auto';
    panel.style.margin = '0';
    panel.style.transform = 'none';

    panel.style.display = 'block';
};

    loadNotifications = (panel) => {
        panel.innerHTML = '';
        const userId = this.config().user._id; 
        const allRequests = this.config().data.graphData || [];
        const joins = this.pendingJoins || []; // Fetched directly from SQLite
    
        let requests = [];
    
        if (this.can('addRole')) {
            // Admin Arrays
            allRequests.forEach(r => { if (r.status === 'pending') requests.push({ type: 'ROLE_CREATE', role: r }); });
            joins.forEach(p => { requests.push({ type: 'ROLE_JOIN', profile: p }); });
        } else {
            allRequests.forEach(r => { if (r.requestedBy === userId && r.status === 'rejected') requests.push({ type: 'ROLE_CREATE', role: r }); });
        }
    
        if (requests.length) {
            requests.forEach(req => {
                const noticeBody = Utils.createElem('div');
                Utils.applyStyles(noticeBody, { padding: '12px 15px', borderBottom: '1px solid #f0f0f0', cursor: 'pointer', textAlign: 'left' });
                noticeBody.addEventListener('mouseenter', () => noticeBody.style.background = "#f9f9f9");
                noticeBody.addEventListener('mouseleave', () => noticeBody.style.background = "#fff");

                let titleText = '', statusText = '', msgText = '', statusRaw = '', targetId = '';

                if (req.type === 'ROLE_CREATE') {
                    titleText = req.role.title;
                    statusRaw = req.role.status;
                    statusText = req.role.status;
                    targetId = req.role.selfId;
                    const requestedUser = this.config().candidateList.find(c => c.id === req.role.requestedBy) || {};
                    msgText = `New role requested by: ${requestedUser.name || req.role.requestedBy}`;
                } else {
                    // Pulling clean data from SQLite payload
                    titleText = req.profile.candidateName || req.profile.userId;
                    statusRaw = req.profile.status;
                    statusText = 'pending';
                    targetId = req.profile.selfId; 
                    msgText = `Requested to join: ${req.profile.roleTitle}`;
                }

                const title = Utils.createElem('div', ['notice'], '', titleText);
                Utils.applyStyles(title, { fontWeight: 'bold', fontSize: '14px', marginBottom: '4px', color: '#333' });

                const statusColor = statusRaw === 'rejected' ? '#dc3545' : '#ffc107';
                const statusBadge = Utils.createElem('span', [], '', statusText);
                Utils.applyStyles(statusBadge, { fontSize: '11px', padding: '2px 6px', borderRadius: '4px', background: statusColor, color: '#fff', marginLeft: 'auto' });
                
                const headerRow = Utils.createElem('div');
                Utils.applyStyles(headerRow, { display: 'flex', justifyContent: 'space-between', alignItems: 'center' });
                headerRow.append(title, statusBadge);

                const message = Utils.createElem('div', [], '', msgText);
                Utils.applyStyles(message, { fontSize: '12px', color: '#666', marginTop: '5px' });
    
                noticeBody.append(headerRow, message);
    
                if (this.can('addRole') && statusRaw !== 'published') {
                    const actionContainer = Utils.createElem('div');
                    Utils.applyStyles(actionContainer, { display: 'flex', gap: '10px', marginTop: '10px' });

                    const approveBtn = Utils.createElem('button', [], '', '&#10003; Approve');
                    const rejectBtn = Utils.createElem('button', [], '', '&#10060; Reject');
                    
                    const btnStyle = { flex: '1', padding: '5px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' };
                    Utils.applyStyles(approveBtn, { ...btnStyle, background: '#e6fffa', color: '#008000' });
                    Utils.applyStyles(rejectBtn, { ...btnStyle, background: '#fff5f5', color: '#cc0000' });
    
                    approveBtn.addEventListener('click', (e) => { 
                        e.stopPropagation(); 
                        if (req.type === 'ROLE_CREATE') this.handleAction(req.role, 'published');
                        else this.handleJoinAction(req.profile, 'assigned', approveBtn);
                    });
                    
                    rejectBtn.addEventListener('click', (e) => { 
                        e.stopPropagation(); 
                        if (req.type === 'ROLE_CREATE') this.handleAction(req.role, 'rejected');
                        else this.handleJoinAction(req.profile, 'rejected', rejectBtn);
                    });
    
                    actionContainer.append(approveBtn, rejectBtn);
                    noticeBody.append(actionContainer);
                }
                
                noticeBody.addEventListener('click', () => {
                   const el = document.querySelector(`[data-empid='${targetId}']`);
                   if(el) el.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
                });
    
                panel.append(noticeBody);
            });
        } else {
            const emptyContainer = Utils.createElem('div');
            Utils.applyStyles(emptyContainer, { padding: '20px', textAlign: 'center' });
            const emptyMessage = Utils.createElem('p', [], '', 'No requests available');
            Utils.applyStyles(emptyMessage, { color: '#888', fontSize: '14px', margin: 0 });
            emptyContainer.append(emptyMessage);
            panel.append(emptyContainer);
        }
    }

    handleJoinAction = async (profile, newStatus, btnElement) => {
        try {
            if (btnElement) btnElement.innerText = "...";
            const orgId = this.getActualOrgId();
            const token = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt');

            if (newStatus === 'assigned') {
                // Call the existing Manual Assign API - Updates SQLite, Mongo, and sends an email!
                const payload = {
                    user_id: profile.userId,
                    email: profile.email || "",
                    role_id: profile.selfId,
                    organization_id: orgId,
                    api_token: token,
                    score: profile.score || 85,
                    reasoning: profile.reasoning || "Self-Requested",
                    fitment_data: [],
                    role_name: profile.roleTitle
                };

                const res = await fetch(`${API_BASE_URL}/api/talent-pool/manual-assign`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload)
                });

                if (res.ok) {
                    // Update Local UI instantly
                    const domNode = document.querySelector(`[data-empid='${profile.selfId}']`);
                    if (domNode) {
                        let currentUsers = domNode.dataset.selectedUsr ? domNode.dataset.selectedUsr.split(',').filter(Boolean) : [];
                        if (!currentUsers.includes(profile.userId)) {
                            currentUsers.push(profile.userId);
                            domNode.dataset.selectedUsr = currentUsers.join(',');
                            const r = domNode.querySelector("label>fieldset>div>span");
                            if (r) {
                                const candidate = this.config().candidateList.find(c => String(c.id) === String(profile.userId)) || {};
                                const newImg = Utils.createElem("img", ["selectedUsrImg"], `img-${profile.userId}`);
                                newImg.src = candidate.imageUrl || candidate.image_url || "https://cdn-icons-png.flaticon.com/512/149/149071.png";
                                Utils.applyStyles(newImg, { position: "relative", marginLeft: "-5px", width: "32px", height: "32px", objectFit:"cover", objectPosition:"center", border:"2px solid", borderRadius:"50%", cursor: "pointer" });
                                r.prepend(newImg);
                            }
                        }
                    }
                }
            } else {
                // Call existing Reject API - Updates SQLite and sends polite rejection email!
                const payload = {
                    user_id: profile.userId,
                    email: profile.email || "",
                    role_id: profile.selfId,
                    organization_id: orgId,
                    role_name: profile.roleTitle,
                    send_email: true
                };
                await fetch(`${API_BASE_URL}/api/talent-pool/reject-suggestion`, {
                    method: "POST",
                    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                    body: JSON.stringify(payload)
                });
            }

            // Remove from local memory so it disappears instantly from the notification bell
            this.pendingJoins = this.pendingJoins.filter(p => p._id !== profile._id);
            this.refreshNotifications();
            // if (typeof Utils.playBellSound === 'function') Utils.playBellSound(800, 840, 'square');
            
        } catch (error) {
            console.error('Error updating join status:', error);
            if (btnElement) btnElement.innerText = "Error";
        }
    }
    
    handleAction = async (request, newStatus) => {
        try {
            // 🔥 First, send the status update to your server
            const param = {
                query: request.selfId,
                data: { analyzedBy: this.config().user._id, status: newStatus }
            }
            
            // FIX: onNodeUpdate already parses the JSON, so it returns the data directly.
            // It does not return a Response object, so checking .ok will fail!
            const updatedData = await this.config().onNodeUpdate(param);
    
            if (!updatedData) {
                console.error('Failed to update request status');
                return;
            }
    
            console.log('Server updated:', updatedData);
    
            const target = safeGraphData(this.config()).find(r => r._id === request._id || r.selfId === request.selfId);
            if (target) {
                target.status = newStatus;
            }

            // ---> Instantly remove the box from the screen if rejected <---
            if (newStatus === 'rejected') {
                const domNode = document.querySelector(`[data-empid='${request.selfId}']`);
                if (domNode) domNode.remove();
            } 
            // ---> Instantly remove the dimming effect if published <---
            else if (newStatus === 'published') {
                const domNode = document.querySelector(`[data-empid='${request.selfId}']`);
                if (domNode) {
                    const label = domNode.querySelector('.emptitle');
                    if (label) label.style.opacity = '1';
                    
                    const card = domNode.querySelector('.userCard');
                    if (card) {
                        card.style.cursor = 'default';
                        card.classList.add('node-hover-target');
                    }
                }
            }

            // 🔁 Refresh the panel and badge
            this.refreshNotifications();

        } catch (error) {
            console.error('Error updating status:', error);
        }
    }
    
    refreshNotifications = () => {
        this.updateNotificationBadge();
        if (this.notifyPanel.style.display === 'block') {
            this.loadNotifications(this.notifyPanel);
        }
    }
    
    updateNotificationBadge = () => {
        const userId = this.config().user._id;
        const allRequests = safeGraphData(this.config());
        const joins = this.pendingJoins || [];
    
        let count = 0;
        if (this.can('addRole')) {
            // Admin: Count pending roles + pending user joins
            count += allRequests.filter(r => r && r.status === 'pending').length;
            count += joins.length;
        } else {
            // User: Count rejections
            count += allRequests.filter(r => r && r.requestedBy === userId && r.status === 'rejected').length;
        }
    
        if (count > 0) {
            this.badge.innerText = count;
            this.badge.style.display = 'block';
        } else {
            this.badge.innerText = '';
            this.badge.style.display = 'none';
        }
    }
    
    startAutoNotificationRefresh = async () => {
        try {
            await this.fetchLatestNotifications();
            this.updateNotificationBadge(); // Immediately reflect the new count on the UI
        } catch (err) {
            console.warn("Manual refresh failed:", err);
        }
    }
    
    fetchLatestNotifications = async () => {
        if (typeof this.config().onNodeFetch === 'function') {
            const query = `kvdrId=${this.config().id}`;
            const latestData = await this.config().onNodeFetch(query);
            this.config().data.graphData = latestData;
        }

        // NEW: Fetch pending joins directly from Python (Bypasses Node API limitations)
        try {
            const orgId = this.getActualOrgId();
            const token = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt');
            const res = await fetch(`${API_BASE_URL}/api/organization/${orgId}/pending-joins`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                const json = await res.json();
                this.pendingJoins = json.data || [];
            }
        } catch (err) {
            console.warn("Could not fetch pending joins", err);
            this.pendingJoins = [];
        }
    }
    createPopup(e) {
        // Fix: Safely check if event exists before calling preventDefault
        if (typeof event !== 'undefined' && event && event.preventDefault) {
            event.preventDefault();
            event.stopPropagation();
        }
        isViewportActive.status = false;
        
        const popupContainer = Utils.createElem("div", ["candidateListPopUp", "organiGramPopup"], "candidate-list-popup", "");
        popupContainer.addEventListener("click", (evt) => { evt.stopPropagation(); });
        
        const settings = e.displaySettings || {};

        Utils.applyStyles(popupContainer, {
            display: "flex", flexFlow: "column", margin: "auto", borderRadius: "12px", 
            boxShadow: "0 10px 30px rgba(0,0,0,0.2)", overflow: "hidden", 
            border: "1px solid #E5E7EB", backgroundColor: "#fff",
            width: settings.width || "700px", 
            height: settings.height || 'auto',
            maxHeight: "95vh", maxWidth: "95vw"
        });
    
        const header = Utils.createElem("div", ["OrganiGramPopupHeader"], "OrganiGramPopupHeader");
        Utils.applyStyles(header, {
            padding: "12px 20px", background: "#FFF", borderBottom: "1px solid #E5E7EB",
            position: "relative", textAlign: "left", width: "100%", display: "flex",
            alignItems: "center", justifyContent: "space-between", flexShrink: "0",
            height: "60px", boxSizing: "border-box"
        });

        const headerTitle = Utils.createElem("span", ["headerTitle"], "", e.headerText);
        Utils.applyStyles(headerTitle, { fontSize: "1.15rem", fontWeight: "600", color: "#111827" });
        
        const headerLeft = Utils.createElem("div", ["headerLeft"]);
        Utils.applyStyles(headerLeft, { display: "flex", alignItems: "center", gap: "10px", flex: "1" });
        headerLeft.append(e.headerLeftControlls ? e.headerLeftControlls : headerTitle);

        const headerRight = Utils.createElem("div", ["headerRight"]);
        Utils.applyStyles(headerRight, { display: "flex", alignItems: "center", gap: "10px" });

        const closeButton = Utils.createElem("i", ["popupShutDownBtn", "vs-icon", "notranslate", "icon-scale", "feather", "icon-x"], "popup-shut-down-btn", "");
        Utils.applyStyles(closeButton, { fontSize: "24px", color: "#6b7287", cursor: "pointer", opacity: '0.7', marginLeft: "5px" });
        closeButton.addEventListener("click", e.onCloseClick);

        headerRight.append(e.headerRightControlls ? e.headerRightControlls : '', closeButton);
        header.append(headerLeft, headerRight);
        
        const body = Utils.createElem("div", ["OrganiGramPopupBody"], "organigram-popup-body", "");
        const bodyStyles = { position: "relative", padding: "10px 20px", background: "#fff", width : "100%", overflowX: "hidden", boxSizing: "border-box" };

        if (settings.height && settings.height !== 'auto') {
            bodyStyles.flex = '1';
            bodyStyles.overflowY = 'auto';
        } else {
            bodyStyles.display = 'flex';
            bodyStyles.flex = '1';
        }
        Utils.applyStyles(body, bodyStyles);
        body.append(e.data);
    
        if (e.footer && (typeof e.footer === 'object' || (typeof e.footer === 'string' && e.footer.trim() !== ''))) {
            const footer = Utils.createElem("div", ["OrganiGramPopupFooter"], "organigram-popup-footer", "");
            Utils.applyStyles(footer, { padding: "12px 20px", background: "#F9FAFB", borderTop: "1px solid #E5E7EB", display: "flex", justifyContent: "flex-end", width: "100%", flexShrink: "0", boxSizing: "border-box" });
            footer.append(e.footer);
            popupContainer.append(header, body, footer);
        } else {
            popupContainer.append(header, body);
        }
    
        return popupContainer;
    }
    
    render() {
        const e = this.config(),
        t = this.chart;            
        return e.data && 0 != e.data.length
            ? (e.container && ("KVDR" === t ? this.createKVDR(e) : "TEAM" === t && this.createChartGroupBy(e)), this)
            : (e.container && ("KVDR" === t ? this.createKVDR(e) : "TEAM" === t && (document.querySelector("#" + e.container).innerHTML = "There is nothing to show. TO create chart provide data.")), this);
    }
}